import axios from 'axios'
///import g25worker from '@/web-worker/g25-worker'
import * as markerjs2 from '@/plugins/markerjs2';
markerjs2.Activator.addKey('MJS2-P186-M739-3506');
import {
    HighlightEllipseMarker
} from "@/components/ellipsehighlighter";
import debounce from "lodash.debounce";
import {
    EllipseMarker2
} from "@/components/ellipse";
import {
    analyzeResults
} from '@/components/methods/sharedMethods.js'
const Social = () => import("@/components/Social.vue");
import copy from 'copy-html-to-clipboard';
import Table from 'table-builder'
import * as turf from '@turf/helpers'
import centerMean from '@turf/center-mean';
import tablecss from '../table.js'
import TransitionExpand from '../components/TransitionExpand.vue';
import VueApexCharts from 'vue-apexcharts'
import VuejsHeatmap from 'vuejs-heatmap'
import ECharts from 'vue-echarts'
const SamplesModal = () => import('../components/modals/dataSamples.vue')
const CalcSamplesModal = () => import('../components/modals/calcSamples.vue')
const CalcModal = () => import('../components/modals/calculator.vue')
const CheckFitsModal = () => import('../components/modals/CheckFitsModal.vue')
const OraclesModal = () => import('../components/modals/OraclesModal.vue')
const EditSamplesModal = () => import('../components/modals/EditSamplesModal.vue')
import Color from 'color';
import {
    useWebWorkerFn
} from '@vueuse/core'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/effectScatter'
import 'echarts/lib/chart/map'
import 'echarts/lib/chart/sunburst'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/geo'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/dataset'
import {
    Checkbox,
    Collapse,
    CollapseItem,
    Button,
    Tabs,
    TabPane
} from '@/components'
import {
    Switch
} from 'element-ui'
import invokeAnalyzeResults from "@/graphql/invokeAnalyzeResults"
import getResultQuery from "@/graphql/getResultQuery"
import getResultJSQuery from "@/graphql/getResultJSQuery"
import getCalcQuery from "@/graphql/getCalcQuery"
import getFitsQuery from "@/graphql/getFitsQuery"
import getGenoplotsamples from "@/graphql/getGenoplotsamples"
import getFilteredGenoplotsamples from "@/graphql/getFilteredGenoplotsamples"
import getCalcResultQuery from "@/graphql/getCalcResultQuery"
import getCalcRResultQuery from "@/graphql/getCalcRResultQuery"
import getFitQuery from "@/graphql/getFitQuery"
import getShareQuery from "@/graphql/getShareQuery"
import getSamplesQuery from "@/graphql/getSamplesQuery"
import getS3SignatureQuery from "@/graphql/getS3SignatureQuery"
import getFilebaseSignatureQuery from "@/graphql/getFilebaseSignatureQuery"
import getOraclesQuery from "@/graphql/getOraclesQuery"
import getFreeFormOraclesQuery from "@/graphql/getFreeFormOraclesQuery"
import invokeApiQuery from "@/graphql/invokeApiQuery"
import invokeApiJSQuery from "@/graphql/invokeApiJSQuery"
import invokeOptiFitQuery from "@/graphql/invokeOptiFitQuery"
import onPublishResultSub from "@/graphql/onPublishResult"
import getOwnerSamplesQuery from "@/graphql/getOwnerSamplesQuery"
import queryByOwnerType from "@/graphql/queryByOwnerType"
import getOwnerCalcsQuery from "@/graphql/getOwnerCalcsQuery"
import getImageJsonQuery from "@/graphql/getImageJsonQuery"
import invokeSimQuery from "@/graphql/invokeSimQuery"
import Vue from "vue";
import {
    ProgressPlugin
} from 'bootstrap-vue'
Vue.use(ProgressPlugin)
import {
    dragscroll
} from 'vue-dragscroll'
import {
    mapState
} from 'vuex'
import legend from "../components/legend"
import LZString from 'lz-string'
import {
    AgGridVue
} from "../plugins/ag-grid-vue";
import domtoimage from 'dom-to-image-improved';
import rightpanel from '../components/RightPanel/';
import {
    saveAs
} from 'file-saver';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import gql from 'graphql-tag';
import map from '@/data/worldmap';
import worldMap from '@/data/world.json'

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
String.prototype.getHashCode = function() {
    var hash = 0;
    //let colors =  ["#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#abdda4", "#66c2a5", "#3288bd"]
    let colors = ["#ffa600", "#d53e4f", "#f46d43", "#66c2a5", "#3288bd", "#ef5675"]
    //let colors = ['#003f5c','#2f4b7c','#665191','#a05195','#d45087','#f95d6a','#ff7c43','#ffa600']
    //let colors = ["#d53e4f","#3288bd",'#d45087','#f95d6a','#ff7c43','#ffa600']
    if (this.length == 0) return hash;
    for (var i = 0; i < this.length; i++) {
        hash = this.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash; // Convert to 32bit integer
    }
    return colors[Math.abs(hash % 5)]
};
Number.prototype.intToHSL = function() {
    var shortened = this % 360;
    return "hsl(" + shortened + ",100%,20%)";
};
String.prototype.getHSL = function() {
    var hex = this;
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    let r = parseInt(result[1], 16);
    let g = parseInt(result[2], 16);
    let b = parseInt(result[3], 16);
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b),
        min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) {
        h = s = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    var HSL = new Object();
    HSL['h'] = Math.round(h * 360);
    HSL['s'] = Math.round(s * 100);
    HSL['l'] = Math.round(l * 100);
    return HSL;
}

function darkenColor(color, factor) {
    const rgba = color.match(/rgba?\((\d+), (\d+), (\d+),? ?([\d\.]+)?\)/);
    if (!rgba) return color;

    let r = parseInt(rgba[1], 10);
    let g = parseInt(rgba[2], 10);
    let b = parseInt(rgba[3], 10);
    let a = rgba[4] !== undefined ? parseFloat(rgba[4]) : 1; // Default alpha to 1 if it's missing

    r = Math.max(0, r - factor);
    g = Math.max(0, g - factor);
    b = Math.max(0, b - factor);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}

function invertColor(hex) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    // invert color components
    var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
        g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
        b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
    // pad each with zeros and return
    return '#' + padZero(r) + padZero(g) + padZero(b);
}


function padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
}

function consoleWithNoSource(...params) {
    setTimeout(console.log.bind(console, ...params));
}

ECharts.registerMap('world', worldMap)

let mapMax = -Infinity;
let mapMin = Infinity;
Vue.component('apexchart', VueApexCharts)
Vue.component('v-chart', ECharts)
Vue.component('vuejs-heatmap', VuejsHeatmap)
export default {
    name: 'app-page',
    bodyClass: 'app-page,nmonte-container,g25',
    computed: {
        ...mapState({
            onLine: 'onLine',
            geo: 'geo',
            alias: 'alias',
            topClass: 'topClass',
            isAdmin: 'isAdmin',
            fadeIn: 'fadeIn',
            activePane: 'activePane',
            primaryT: 'primaryTabs',
            usergroups: 'usergroups',
            secondaryT: 'secondaryTabs',
            lastQuery: 'lastQuery',
            firstRun: 'g25firstRun',
            subs: 'subscription',
            themes: 'themes',
            loading: 'g25chartLoading',
            statusMessage: 'statusMessage',
            running: 'spinner',
            series: 'g25chartSeries',
            showGrid: 'showGrid',
            chartJSON: 'g25chartJSON',
            heatmapJSON: 'g25heatmapJSON',
            chartKey: 'g25chartKey',
            calcComponents: 'g25calcComponents',
            calcSeries: 'g25calcSeries',
            calcColors: 'g25calcColors',
            calcSampleComponents: 'g25calcSampleComponents',
            calcSampleSeries: 'g25calcSampleSeries',
            calcSeries: 'g25calcSeries',
            slider: 'slider',
            credits: 'credits',
            testData: 'testData',
            lastSort: 'lastSort',
            switches: 'switches',
            subId: 'subId',
            env: 'env',
        }),
        newUser() {
            let created = this.subs && this.subs.created ? this.subs.created : 0
            let now = Date.now()
            let days = Math.ceil((now - (created * 1000)) / 86400000)
            let name = this.user.username + ':' + 'runmonte'
            name = localStorage.getItem(name)
            return !name && days < 7 ? true : false
        },
        isCustom() {
            let isCustom = this.customSampleCount > 0 && this.currentIndex >= 0 && this.chartJSON && this.chartJSON[this.currentIndex].coords && this.chartJSON[this.currentIndex].profile && this.chartJSON[this.currentIndex].profile.substr(0, 7) == 'Custom:' ? true : false
            console.log('isCustom', isCustom);
            return isCustom
        },
        ahistory: {
            get: function() {
                return this.$store.getters.get(`ahistory`) ? true : false
            },
            set: function(value) {
                this.$store.commit('change', {
                    ahistory: value
                })
            },
        },
        screenshot: {
            get: function() {
                return this.$store.getters.get(`screenshot`) ? true : false
            },
            set: function(value) {
                this.$store.commit('change', {
                    screenshot: value
                })
            },
        },
        calcName() {
            let calc = this.groupArray && this.groupArray[0] && this.groupArray[0].label && this.groupArray[0].calculator ? this.groupArray[0].label : false
            return calc ? decodeURI(calc).replace(/\(.*/g, '') + ' Calculator' : ''
        },
        colorByHashCode(evt) {
            let name = this.groupArray[0].user ? this.groupArray[0].user : this.groupArray[0].alias ? this.groupArray[0].alias : this.groupArray[0].group
            if (name) {
                let hex = name.getHashCode()
                let hsl = hex.getHSL()
                let brightness = this.theme ? 30 : 20
                hsl = `hsl(${hsl.h},${hsl.s}%, ${hsl.l - brightness}%)`
                return this.theme ? `border: 3px solid white; background-color: ${hsl};` : `background-color: ${hsl};`
            } else {
                return ''
            }
        },
        sampleArray: {
            get() {
                return JSON.parse(JSON.stringify(this.$store.getters.get('sampleArray')))
            },
            set(value) {
                this.$store.commit('change', {
                    sampleArray: value
                })
            }
        },
        nocredits() {
            let credits = this.credits || 0
            return credits <= 0 ? true : false
        },
        validQS() {
            return this.validateCSV()
        },
        themevalue: function() {
            return this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
        },
        mapHeight() {
            let height = this.$refs['mapwrapper'] && this.$refs['mapwrapper'].$el ? this.$refs['mapwrapper'].$el.clientHeight : 0
            return height
        },
        categories: {
            get() {
                let cats = this.$store.getters.get(`g25chartCategories`)
                //console.log('categories', cats);
                return cats
            },
            set(value) {
                this.$store.commit('change', {
                    g25chartCategories: value
                })
            }
        },
        compAlias() {
            let w = this;
            let comps = w.components;
            let aliased = []
            if (comps && w.publicSamples) {
                for (let i = 0; i < comps.length; i++) {
                    let comp = w.components[i]
                    let group = w.publicSamples.find(x => x.group == comp.split(" • ")[0])
                    if (group && group.samples && group.samples[0] && !group.samples[0].alias) {
                        if (group.custom && comp.split(" • ").length > 1) {
                            aliased.push(comp.split(" • ")[1].replace(/_/g, " ").replace(/-/, ' '))
                        } else if (comp.split(" • ").length > 1) {

                            let sample = comp.split(" • ")[1] == 'Average' ? 'AVG' : comp.split(" • ")[1] == 'Median' ? 'MED' : comp.split(" • ")[1]
                            aliased.push(`${comp.split(" • ")[0]} (${sample})`.replace(/_/g, " ").replace(/-/, ' '))
                        } else {
                            aliased.push(comp.replace(/_/g, " ").replace(/-/, ' '))
                        }
                    } else {
                        if (comp.split(" • ").length > 1) {
                            aliased.push(comp.split(" • ")[1].replace(/_/g, " ").replace(/-/, ' '))
                        } else {
                            aliased.push(comp.replace(/_/g, " ").replace(/-/, ' '))
                        }
                    }
                }
            }
            return aliased;
        },
        frameClass() {
            let mainclass = this.src && (this.src.includes('discussions.genoplot') || this.src.includes('devdiscuss.genoplot')) ? 'embedded' : 'normal'
            let visible = this.frameReady ? 'showframe' : 'hideframe'
            console.log('frameClass', this.frameReady, visible)
            return visible + ' ' + mainclass
        },
        screenClass() {
            return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document) || window.navigator && window.navigator.userAgentData && window.navigator.userAgentData.mobile || window.innerWidth <= 800 ? 'isMobile' : 'isDesktop'
        },
        calcGroupOptions() {
            if (!this.switches.calculator || !this.groupArray[0]) {
                return []
            } else if (this.switches.calculator && this.groupArray[0] && this.groupArray[0].calculator && this.groupArray[0].components && Array.isArray(this.groupArray[0].components)) {
                let groups = []
                this.groupArray[0].components.forEach(x => {
                    x.groups.forEach(y => {
                        y = y.split('|').length > 1 ? y.split('|')[0] : y.split(':').length > 1 ? y.split(':')[0] : y
                        if (!groups.find(z => z.label == y.replace(/_/g, ' '))) {
                            if (y != this.groupArray[0].user) {
                                groups.push({
                                    name: y,
                                    label: y.replace(/_/g, ' ')
                                })
                            }
                        }
                    })
                })
                return groups.sort((a, b) => a.label > b.label ? 1 : a.label < b.label ? -1 : 0)
            } else {
                return []
            }
        },
        getGroupOrOptions() {
            let w = this;
            const groups = []
            const groupOptions = [];

            function getGroup(key, value) {
                return w.sampleOptions.find((option) =>
                    option.samples.some((sample) => sample[key] === value)
                );
            }
            const grouped = {}
            this.sampleArray.forEach((option) => {
                const grouplabel = option.customgroup ? option.customgroup : option.group
                let group;
                if (grouped[grouplabel]) {
                    group = grouped[grouplabel]
                } else {
                    group = option.customgroup ? getGroup("customgroup", option.customgroup) : getGroup("group", option.group);
                }
                if (group) group.group = option.customgroup ? option.customgroup : group.group
                grouped[grouplabel] = group
                let custom = option.customgroup ? true : false
                if (group && !groups.includes(grouplabel) && this.isAllOptionsSelectedInGroup(group, custom)) {
                    if (!groups.includes(grouplabel)) {
                        groups.push(grouplabel);
                        let label = option.customgroup ? grouplabel.replace(/_/g, ' ') + ' [ ' + option.group + ' ]' : grouplabel.replace(/_/g, ' ')
                        label = label + ` (${group.samples.length})`
                        groupOptions.push({
                            label: label,
                            custom: custom,
                            option: group,
                            group: true
                        });
                    }
                } else {
                    if (group && group.group && !groups.includes(grouplabel)) {
                        groupOptions.push({
                            label: this.customSample(option),
                            option,
                            group: false,
                        });
                    }
                }
            });
            return groupOptions;
        },
        filteredOptions: {
            get() {
                if (this.filteredSamples.length == 1 && this.filteredSamples[0].empty) {
                    return []
                } else if (this.filteredSamples.length == 0) {
                    return this.sampleOptions.slice(0, 1000)
                }
                return this.filteredSamples.slice(0, 1000)
            },
            set(value) {
                this.filteredSamples = value;
            }
        },
        filteredGroupOptions: {
            get() {
                if (this.filteredGroupSamples.length == 1 && this.filteredGroupSamples[0].empty) {
                    return []
                } else if (this.filteredGroupSamples.length == 0) {
                    return this.groupOptions.slice(0, 1000)
                }
                return this.filteredGroupSamples.slice(0, 1000)
            },
            set(value) {
                this.filteredGroupSamples = value;
            }
        },
        user: {
            get: function() {
                let user = this.$store.getters.get(`user`)
                //let lastinit = this.initiated && this.initiated > 0 ? this.initiated : 0
                //console.log('lastinit', lastinit, (Date.now() - lastinit));
                //if (user && user.username && ((Date.now() - lastinit) > 10000) ) this.init()
                return user
            },
            set: function(value) {
                this.$store.commit('change', {
                    user: value
                })
            },
        },
        groupedSamples: {
            get: function() {
                return this.$store.getters.get(`groupedSamples`)
            },
            set: function(value) {
                this.$store.commit('change', {
                    groupedSamples: value
                })
            },
        },
        csv: {
            get: function() {
                return this.$store.getters.get(`customCSV`)
            },
            set: function(value) {
                this.$store.commit('change', {
                    customCSV: value
                })
            },
        },
        isMobile: function() {
            return this.$isMobile ? true : false;
        },
        showSubtract: function() {
            this.collapse;
            this.collapseSubtract = this.calcGroupsArray && this.calcGroupsArray.length ? true : false
            return this.calcGroupsArray && this.calcGroupsArray.length > 0 ? 0 : -1
        },
        isPhone: function() {
            let ios = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
            let mobile = navigator.userAgentData && navigator.userAgentData.mobile ? true : false
            return (ios || mobile) ? true : false
        },
        downloadable() {
            let downloadable = (!this.switches.calculator || this.isAdmin) ? true : this.groupArray && this.groupArray[0] && this.groupArray[0].user == this.user.username ? true : this.groupArray && this.groupArray[0] && this.groupArray[0].download ? true : false
            downloadable = this.groupArray && this.groupArray[0] && downloadable ? true : false
            return downloadable
        },
        downloadIcon() {
            let length = this.sampleArray.length == 2 ? this.customSample(this.sampleArray[0]).length + this.customSample(this.sampleArray[1]).length : this.sampleArray.length == 1 ? 1 : 100
            return length
        },
        src: {
            get: function() {
                let src = this.$store.getters.get(`sharedurl`) ? this.$store.getters.get(`sharedurl`).split('||')[0] : ''
                let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
                let genoTheme = this.getInitialColorMode(value)
                if (this.$store.getters.get(`sharedurl`) && this.$store.getters.get(`sharedurl`).split('||').length > 1 && src) src = src.replace(/\#.*/, '') + (genoTheme == 'dark' ? '#2' : '#1')
                return src ? src : false
            },
            set: function(value) {
                this.$store.commit('change', {
                    sharedurl: value
                })
            },
        },
        sampleArray2: {
            get: function() {
                let src = this.$store.getters.get(`sampleArray`) ? this.$store.getters.get(`sampleArray`) : []
                if (src == []) this.chartReady = false;
                return src
            },
            set: function(value) {
                this.$store.commit('change', {
                    sampleArray: value
                })
            },
        },
        calcGroupsArray: {
            get: function() {
                return this.$store.getters.get(`calcGroupsArray`)
            },
            set: function(value) {
                this.$store.commit('change', {
                    calcGroupsArray: value
                })
            },
        },
        groupArray2: {
            get: function() {
                let src = this.$store.getters.get(`groupArray`) ? this.$store.getters.get(`groupArray`) : []
                if (src == []) this.chartReady = false;
                return src
            },
            set: function(value) {
                this.$store.commit('change', {
                    groupArray: value
                })
            },
        },
        totalSamples: function() {
            let samples = this.groupArray[0] && this.groupArray[0].calculator && this.groupArray[0].samples ? this.groupArray[0].samples : this.groupArray.length > 1 ? this.groupArray.reduce((a, b) => (a.samples ? a.samples : parseInt(a) ? parseInt(a) : 1) + (b.samples ? b.samples : 1)) : this.groupArray[0] ? (this.groupArray[0].samples ? this.groupArray[0].samples : 1) : 0
            samples = samples + this.sampleArray.length
            return samples
        },
        showshare: {
            set: function(value) {
                this.$store.commit('change', {
                    showshare: value
                })
            },
            get: function() {
                let showshare = this.$store.getters.get('showshare')
                this.shareTitle = false
                this.frameDisplay = 'none'
                let user = this.user && this.user.username ? this.user.username : ''
                let src = this.$store.getters.get(`sharedurl`) ? this.$store.getters.get(`sharedurl`).split('||')[0] : ''
                if (this.$store.getters.get(`sharedurl`) && this.$store.getters.get(`sharedurl`).split('||').length > 1) this.shareTitle = this.$store.getters.get(`sharedurl`).split('||')[1]
                if (showshare) {
                    setTimeout(() => {
                        let evt = 'rightpanel';
                        this.$root.$emit(evt, 'close');
                    }, 0)
                }
                return this.$store.getters.get('showshare') ? this.$store.getters.get('showshare') : false
            },
        },
        jsCalc: function() {
            let w = this;
            let calc = w.switches.calculator
            let js = w.switches.lite
            return js || calc ? true : false
        },
        newColors: function() {
            let w = this;
            /*
                    json.forEach(function(y, t) {
                        var value = y.result[component] ? y.result[component] : 0;
                        if (y.result[component] && t === w.currentIndex) {
                            newcomponents.push(component)
                            let index = components.findIndex(x => x === component)
                            newcolors.push(w.colors[index % w.colors.length])
                        }
                        data.push(value)
                    });
            */
            let colors = []
            w.components.map((x, i) => {
                if (w.chartJSON[w.currentChartIndex] && w.chartJSON[w.currentChartIndex].result && w.chartJSON[w.currentChartIndex].result[x]) {
                    colors.push(w.colors[i % w.colors.length])
                }
            })
            return colors;

        },
        userCalcs: {
            set: function(value) {
                this.$store.commit('change', {
                    userCalcs: value
                })
            },
            get: function() {
                return this.$store.getters.get('userCalcs')
            },
        },
        proxyUser: {
            get: function() {
                if (this.isAdmin && this.user.username && this.user.username == 'Genoplot' && this.$store.getters.get('proxyUser') != this.priorProxy) {
                    this.priorProxy = this.$store.getters.get('proxyUser')
                    this.init()
                }
                return 'proxy'
            },
            set: function(value) {
                this.priorProxy = this.$store.getters.get('proxyUser')
                this.$store.commit('change', {
                    proxyUser: value
                })
            }
        },
        markup: {
            set: function(value) {
                this.$store.commit('change', {
                    markup: value
                })
            },
            get: function() {
                return this.$store.getters.get('markup')
            },
        },
        editedImageUrl: {
            set: function(value) {
                this.$store.commit('change', {
                    editedImageUrl: value
                })
            },
            get: function() {
                return this.$store.getters.get('editedImageUrl')
            },
        },
        editedImageUrl2: {
            set: function(value) {
                this.$store.commit('change', {
                    editedImageUrl2: value
                })
            },
            get: function() {
                return this.$store.getters.get('editedImageUrl2')
            },
        },
        editingImage: {
            set: function(value) {
                this.$store.commit('change', {
                    editingImage: value
                })
            },
            get: function() {
                return this.$store.getters.get('editingImage')
            },
        },
        g25Rerun: {
            set: function(value) {
                this.$store.commit('change', {
                    g25Rerun: value
                })
            },
            get: function() {
                return this.$store.getters.get('g25Rerun')
            },
        },
        g25customsamples: {
            set: function(value) {
                this.$store.commit('change', {
                    g25customsamples: value
                })
            },
            get: function() {
                return this.$store.getters.get('g25customsamples')
            },
        },
        colors: {
            set: function(value) {
                this.$store.commit('change', {
                    g25chartColors: value
                })
            },
            get: function() {
                let w = this;
                let colors = [...w.$store.getters.get('g25chartColors')]
                return colors;
            },
        },
        heatmapColors: function() {
            let w = this;
            let colors = JSON.parse(JSON.stringify(w.$store.getters.get('g25chartColors')))
            if (colors) {
                let color = colors[0]
                let luminance = (Color(color).luminosity())
                if (luminance > 0.2) color = Color(color).darken(0.3).hex();
                if (w.theme) {
                    color = Color(color).saturate(0.2).hex()
                } else {
                    color = Color(color).saturate(0.1).hex()
                }
                colors[1] = color;
            } else {
                colors = []
            }
            return colors;
        },
        piechartOptions2: function() {
            let w = this;
            return {
                title: {
                    text: '',
                    subtext: '',
                    left: 'center',
                },
                label: {
                    position: 'outer',
                    fontSize: 13,
                    fontWeight: 700,
                    formatter: params => params.value < 2 ? params.name.replace(/_/, ' ').replace(/-/, ' ') : params.value + ' %  ' + params.name.replace(/_/, ' ').replace(/-/, ' '),
                },
                color: ["#1f78b4", "#a6cee3", "#33a02c", "#b2df8a", "#e31a1c", "#fb9a99", "#ff7f00", "#fdbf6f", "#6a3d9a", "#cab2d6", "#b15928", "#ffff99"],
                tooltip: {
                    trigger: 'item',
                    formatter: params => `&nbsp;&nbsp;${params.value}&nbsp;%&nbsp;&nbsp;${params.name.replace(/_/, ' ').replace(/-/,' ')}&nbsp;&nbsp;&nbsp`,
                },
                toolbox: {
                    show: false,
                    feature: {
                        mark: {
                            show: false
                        },
                        dataView: {
                            show: true,
                            readOnly: false
                        },
                        magicType: {
                            show: false,
                            type: ['funnel']
                        },
                        restore: {
                            show: true
                        },
                        saveAsImage: {
                            show: true
                        }
                    }
                },
                series: [{
                    name: '',
                    type: 'pie',
                    height: 520,
                    radius: w.$isMobile ? [45, 90] : [50, 200],
                    top: 30,
                    bottom: 40,
                    center: ['50%', '50%'],
                    stillShowZeroSum: false,
                    selectedOffset: 0,
                    avoidLabelOverlap: true,
                    startAngle: 45,
                    roseType: 'radial',
                    label: {
                        show: true,
                        alignTo: 'none',
                        //alignTo: 'edge',
                    },
                    emphasis: {
                        label: {
                            show: true,
                            position: 'center'
                        }
                    },
                    //data: w.pieSeries
                    data: w.piechartSeries,
                }]
            }
        },
        piechartOptions: function() {
            let w = this;
            return {
                title: {
                    text: '',
                    subtext: '',
                    left: 'center',
                    textStyle: {
                        color: w.theme ? 'white' : 'black'
                    }
                },
                label: {
                    position: 'outer',
                    fontSize: 13,
                    fontWeight: 700,
                    formatter: params => params.name.replace(/_/, ' ').replace(/-/, ' ') + ' ' + params.value + '%',
                    color: w.theme ? 'silver' : 'gray'
                },
                color: w.newColors,
                tooltip: {
                    trigger: 'item',
                    formatter: params => `&nbsp;&nbsp;${params.value}&nbsp;%&nbsp;&nbsp;${params.name.replace(/_/, ' ').replace(/-/,' ')}&nbsp;&nbsp;&nbsp`,
                },
                toolbox: {
                    show: false,
                    feature: {
                        mark: {
                            show: false
                        },
                        dataView: {
                            show: true,
                            readOnly: false
                        },
                        magicType: {
                            show: false,
                            type: ['funnel']
                        },
                        restore: {
                            show: true
                        },
                        saveAsImage: {
                            show: true
                        }
                    }
                },
                series: [{
                    highlightPolicy: 'self',
                    type: 'pie',
                    startAngle: 90,
                    roseType: 'radial',
                    data: w.piechartSeries,
                    //radius: [45, 170],
                    radius: w.$isMobile ? [45, 90] : [45, 170],
                }]
            }
        },
        heatmapOptions: function() {
            let w = this;
            let colors = w.chartColors[w.slider.colors.value - 1]
            w.priorSelection = false;
            return {
                chart: {
                    type: 'heatmap',
                    //events: { click: function( a, b, c ) { console.log(a,b,c)} },
                    width: '100%',
                    toolbar: {
                        show: false
                    },
                    offsetX: 10,
                    offsetY: 60,
                    events: {
                        updated: function(event, config) {
                            let el = document.getElementsByClassName('apexcharts-yaxis')
                            let el2 = document.getElementsByClassName('apexcharts-xcrosshairs')
                            if (el && el[0] && el2 && el2[0]) {
                                let height = el2[0].getBBox().height / 212
                                el[0].transform.baseVal[0].matrix.f = -1 * (height - 1.5)
                            }
                        },
                        mounted: function(event, config) {
                            console.log('g25 mounted');
                            this.$store.commit('change', {
                                g25Loaded: true
                            })
                            let el = document.getElementsByClassName('apexcharts-yaxis')
                            let el2 = document.getElementsByClassName('apexcharts-xcrosshairs')
                            if (el && el[0] && el2 && el2[0]) {
                                let height = el2[0].getBBox().height / 212
                                el[0].transform.baseVal[0].matrix.f = -1 * (height - 1.5)
                            }
                        },
                        click: function(event, chartContext, {
                            globals,
                            seriesIndex,
                            dataPointIndex,
                            config
                        }) {
                            if (w.priorSelection) {
                                let el = document.getElementById(w.priorSelection)
                                if (el) {
                                    el.classList.remove('selected');
                                }
                            }
                            if (event.path && event.path[1] && event.path[1].id) {
                                let el = document.getElementById(event.path[1].id)
                                if (el) {
                                    w.priorSelection = event.path[1].id
                                    el.classList.add('selected');
                                }
                            }

                            let sample = w.heatmapJSON[seriesIndex].group.split('|')[0].split('@')[0] + ' ► ' + w.heatmapJSON[seriesIndex].name
                            w.onHeatmapClicked(sample);
                        }
                    },
                },
                states: {
                    normal: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    },
                    hover: {
                        filter: {
                            type: 'lighten',
                            value: 0.5,
                        }
                    },
                    active: {
                        allowMultipleDataPointsSelection: false,
                        filter: {
                            type: 'none',
                            value: 0
                        }
                    },
                },
                plotOptions: {
                    heatmap: {
                        distributed: false,
                        radius: 0,
                        colorScale: {
                            inverse: true
                        },
                        useFillColorAsStroke: false
                        //reverseNegativeShade: true
                    },
                },
                tooltip: {
                    shared: false,
                    enabled: true,
                    x: {
                        show: false
                    },
                    marker: {
                        show: false,
                    },
                    z: {
                        show: false
                    },
                    y: {
                        formatter: function(val, series) {
                            let distance = (w.heatmapJSON[series.seriesIndex].data[series.dataPointIndex].distance);
                            //return (val + ' ' + distance + ' '  + JSON.stringify(series.series[series.seriesIndex][series.dataPointIndex],null,2))
                            return distance.toFixed(2);
                        },
                        title: {
                            formatter: function(seriesName, series) {
                                let sample = (w.heatmapJSON[series.seriesIndex].data[series.dataPointIndex].sample);
                                return sample.replace(':', ' ').replace(/_/g, ' ')
                            }
                        }
                    }
                },
                xaxis: {
                    axisBorder: {
                        show: false
                    },
                    tooltip: {
                        enabled: false
                    },
                    labels: {
                        show: true,
                        rotate: -45,
                        rotateAlways: true,
                        offsetY: 5,
                        formatter: function(value, timestamp, opts) {
                            let length = w.heatmapJSON[0].data.length
                            let max = 2 * length
                            let count = w.heatmapJSON.filter(x => x.data.findIndex(y => y.x == value && y.y == max) >= 0)
                            //value = value.split(' ')
                            return [value].concat([`(${count.length})`, '     '])
                            //return value + ' ' + `(${count.length})`
                        }
                    },
                    position: 'bottom',
                    floating: false,
                },
                yaxis: {
                    labels: {
                        show: true,
                        minWidth: 0,
                        offsetX: -5,
                    },
                    offsetY: -10,
                    floating: false,
                },
                dataLabels: {
                    enabled: false,
                },
                colors: this.colors,
                colors: [w.themea ? invertColor(colors[0]) : colors[0]],
                colorsa: w.components.length <= this.colors.length ? this.colors : ["#F3B415", "#F27036", "#663F59", "#6A6E94", "#4E88B4", "#00A7C6", "#18D8D8", '#A9D794',
                    '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD', '#7A918D', '#BAFF29'
                ],
            }
        },
        usergroups: function() {
            return this.$store.getters.get('usergroups')
        },
        advanced: function() {
            return this.usergroups.indexOf('advanced') >= 0 ? true : false
        },
        showMap2: async function() {
            if (this.drawer) {
                await setTimeout(async () => {
                    return true
                }, 3000)
            } else {
                return false
            }
        },
        modes: function() {
            let defaultmodes = [{
                    label: 'Global 25 (G25)',
                    value: 'G25'
                },
                {
                    label: 'HarappaWorld',
                    value: 'HARAPPAWORLD'
                },
                {
                    label: 'Eurogenes K13',
                    value: 'EUROGENESK13'
                },
                {
                    label: 'Eurogenes Global K36',
                    value: 'K36'
                },
                {
                    label: 'Eurogenes K15',
                    value: 'EUROGENESK15'
                },
                {
                    label: 'MDLP World K22',
                    value: 'MDLPWORLD22'
                },
                {
                    label: 'Dodecad World K12',
                    value: 'DODECADK12B'
                },
                {
                    label: 'Dodecad Globe K13',
                    value: 'GLOBE13'
                }
            ]
            let enhanced = [
                //{ label: 'Geno25 (v1)', value: 'GENO25V1' },
                {
                    label: 'Geno25 (v2)',
                    value: 'GENO25V2'
                }
                //{ label: 'Geno25 (v3)', value: 'GENO25V3' }
            ]
            if (this.isAdmin) {
                return defaultmodes.concat(enhanced)
            } else {
                return defaultmodes
            }
        },
        maxVals: {
            set: function(value) {
                this.$store.commit('change', {
                    maxVals: value
                })
            },
            get: function(value) {
                return this.$store.getters.get('maxVals')
            }
        },
        mode: {
            set: function(value) {
                this.$store.commit('change', {
                    monteMode: value
                })
            },
            get: function(value) {
                return this.$store.getters.get('monteMode') ? this.$store.getters.get('monteMode') : 'G25'
            }
        },
        aggregatedCalc() {
            let w = this;
            let calc = w.groupArray && w.groupArray[0] && w.groupArray[0].aggregated && w.groupArray[0].calculator ? w.groupArray[0].aggregated : false
            return calc
        },
        selectWidth() {
            let modes = this.modes
            modes = [...modes];
            let maxWidth = modes.sort((a, b) => a.value.length > b.value.length ? -1 : a.value.length < b.value.length ? 1 : 0)[0].value.length
            return `${maxWidth * 16}px`
        },
        userSamples: {
            set: function(value) {
                this.$store.commit('change', {
                    'userSamples': value
                })
            },
            get: function(value) {
                let samples = this.$store.getters.get('userSamples') && this.$store.getters.get('userSamples')[0] ? [{
                    group: this.alias ? this.alias : this.user.username,
                    alias: this.alias ? this.alias : undefined,
                    originalGroup: this.alias ? this.user.username : undefined,
                    samples: this.$store.getters.get('userSamples').filter(x => x.type === this.mode)
                }] : []
                //console.log('filtering', this.mode, samples, this.$store.getters.get('userSamples').filter(x => x.type === this.mode))
                return samples
            }
        },
        selectSamples() {
            return "<div style=padding:10px>Select individual samples instead of the whole group<br/>Multiple samples from the same group will form their own virtual group<br/>Selections can be mixed-and-matched from groups and individual samples, but groups will take precedence</div></div>"
        },
        updated() {},
        subType() {
            return this.subs && this.subs.subType && this.subs.subType.indexOf('gold') >= 0 ? 2 : this.subs && this.subs.subType && this.subs.subType.indexOf('silver') >= 0 ? 1 : 0
        },
        optimaFit() {
            return "<div style=padding:10px><b>Experimental Feature</b><br/><div style='padding:5px 0;'>Select as many populations as you like<br>(up to a maximum of 20)<br/>The optimaFit process will iterate over all possible combinations and calculate the 4 populations that provide optimal results<br/>Please note that the selected populations should all belong to the same time period<br/>Care should also be taken to select populations that, at minimum, hold a possibility of being relevant to your ancestry<br/>Alternatively, you may choose to run with no groups selected<br/>In this case, optimaFit will automatically find the groups that provide the best fit (moderns only)<br></div><b style='color:brown;padding-bottom: 5px;'>Warning</b><br/><div style='padding-top: 5px'>Enabling this mode can use up to 200 credits for a single run<br/><div style='padding-top: 10px; padding-bottom: 0px'><b style='color:brown;padding-bottom: 5px;'>Requires PRO subscription</b></div></div></div>"
        },
        queryTimeStamp: {
            get: function() {
                return this.$store.getters.get('queryTimeStamp');
            },
            set: function(value) {
                this.$store.commit('change', {
                    queryTimeStamp: value
                })
            }
        },
        globaltheme: {
            get: function() {
                return this.$store.getters.get('theme');
            },
            set: function(value) {
                this.$store.commit('change', {
                    theme: value
                })
            }
        },
        primaryTabs: {
            get: function() {
                return this.primaryT
            },
            set: function(value) {
                this.$store.commit('change', {
                    primaryTabs: value
                })
            }
        },
        spinner: {
            get: function() {
                return this.$store.getters.get('spinner')
            },
            set: function(value) {
                this.$store.commit('change', {
                    spinner: value
                })
            }
        },
        progress: {
            get: function() {
                return this.$store.getters.get('progress')
            },
            set: function(value) {
                this.$store.commit('change', {
                    progress: value
                })
            }
        },
        sampleOptions: function() {
            if (this.switches.sampleGroups) {
                let options = this.sampleJSON.filter(x => x.samples.filter(y => y.mode === 'raw' || y.mode === this.mode || y.type === this.mode).length > 0)
                this.filteredOptions = options.slice(0, 1000)
                return options
            } else {
                let options = this.sampleJSON.filter(x => x.samples.filter(y => y.mode === 'raw' || y.mode === this.mode || y.type === this.mode).length > 0)
                options = options.concat(this.customGroups.filter(x => x.type == this.mode))
                this.filteredOptions = options.slice(0, 1000)
                return options.concat(this.customGroups.filter(x => x.type == this.mode))
                //return this.sampleJSON.filter(x => x.samples.filter(y => y.mode === 'raw' || y.mode === this.mode || y.type === this.mode).length > 0)
                //return this.sampleJSON
                var newoptions = []
                var array = JSON.parse(JSON.stringify(this.sampleJSON))
                array.forEach(group => {
                    group.samples.forEach(sample => {
                        if (sample.public === 1 || sample.type !== 'user') {
                            sample.label = sample.group + " ► " + sample.sample
                            sample.class = sample.outlier ? 'G25 outlier' : sample.class
                            delete sample.coords;
                            delete sample.coords2;
                            newoptions.push(sample)
                        }
                    })
                })
                this.filteredOptions = newoptions.slice(0, 1000)
                return newoptions
            }
        },
        allSamples: function() {
            let allsamples = []
            this.sampleOptions.forEach(group => {
                group.samples.forEach(sample => {
                    allsamples.push(sample)
                })
            })
            return allsamples
        },
        groupOptions: {
            get: function() {
                if (this.switches.calculator) {
                    return this.groupCalcs;
                } else if (!this.switches.groupSamples) {
                    if (this.mode === 'G25') {
                        //return this.groupJSON.filter(x => x.type === 'G25' || x.type === undefined)
                        return this.customGroups && this.customGroups.length > 0 ? this.groupJSON.filter(x => x.type === 'G25' || x.type === undefined).concat(this.customGroups.filter(x => x.type === 'G25' || x.type === undefined)) : this.groupJSON.filter(x => x.type === 'G25' || x.type === undefined)
                    } else {
                        return this.customGroups && this.customGroups.length > 0 ? this.groupJSON.filter(x => x.type != 'G25' && x.type != undefined).concat(this.customGroups.filter(x => x.type != 'G25' && x.type != undefined)) : this.groupJSON.filter(x => x.type != 'G25' && x.type != undefined)
                    }
                } else {
                    //return this.groupJSON
                    var newoptions = []
                    var array = JSON.parse(JSON.stringify(this.sampleJSON))
                    array.forEach(group => {
                        group.samples.forEach(sample => {
                            if ((sample.mode === 'raw' || sample.mode === this.mode || sample.type === this.mode) && (sample.public !== 0 || sample.type !== 'user')) {
                                sample.label = sample.group + " ► " + sample.sample
                                delete sample.coords;
                                delete sample.coords2;
                                newoptions.push(sample)
                            }
                        })
                    })
                    return newoptions
                }
            },
            set: function(value) {
                console.log(value);
            }
        },
        showNonRawUploadIcons: function() {
            return true;
        },
        secondaryTabs: {
            get: function() {
                return this.secondaryT
            },
            set: function(value) {
                this.$store.commit('change', {
                    secondaryTabs: value
                })
            }
        },
        batchEnabled() {
            return this.subType > 0 ? true : false
        },
        optimaEnabled() {
            return this.subType > 1 ? true : false
        },
        fitsEnabled() {
            return this.subType > 0 ? true : false
        },
        cyclesEnabled() {
            return this.subType > 0 ? true : false
        },
        sampleMax() {
            return this.resources.samples[this.subType] - this.customSampleCount;
        },
        groupMax() {
            return this.resources.groups[this.subType]
        },
        groupSelect() {
            return this.subType > 1 ? true : false
        },
        groupCalcs: function() {
            if (this.userCalcs[0]) {
                let newCalcs = JSON.parse(JSON.stringify(this.publicCalcs.concat([])))
                newCalcs = newCalcs.map(x => {
                    x.label = x.calculator;
                    x.class = 'default calc';
                    return x
                })
                if (this.mode === 'G25') {
                    newCalcs = newCalcs.filter(x => x.public == 1 && (x.type === undefined || x.type === 'G25' || x.type === null))
                } else {
                    newCalcs = newCalcs.filter(x => x.type === this.mode)
                }
                this.userCalcs.map(x => {
                    if (newCalcs.findIndex(c => c.label == x.label && c.user == x.user) < 0 && (this.mode == 'G25' ? (x.type === undefined || x.type === 'G25' || x.type === null) : x.type === this.mode)) {
                        newCalcs.push(x)
                    }
                })
                return newCalcs
            } else {
                let newCalcs = JSON.parse(JSON.stringify(this.publicCalcs.concat([])))
                newCalcs = newCalcs.map(x => {
                    x.label = x.calculator;
                    x.class = 'default calc';
                    return x
                })
                let publicCalcs = []
                if (this.mode === 'G25') {
                    publicCalcs = newCalcs.filter(x => x.public == 1 && (x.type === undefined || x.type === 'G25' || x.type === null))
                } else {
                    publicCalcs = newCalcs.filter(x => x.public == 1 && x.type === this.mode)
                }
                return publicCalcs;
            }
        },
        groupJSON: function() {
            if (this.userSamples[0]) {
                let customgroups = []
                this.userSamples[0].samples.filter(x => x.type === this.mode).map(sample => {
                    if (sample.customgroup) {
                        let customIndex = customgroups.findIndex(x => x.label == sample.customgroup + ' [' + sample.group + ']');
                        if (customIndex >= 0) {
                            customgroups[customIndex].samples = customgroups[customIndex].samples + 1
                        } else {
                            customgroups.push({
                                class: 'default user',
                                type: sample.type,
                                age: sample.age,
                                customgroup: sample.customgroup,
                                ethnicity: sample.customgroup + ' [' + sample.group + ']',
                                label: sample.customgroup + ' [' + sample.group + ']',
                                samples: 1
                            })
                        }
                    }
                })
                if (this.mode === 'G25') {
                    return this.publicGroups.concat(customgroups)
                } else {
                    return this.publicRawGroups.concat(customgroups)
                }
            } else {
                if (this.mode === 'G25') {
                    return this.publicGroups
                } else {
                    return this.publicRawGroups
                }
            }
        },
        sampleJSON: function() {
            if (this.userSamples[0]) {
                if (this.mode == 'G25') {
                    let publicSamples = this.publicSamples.filter(x => x.group !== this.userSamples[0].group)
                    let userSamples = JSON.parse(JSON.stringify(this.userSamples[0]))
                    userSamples.originalGroup = this.userSamples[0].group
                    userSamples.group = this.alias ? this.alias : this.userSamples[0].group
                    console.log('mysamples', userSamples);
                    let customgroups = userSamples.samples.length > 0 ? [userSamples] : []
                    this.userSamples[0].samples.map(sample => {
                        if (sample.customgroup) {
                            let customIndex = customgroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customgroups[customIndex].samples.push(sample)
                            } else {
                                customgroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    customgroup: sample.customgroup,
                                    originalgroup: sample.group,
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    return customgroups.concat(publicSamples)
                } else {
                    let publicSamples = this.publicRawSamples.filter(x => x.group !== this.userSamples[0].group)
                    let userSamples = JSON.parse(JSON.stringify(this.userSamples[0]))
                    userSamples.samples = userSamples.samples.filter(x => x.sample.indexOf('Average') < 0 && x.sample.indexOf('Median') < 0 && !x.customgroup)
                    let customgroups = userSamples.samples.length > 0 ? [userSamples] : []
                    this.userSamples[0].samples.map(sample => {
                        if (sample.customgroup) {
                            let customIndex = customgroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customgroups[customIndex].samples.push(sample)
                            } else {
                                customgroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    return customgroups.concat(publicSamples)
                }
            } else {
                if (this.mode == 'G25') {
                    return this.publicSamples
                } else {
                    return this.publicRawSamples
                }
            }
        },
        piechartSeries: function() {
            let w = this;
            let pieseries = w.series
            let series = []
            let index = w.currentIndex;
            pieseries.map(x => {
                if (x.data[index] && x.data[index] > 0) {
                    let aliasindex = w.components.findIndex(y => y == x.name)
                    series.push({
                        value: x.data[index],
                        name: w.compAlias[aliasindex]
                        //name: x.name.split(' • ').length > 1 ? x.name.split(' • ')[1].replace(/_/g, ' ').replace(/ \(.*\)/, '') : x.name.replace(/_/g, ' ')
                    })
                }
            })
            //w.pieOptions.title.text = w.calcArray[0].label;
            return series;
        },
        pieSeries: function() {
            let w = this;
            let pieseries = w.series
            let series = []
            let index = w.currentIndex;
            pieseries.map(x => {
                if (x.data[index] && x.data[index] > 0) {
                    series.push({
                        value: x.data[index],
                        name: x.name.split(' • ').length > 1 ? x.name.split(' • ')[1].replace(/_/g, ' ').replace(/ \(.*\)/, '') : x.name
                    })
                }
            })
            //w.pieOptions.title.text = w.calcArray[0].label;
            w.pieOptions.title.textStyle = {
                color: w.theme ? 'white' : 'black'
            }
            w.pieOptions.label.color = w.theme ? 'silver' : 'gray'
            //w.pieOptions.title.subtext = 'by ' +  w.calcArray[0].owner;
            w.pieOptions.color = w.colors;
            w.pieOptions.series[0].data = series
        },
        heatmapSeries: function() {
            let w = this;
            let series = this.heatmapJSON
            let components = w.components.map(x => x.split(' ')[0])
            series = series.map(x => {
                x.data.sort(function(a, b) {
                    return components.indexOf(a.sample.split(':')[0]) - components.indexOf(b.sample.split(':')[0]);
                });
                return x
            })
            return series;

        },
        mapseries: function() {
            this.map.geo.select = {
                itemStyle: {
                    areaColor: '#729bbbaa',
                    borderWidth: 3,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                    shadowBlur: 10
                },
                label: {
                    show: false,
                    color: 'transparent',
                    fontSize: 14
                }
            }
            this.userSeries = [];
            let index = this.currentIndex ? this.currentIndex : 0;
            let series = []
            let features = []
            let chartseries = this.switches.calculator ? this.calcSeries : this.series
            chartseries.forEach(item => {
                series.push(item.data[index])
            })
            //var series = [{'name':name, 'value':value, 'color':color, latitude: 52.333333, longitude: 61.016667}]
            series.forEach(function(itemOpt) {
                if (itemOpt > mapMax) {
                    mapMax = itemOpt
                }
                if (itemOpt < mapMin) {
                    mapMin = itemOpt;
                }
            });

            function getRandomInRange(from, to, fixed) {
                return (Math.random() * (to - from) + from).toFixed(fixed) * 1;
                // .toFixed() returns string, so ' * 1' is a trick to convert to number
            }
            var w = this
            w.currentChartIndex = w.currentChartIndex < 0 ? 0 : w.currentChartIndex
            w.currentIndex = w.currentIndex < 0 ? 0 : w.currentIndex
            let components = w.switches.calculator ? w.calcComponents : w.components
            let colorComp = w.components;
            let compObj = {}
            let countries = JSON.parse(JSON.stringify(worldMap.countries))
            let regions = []
            series = series.map(function(itemOpt, index) {
                var parent = components[index] ? components[index].split(':')[0] : 'unknown'
                var comp = components[index] && components[index].split(':')[1] ? components[index].split(':')[1] : components[index] ? components[index] : 'unknown'
                comp = comp.replace(' (AVG)', '').replace(' (MED)', '')
                comp = Object.keys(w.geo).some(x => x == comp) ? comp : Object.keys(w.geo).some(x => x == comp.split(' • ')[0]) ? comp.split(' • ')[0] : comp
                var meta = w.geo[comp] ? {
                    age: w.geo[comp].a,
                    origin: w.geo[comp].origin
                } : undefined
                if (w.geo[comp] && w.geo[comp].origin) {
                    let index = worldMap.countries.findIndex(x => x.name === w.geo[comp].origin)
                    if (index >= 0) {
                        let regionIndex = regions.findIndex(y => y.name === w.geo[comp].origin)
                        if (regionIndex < 0) {
                            regions.push({
                                name: w.geo[comp].origin,
                                label: {
                                    show: false,
                                    position: [0, -40]
                                },
                                itemStyle: {
                                    areaColor: '#2c526f',
                                    borderColor: 'white',
                                    shadowOffsetX: 0,
                                    shadowOffsetY: 0,
                                    shadowBlur: 20,
                                    borderWidth: 1,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            })
                        }
                        if (countries[index]) {
                            countries[index].value[3] = parseFloat((countries[index].value[3] + itemOpt).toFixed(2))
                            countries[index].itemStyle = {
                                normal: {
                                    areaColor: 'black'
                                }
                            }
                        }
                    } else {}
                }
                var colorIndex = colorComp.findIndex(x => x === unescape(parent))
                compObj[parent] = compObj[parent] ? compObj[parent] + itemOpt : itemOpt
                if (w.chartJSON[w.currentChartIndex].meta && (!w.switches.calculator || w.calcComponents.length > 0)) {
                    meta = meta ? {
                        ...{
                            meta: w.chartJSON[w.currentChartIndex].meta
                        },
                        ...meta
                    } : w.chartJSON[w.currentChartIndex].meta
                    let userSeries = []
                    userSeries.push({
                        type: 'custom',
                        visualMap: false,
                        symbol: 'pin',
                        label: {
                            show: true,
                            position: 'bottom',
                            color: 'white',
                            offset: [0, 5],
                            formatter: function(d) {
                                let name = d.name
                                if (name.includes(' ► ')) {
                                    name = name.split(' ► ')[1]
                                } else if (name.includes(':')) {
                                    name = name.split(':')[1]
                                } else if (name.includes(' ') && name.split(' ').length > 2) {
                                    name = name.split(' ')[2]
                                }
                                name = w.map.geo.zoom && w.map.geo.zoom >= 2 ? name.replace(/_/g, ' ') : ''
                                if (name == 'Average' || name == 'Median') name = d.name.replace(/:/, ' ► ').replace(/_/g, ' ')
                                return name
                            },
                            fontSize: 12,
                            fontWeight: 'bold',
                        },
                        symbolSize: 25,
                        animation: true,
                        itemStyle: {
                            normal: {
                                //color: '#E65929',
                                color: 'lightskyblue',
                                borderColor: 'white',
                                borderWidth: 2
                            }
                        },
                        name: w.categories[w.currentIndex],
                        locality: meta.meta,
                        value: [meta.meta.longitude, meta.meta.latitude, 100, 0]
                    })
                    w.map.geo.center = [meta.meta.longitude, meta.meta.latitude, 100, 0];
                    w.map.geo.zoom = 4;
                    w.mapOptions = {
                        geo: {
                            center: w.map.geo.center,
                            zoom: w.map.geo.zoom
                        }
                    }
                    w.map.series[1].data = userSeries
                } else if (w.geo[comp] && itemOpt > 0) {
                    features.push(turf.point([w.geo[comp].latitude, w.geo[comp].longitude], {
                        value: itemOpt
                    }))
                }
                return {
                    name: comp,
                    parent: parent,
                    meta: meta,
                    animation: false,
                    value: [
                        w.geo[comp] && itemOpt > 0 ? w.geo[comp].longitude : undefined,
                        w.geo[comp] && itemOpt > 0 ? w.geo[comp].latitude : undefined,
                        itemOpt
                    ],
                    label: {
                        emphasis: {
                            position: 'right',
                            show: true
                        },
                        show: true,
                        position: 'bottom',
                        offset: [0, 5],
                        color: 'white',
                        formatter: function(d) {
                            let name = d.name
                            if (name.includes(' ► ')) {
                                let nametemp = name.split(' ► ')[1]
                            } else if (name.includes(':')) {
                                name = name.split(':')[1]
                            } else if (name.includes(' ') && name.split(' ').length > 2) {
                                name = name.split(' ')[2]
                            }
                            name = w.map.geo.zoom && w.map.geo.zoom >= 2 ? name.replace(/_/g, ' ') : ''
                            if (name == 'Average' || name == 'Median') name = d.name.replace(/:/, ' ► ').replace(/_/g, ' ')
                            return name
                        },
                        fontWeight: 'bold',
                        fontSize: 10,
                    },
                    itemStyle: {
                        normal: {
                            color: w.colors[colorIndex % w.colors.length],
                            borderColor: 'white',
                            borderWidth: 2
                        }
                    }
                };
            })
            let aggValues = Object.keys(compObj).map(x => {
                return {
                    component: x,
                    value: compObj[x]
                }
            })
            aggValues.sort((a, b) => a.value === b.value ? 0 : a.value < b.value ? 1 : -1)
            series.sort((a, b) => a.value[2] === b.value[2] ? 0 : a.value[2] < b.value[2] ? 1 : -1)
            let newseries = []
            aggValues.map(x => {
                newseries = newseries.concat(series.filter(y => y && y.parent == x.component))
            })
            let geoOptions = {
                weight: "value"
            }
            if (features.length > 0 && w.calcComponents.length > 0) {
                features = turf.featureCollection(features);
                let userSeries = []
                let value, locality, mean
                let meta = w.chartJSON[w.currentChartIndex].meta
                if (meta) {
                    value = [meta.meta.longitude, meta.meta.latitude, 100, 0]
                    locality = meta.meta
                } else {
                    mean = centerMean(features, geoOptions);
                    value = [mean.geometry.coordinates[1], mean.geometry.coordinates[0], 100, 0]
                }
                userSeries.push({
                    type: 'custom',
                    visualMap: false,
                    symbol: 'pin',
                    symbolSize: 25,
                    animation: true,
                    itemStyle: {
                        normal: {
                            //color: '#E65929',
                            color: 'lightskyblue',
                            borderColor: 'white',
                            borderWidth: 2
                        }
                    },
                    label: {
                        show: true,
                        position: 'bottom',
                        color: 'white',
                        offset: [0, 5],
                        formatter: function(d) {
                            let name = d.name
                            console.log('secundo', name)
                            if (name.includes(' ► ')) {
                                name = name.split(' ► ')[1]
                            } else if (name.includes(':')) {
                                name = name.split(':')[1]
                            } else if (name.includes(' ') && name.split(' ').length > 2) {
                                name = name.split(' ')[2]
                            }
                            name = w.map.geo.zoom && w.map.geo.zoom >= 2 ? name.replace(/_/g, ' ') : ''
                            if (name == 'Average' || name == 'Median') name = d.name.replace(/:/, ' ► ').replace(/_/g, ' ')
                            return name
                        },
                        fontSize: 12,
                    },
                    name: w.categories[w.currentIndex],
                    value: value,
                    locality: locality
                })
                w.map.geo.center = value;
                w.map.geo.zoom = 4;
                w.mapOptions = {
                    geo: {
                        center: w.map.geo.center,
                        zoom: w.map.geo.zoom
                    }
                }
                w.map.series[1].data = userSeries
            }
            w.map.series[2].data = countries;
            w.map.geo.regions = regions;
            return newseries
        },
        showSelections: function() {
            if (((this.sampleArray && this.sampleArray.length >= 1 || this.csv && this.customSampleCount > 0) && this.groupArray && ((this.switches.calculator && this.groupArray.length >= 1) || this.groupArray.length >= 2)) || this.collapsed || this.chartReady === true) {
                //if (this.collapsed || this.chartReady === true) {
                return -1
            } else {
                return 0
            }
        },
        sunburstSeries: function() {
            let index = this.currentIndex ? this.currentIndex : 0;
            let series = []
            let chartseries = this.series
            chartseries.forEach(item => {
                series.push(item.data[index])
            })
            var w = this
            //let components = w.switches.calculator ? w.calcComponents : w.components
            let components = w.components
            let colorComp = w.components;
            let compObj = {}
            series = series.map(function(itemOpt, index) {
                var parent = components[index] ? components[index].split(':')[0] : 'unknown'
                var comp = components[index] && components[index].split(':')[1] ? components[index].split(':')[1] : components[index] ? components[index] : 'unknown'
                comp = comp.replace(' (AVG)', '').replace(' (MED)', '')
                var colorIndex = colorComp.findIndex(x => x === parent)
                let color = w.colors[colorIndex % w.colors.length]
                let children = w.mapseries.filter(x => unescape(x.parent) === parent)
                children = children.map((x, i) => {
                    let grandchildren = w.calcSampleSeries.filter(y => y.parent === x.name)
                    grandchildren = grandchildren.map((x, i) => {
                        return {
                            name: unescape(x.parent).replace(/_/g, ' ') + ' ► ' + x.name.replace(/_/g, ' '),
                            value: x.data[w.currentIndex],
                            itemStyle: {
                                color: w.newColor(color)
                            }
                        }
                    })
                    return {
                        name: unescape(x.name).replace(/_/g, ' '),
                        value: parseFloat(x.value[2].toFixed(2)),
                        itemStyle: {
                            color: w.newColor(color, 0, 0, -8)
                        },
                        children: grandchildren
                    }
                })
                return {
                    name: unescape(comp).replace(/_/g, ' '),
                    children: children,
                    itemStyle: {
                        color: w.newColor(color, 0, 0, -15)
                    },
                    //value: parseFloat(itemOpt.toFixed(2))
                    value: itemOpt
                };
            })
            return series
        },
        returnNearest: function(event) {
            var message, klass, distance = this.chartJSON[this.currentChartIndex].nearest[0] ? this.chartJSON[this.currentChartIndex].nearest[0].distance : 99,
                nearest = this.optimaEnabled ? this.chartJSON[this.currentChartIndex].nearest.slice(0, 5) : this.chartJSON[this.currentChartIndex].nearest.slice(0, 5);
            message = "<div class=tip-content><table class='nearestSamples'><thead><tr><th class='samples'>" + (this.calcComponents.length > 0 ? "Group" : "Sample") + "</th><th>Distance</th></tr></thead><tbody>"
            if (distance <= 2) {
                klass = 'good'
            } else if (distance <= 3) {
                klass = 'fair'
            } else {
                klass = 'poor'
            }
            nearest.forEach(sample => {
                sample.sample = sample.sample ? sample.sample : sample._row;
                message = message + `<tr><td>${sample.sample.replace(/_/g,' ').replace(':','  ')}</td><td>${sample.distance.toFixed(2)}</td></tr>`
            })
            message = message + "</tbody></table></div>"
            message = "<div class='tip-fit-header-" + klass + "' >Nearest " + (this.calcComponents.length > 0 ? "Group" : "Samples") + "</div>" + message;
            return message
        },
        returnFit: function(event) {
            if (this.chartJSON[this.currentChartIndex] && this.chartJSON[this.currentChartIndex].distance) {
                var message, klass, distance = this.chartJSON[this.currentChartIndex].distance;
                if (distance <= 2) {

                    message = 'This is a great result!<br>' + (this.newseries.length > 6 ? ' try to reduce the number of target groups to <b>6</b> or less while keeping the distance below <b>2</b>...' : '')
                    klass = 'good'
                } else if (distance <= 3) {
                    message = 'This is a decent result, but we can do better!<br> Try to select alternate target groups with geographic and historic relevance for your ancestry<br>aim to get the distance below <b>2</b>.'
                    klass = 'fair'
                } else {
                    message = 'This is not a great result, but no worries, we can improve on it!<br> Try to select alternate target groups with geographic and historic relevance for your ancestry<br>we should try to get the distance to <b>2</b> or less...'
                    klass = 'poor'
                }
                message = "<div class='tip-fit-header-" + klass + "' >Fit: " + distance + "</div><div class='tip-fit-content'>" + message + "<br><br>Click to get the <b>Oracles</b> from the source populations</div>"

                return message
            } else {
                return null
            }
        },
        newseries: function() {
            var index = this.currentIndex ? this.currentIndex : 0;
            var series = []
            this.series.forEach(item => {
                if (item.data[index] > 0) series.push(item.data[index])
            })
            return series
        },
        newcomponents: function() {
            var index = this.currentIndex ? this.currentIndex : 0;
            var components = []
            this.series.forEach(item => {
                if (item.data[index] > 0) components.push(item.name)
            })
            return components
        },
        newcolors: function() {
            var index = this.currentIndex ? this.currentIndex : 0;
            var colors = []
            this.series.forEach(item => {
                if (item.data[index] > 0) colors.push(this.colors[this.components.findIndex(x => x === item.name) % this.colors.length])
            })
            return colors
        },
        saveReady: function() {
            if (this.series && this.series.length > 0) {
                return true
            } else {
                return false
            }
        },
        switchOutliers: function() {
            return true
        },
        switchAverages: function() {
            return true
        },
        samplesReady: function(evt) {
            if (this.sampleArray && this.sampleArray.length > 1) {
                return true
            } else {
                return false
            }
        },
        groupsReady: function() {
            if (this.groupArray && this.groupAprray.length > 2) {
                return 'ready'
            } else {
                return 'disabled'
            }
        },
        empty: function() {
            if ((this.formstate.$invalid || (!this.sampleArray && !this.csv) || (this.sampleArray && this.sampleArray.length < 1 && this.customSampleCount == 0)) || (!this.groupArray && !this.switches.optimaFit || (this.groupArray && this.switches.calculator && this.groupArray.length < 1) || (this.groupArray && !this.switches.optimaFit && !this.switches.calculator && this.groupArray.length < 2))) {
                return true
            } else {
                return false
            }
        },
        columnDefs: function() {
            let w = this;
            if (this.components) {
                if (this.components.length > 6 || this.screenClass == 'isMobile') {
                    let maxLength = this.components.reduce((a, b) => {
                        return a && a.length > b.length ? a : b
                    }).length
                    if (w.heatmapJSON && w.heatmapJSON[0] && w.components.findIndex(x => x.indexOf('AVG') >= 0 || x.indexOf('MED') >= 0) < 0) {
                        maxLength = maxLength + 2
                    }
                    this.gridOptions.headerHeight = maxLength * 5;
                    //this.gridOptions.skipHeaderOnAutoSize = true;
                } else {
                    //this.gridOptions.skipHeaderOnAutoSize = false;
                    this.gridOptions.headerHeight = undefined;
                }
                var columns = [{
                    headerName: 'Sample',
                    field: 'sample',
                    pinned: 'left',
                    sortable: true,
                    resizable: false,
                    rowDrag: false,
                    suppressSizeToFit: true,
                    headerClass: 'header-sample',
                    //headerTooltip: 'Sample',
                    cellClass: 'cell-sample',
                    filter: true,
                    floatingFilter: false,
                    //tooltipComponent: 'customTooltip',
                    filterParams: {
                        buttons: ['reset']
                    },
                    tooltipField: 'sample',
                    // tooltipComponentParams: { color: '#ececec' },
                    cellStyle: {
                        textTransform: 'uppercase',
                        borderBottom: 'none',
                        textAlign: 'right',
                        paddingRight: '22px',
                        fontSize: '10px'
                    },
                    minWidth: 150,
                    maxWidth: 320
                }, {
                    headerName: !w.switches.calculator && w.switches.heatmap ? 'Nearest' : 'Fit',
                    //headerTooltip: !w.switches.calculator && w.switches.heatmap ? 'Nearest' : 'Fit',
                    field: 'distance',
                    sortable: true,
                    pinned: 'left',
                    rowDrag: false,
                    resizable: false,
                    headerClass: 'header-fit',
                    cellStyle: {
                        //backgroundColor: 'white',
                        //color: 'gray',
                        fontWeight: 700,
                    },
                    suppressSizeToFit: true,
                    width: 80,
                    //filter: 'agNumberColumnFilter',
                    filter: false,
                    filterParams: {
                        filterOptions: [
                            'lessThan',
                            'greaterThan',
                        ],
                        buttons: ['reset', 'apply']
                    },
                    cellClass: function(params) {
                        return (params.value <= 2 ? 'cell-fit distance-good' : params.value <= 3 ? 'cell-fit distance-fair' : params.value <= 5 ? 'cell-fit distance-poor' : 'cell-fit distance-bad')
                    }
                }]
                w.categories.map(x => {
                    columns[0].width = x.length * 8 >= 300 ? 300 : x.length * 8 > columns[0].width ? 8 * x.length : columns[0].width
                });
                var comp = this.components;

                function getLog(y) {
                    return Math.log(y) * 2 / Math.log(10);
                }
                comp.forEach(function(c, i) {
                    var index = w.components.indexOf(c);
                    let component = c.split('] ').length > 1 ? c.split('] ')[0] + ']' : c.split(' • ').length > 1 ? c.split(' • ')[1].replace(/ \(.*\)/, '') : c.split(' ')[0];
                    //if ( !w.switches.calculator ||  w.series[index].data.findIndex(x => x >= 1) >= 0 ) {
                    if (w.switches.heatmap && !w.switches.calculator && w.heatmapJSON && w.heatmapJSON[0] || w.switches.calculator && w.series[index].data.findIndex(x => x >= 1) >= 0 || w.series[index].data.findIndex(x => x > 0) >= 0) {
                        var obj = {};
                        obj.component = c
                        obj.minWidth = comp.length > 6 ? 56 : c.length > 6 ? 80 : c.length > 3 ? c.length * 13 : 56;
                        obj.sortable = true;
                        obj.resizable = false;
                        //obj.floatingFilter = true;
                        obj.filter = false
                        obj.filterParams = {
                            filterOptions: [
                                'lessThan',
                                'greaterThan',
                            ],
                            buttons: ['reset', 'apply']
                        };
                        obj.suppressSizeToFit = false;
                        let count;
                        if (w.switches.heatmap && !w.switches.calculator && w.heatmapJSON && w.heatmapJSON[0] && w.heatmapJSON[0].data) {
                            let length = w.heatmapJSON[0].data.length
                            let max = 2 * length
                            if (c.split(' • ').length > 1) {
                                count = w.heatmapJSON.filter(x => x.data.findIndex(y => y.sample == c.replace(/ \(.*\)/, '') && y.y == max) >= 0)
                            } else {
                                count = w.heatmapJSON.filter(x => x.data.findIndex(y => y.sample.split(':')[0] == component && y.y == max) >= 0)
                            }

                            //count = count.length < 21 ? '(' + count.length + ') ' : count.length > 20 ?  '&#' + (12880 + count.length) + '; ' : '' 
                            count = count.length
                            //obj.headerName = c.split(' • ').length > 1 ? c.split(' • ')[1].replace(/_/g, ' ').replace(/ \(.*\)/, '') + '<small><icon class="fa fa-header fa-info"></icon></small>' : component.replace(/_/g, ' ')
                            obj.headerName = w.compAlias[i]
                            obj.toolTip = c.split(' • ').length > 1 ? c.replace(/_/g, ' ').replace(/ \(.*\)/, '') : component.replace(/_/g, ' ')
                        } else {
                            obj.headerName = w.compAlias[i]
                            //obj.headerName = c.split(' • ').length > 1 ? c.split(' • ')[1].replace(/_/g, ' ').replace(/ \(.*\)/, '') + '<small><icon class="fa fa-header fa-info"></icon></small>' : c.replace(/_/g, ' ');
                            obj.toolTip = c.split(' • ').length > 1 ? c.replace(/_/g, ' ').replace(/ \(.*\)/, '') : c.replace(/_/g, ' ');
                        }
                        obj.headerComponentParams = {
                            template: '<div class="ag-cell-label-container" role="presentation">' +
                                '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                                '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                                '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
                                '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
                                '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
                                '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +

                                //The line below is the key for achieving the solution
                                //'    <span class="ag-count">' + count + '<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
                                '    <span class="ag-header-cell-text">' + (count ? '<span class="ag-count">' + count + '</span>' : '') + obj.headerName + '</span>' +
                                '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                                '  </div>' +
                                '</div>'
                        }
                        obj.headerTooltip = (count ? '<span class="ag-tooltip-count">' + count + '</span>' : '') + obj.toolTip;
                        obj.headerClass = comp.length > 6 || w.screenClass == 'isMobile' ? 'header-rotated-component' : 'header-component'
                        obj.field = c;
                        var index = w.components.indexOf(c);
                        var color = w.colors[index % w.colors.length];
                        obj.cellClass = 'cell-sheet';
                        let background;
                        obj.cellRenderer = function(params) {
                            if (w.switches.heatmap && !w.switches.calculator && params.data.display && params.data.display[index] !== undefined) {
                                return params.data.display[index].toFixed(2);
                            } else {
                                return params.value
                            }
                        }
                        obj.cellStyle = function(params) {
                            let color = w.heatmapColors[1]
                            let color2 = w.heatmapColors[1]

                            function adjust(color, amount) {
                                return '#' + color.replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
                            }
                            color2 = adjust(color, 20)
                            if (w.switches.heatmap && !w.switches.calculator && w.heatmapJSON && w.heatmapJSON[0] && w.heatmapJSON[0].data) {
                                //let sum = w.components.length * 2
                                let sum = w.heatmapJSON[0].data.length * 2
                                let base = w.components.length <= 3 ? 0 : 3
                                background = !isNaN(params.value) && params.value >= 0 ? (params.value == sum ? color2 : color) + Math.floor(parseFloat(((params.value == sum ? params.value : params.value + base) / sum).toFixed(2)) * 255).toString(16) : null;

                            } else {
                                let comp = c.split(' ')[0]
                                let max = w.maxVals && w.maxVals[comp] ? w.maxVals[comp] / 100 : 1
                                //background = !isNaN(params.value) && params.value >= 0 ? color + Math.floor(parseFloat(((0.5 + params.value/ (max * 100))/ max + 5).toFixed(2)) * 255).toString(16) : null;
                                background = !isNaN(params.value) && params.value >= 0 ? color2 + Math.floor(parseFloat(((params.value + 40) / 140).toFixed(2)) * 255).toString(16) : null;
                                //background = !isNaN(params.value) && params.value >= 0 ? color2 + Math.floor(parseFloat((getLog(params.value + 2) / getLog(102)).toFixed(2)) * 255).toString(16) : null;
                            }
                            //let background = !isNaN(params.value) && params.value >= 0 ? w.colors[0] + Math.floor(parseFloat(((params.value + 60)/167).toFixed(2)) * 255).toString(16) : null;
                            //background = background && w.theme ? w.colors[0] + Math.floor((1 - (Math.log(params.value + 3)/Math.log(103))) * 255).toString(16) : background;
                            let fontcolor = !isNaN(params.value) && params.value >= 0 ? 'white' : 'gray';
                            return {
                                backgroundColor: background,
                                //backgroundColor: '#7372721d',
                                color: fontcolor,
                                fontWeight: 700,
                                textAlign: 'center'
                            }
                        };
                        columns.push(obj);
                    }
                })
                return columns;
            } else {
                var columns = null;
                return columns;
            }
        },
        rowData: function() {
            var w = this;
            if (this.chartJSON && Array.isArray(this.chartJSON)) {
                var json = JSON.parse(JSON.stringify(this.chartJSON));
                var rows = [];
                if (w.switches.heatmap && !w.switches.calculator) {
                    json.forEach(function(p, i) {
                        var obj = {};
                        obj.display = []
                        //let sample = p.alias ? `${p.alias}:${p.profile.split(':')[1].split('@')[0]}` : p.profile.split(':')[0] + ':' + p.profile.split(':')[1].split('@')[0]
                        let sample = p.alias;
                        obj.sample = sample.split(':').reverse().join(':').replace(/:/g, " (").replace(/_/g, ' ').replace(/$/, ')')
                        obj.distance = p.similar.distance.toFixed(2)
                        var comp = w.components;
                        comp.forEach(function(n) {
                            let granular = false;
                            let match = n.split('] ').length > 1 ? n.split('] ')[0] + ']' : n.split(' [').length > 1 ? n : n.split(' ')[0]
                            if (n.split(' • ').length > 1) {
                                granular = true;
                                match = n.replace(/ \(.*\)/, '');
                            }
                            if (i == 0) {}
                            if (granular) {
                                obj[n] = p.heatmap && p.heatmap.data && p.heatmap.data.find(x => x.sample == match) ? p.heatmap.data.find(x => x.sample == match).y : 0
                            } else {
                                obj[n] = p.heatmap && p.heatmap.data && p.heatmap.data.find(x => x.sample.split(':')[0] == match) ? p.heatmap.data.find(x => x.sample.split(':')[0] == match).y : 0
                            }
                            if (granular) {
                                let display = p.heatmap && p.heatmap.data && p.heatmap.data.find(x => x.sample == match) ? p.heatmap.data.find(x => x.sample == match).distance : 0
                                obj.display.push(display)
                            } else {
                                let display = p.heatmap && p.heatmap.data && p.heatmap.data.find(x => x.sample.split(':')[0] == match) ? p.heatmap.data.find(x => x.sample.split(':')[0] == match).distance : 0
                                obj.display.push(display)
                            }
                        })
                        if (i == 0) {}
                        //if ( c === 'PJL-sim [Genoplot]' ) console.log(obj);
                        rows.push(obj)
                    })
                } else {
                    console.log('setting json', json)
                    json.forEach(function(p, i) {
                        var obj = {};
                        //let sample = p.alias ? `${p.alias}:${p.profile.split(':')[1].split('@')[0]}` : p.profile.split(':')[0] + ':' + p.profile.split(':')[1].split('@')[0]
                        let sample = p.alias;
                        obj.sample = sample.split(':').reverse().join(':').replace(/:/g, " (").replace(/_/g, ' ').replace(/$/, ')')
                        obj.distance = p.distance ? p.distance.toFixed(2) : undefined;
                        var comp = w.components;
                        comp.forEach(function(n) {
                            obj[n] = p.result && p.result[n] ? p.result[n] : 0
                        })
                        if (i == 0) {}
                        rows.push(obj)
                    })
                }
                return rows;
            } else {
                return []
            }
        },
        sheet: function() {
            var w = this;
            if (this.chartJSON) {
                var json = this.chartJSON;
                var rows = [];
                let components = JSON.parse(JSON.stringify(w.components))
                components.sort((a, b) => a > b ? 1 : a < b ? -1 : 0)
                //var columns = ['sample', 'distance'].concat(components)
                var columns = ['sample'].concat(components)
                rows.push(columns);
                json.forEach(function(p) {
                    var result = []
                    result.push(p.profile);
                    //result.push(p.distance);
                    components.map(n => {
                        var pct = p.result[n] ? p.result[n] : 0
                        result.push(pct)
                    })
                    rows.push(result)
                })
                return rows;
            } else {
                return null;
            }
        }

    },
    watch: {
        $workerData: (data, test) => {
            console.log('data!!!!!', data, test)
        }
    },
    data() {
        let w = this;
        return {
            debouncedValidateCSV: undefined,
            currentChartIndex: 0,
            imageDrop: undefined,
            rerunswitch: false,
            simulating: false,
            fullmap: false,
            g25mounted: false,
            gridMargin: 800,
            topics: {},
            embed: false,
            maintenance: false,
            frameReady: false,
            frameDisplay: 'none',
            debouncedSearchSamples: undefined,
            filteredSamples: [],
            initiated: false,
            filteredGroupSamples: [],
            csvValidation: '',
            customSampleCount: 0,
            unchanged: false,
            formstate: {},
            showTable: true,
            groupsvalue: [],
            gridKey: 0,
            priorProxy: null,
            GroupOrOptions: [],
            customGroups: [],
            spacerHeight: 80,
            fullScreen: false,
            previousQueryTimeStamp: 0,
            showMap: false,
            userSeries: [],
            saveReady2: false,
            introOptions: {
                "nextLabel": "Next &rarr;",
                "prevLabel": "&larr; Back",
                "skipLabel": "Cancel",
                "doneLabel": "Done",
                "hidePrev": false,
                "hideNext": false,
                "tooltipPosition": "bottom",
                "tooltipClass": "",
                "highlightClass": "",
                "exitOnEsc": true,
                "exitOnOverlayClick": false,
                "showStepNumbers": true,
                "keyboardNavigation": false,
                "showButtons": true,
                "showBullets": true,
                "showProgress": false,
                "scrollToElement": false,
                "scrollTo": "tooltip",
                "scrollPadding": 30,
                "overlayOpacity": 0.5,
                "positionPrecedence": [
                    "bottom",
                    "top",
                    "right",
                    "left"
                ],
                "disableInteraction": false,
                "helperElementPadding": 10,
                "hintPosition": "top-middle",
                "hintButtonLabel": "Got it",
                "hintAnimation": true,
                "buttonClass": "introjs-button"
            },
            drawer: false,
            showMap: false,
            direction: 'rtl',
            debug: false,
            customgroups: [],
            //frameworkComponents: {customTooltip: VTooltip},
            frameworkComponents: {},
            lastShared: false,
            shareUrl: {},
            theme: false,
            component: 'g25',
            tipDisabled: false,
            mapReady: false,
            sunburstReady: false,
            //userSamples: [],
            groupArray: this.$store.getters.get('groupArray') ? this.$store.getters.get('groupArray') : [],
            map,
            collapsed: false,
            collapseSubtract: false,
            exporting: false,
            pieOptions: {
                title: {
                    text: '',
                    subtext: '',
                    left: 'center',
                },
                label: {
                    position: 'outer',
                    formatter: params => params.name.replace(/_/, ' ').replace(/-/, ' '),
                },
                color: ["#1f78b4", "#a6cee3", "#33a02c", "#b2df8a", "#e31a1c", "#fb9a99", "#ff7f00", "#fdbf6f", "#6a3d9a", "#cab2d6", "#b15928", "#ffff99"],
                tooltip: {
                    trigger: 'item',
                    formatter: params => `&nbsp;&nbsp;${params.value}&nbsp;%&nbsp;&nbsp;${params.name.replace(/_/, ' ').replace(/-/,' ')}&nbsp;&nbsp;&nbsp`,
                },
                toolbox: {
                    show: false,
                    feature: {
                        mark: {
                            show: false
                        },
                        dataView: {
                            show: true,
                            readOnly: false
                        },
                        magicType: {
                            show: false,
                            type: ['funnel']
                        },
                        restore: {
                            show: true
                        },
                        saveAsImage: {
                            show: true
                        }
                    }
                },
                series: [{
                    name: '',
                    type: 'pie',
                    height: 450,
                    radius: [50, 200],
                    center: ['50%', '50%'],
                    stillShowZeroSum: false,
                    selectedOffset: 0,
                    startAngle: 45,
                    roseType: 'radial',
                    label: {
                        show: true,
                        alignTo: 'none',
                        //alignTo: 'edge',
                    },
                    emphasis: {
                        label: {
                            show: true,
                            position: 'center'
                        }
                    },
                    data: w.pieSeries
                }]
            },
            sunOptions: {
                tooltip: {
                    trigger: 'item',
                    //formatter: '{b}: {c}%'
                    //formatter: '&nbsp;{b}&nbsp;<br>&nbsp;<b>{c} %</b>'
                },
                itemStyle: {
                    emphasis: {
                        color: 'brown'
                    },
                    highlight: {
                        color: 'brown'
                    },
                    downplay: {
                        color: 'gray'
                    }
                },
                label: {
                    formatter: function(data) {
                        return data.data.value >= 1 ? `${data.data.name} ${data.data.value} % ` : ''
                    }
                },
                series: {
                    type: 'sunburst',
                    data: w.sunburstSeries,
                    highlightPolicy: 'self',
                    radius: [0, '90%'],
                    avoidLabelOverlap: true,
                    levels: [{}, {
                        r0: '20%',
                        r: '55%',
                        highlightPolicy: 'descendant',
                        itemStyle: {
                            borderWidth: 2,
                            opacity: 1,
                        },
                        label: {
                            show: true,
                            minAngle: 10,
                            fontSize: 15,
                            borderRadius: 9,
                            textShadowColor: '#333333',
                            textShadowBlur: 3,
                            textShadowOffsetX: 2,
                            textShadowOffsetY: 1,
                            padding: [7, 9],
                            rotate: 0,
                            color: 'white'
                        }
                    }, {
                        r0: '55%',
                        r: '72%',
                        label: {
                            position: 'outside',
                            show: true,
                            minAngle: 10,
                            padding: [50, 10],
                            borderRadius: 5,
                            fontSize: 12,
                            silent: true,
                            itemStyle: {
                                borderWidth: 2,
                            },
                            color: '#444',
                            rotate: 0,
                            distance: 30
                        }
                    }, {
                        r0: '72%',
                        r: '80%',
                        label: {
                            position: 'outside',
                            show: false,
                            minAngle: 5,
                            silent: false,
                            itemStyle: {
                                padding: [50, 10],
                                borderRadius: 5,
                                fontSize: 12,
                                silent: true,
                                borderWidth: 2,
                            },
                            color: 'white',
                            rotate: 0,
                            distance: 30
                        }
                    }]
                }
            },
            initOptions: {
                renderer: 'svg',
            },
            currentIndex: this.$store.getters.get('currentIndex'),
            introData: {},
            steps: [{
                    element: '#selectWrapper',
                    tooltipClass: 'introstep',
                    disableInteraction: true,
                    intro: "<p class=introHeader>Welcome to the genoplot global 25 runner!</p>please select <b>Next</b> to learn how to use the tool",
                    sound: {
                        media: ['https://static.genoplot.com/media/welcome.v5.mp3']
                    },
                    next: 'ready'
                },
                {
                    element: '#leftSelectIntro',
                    tooltipClass: 'samplesReady',
                    intro: "<p class=introHeader>Select Samples</p>You can just start typing in the input box and any matching sample(s) will show up in the drop-down list",
                    old: "<br><br>samples are searchable by name, country and age of sample ( for those samples that have age available )<br><br>your personal samples can be added to the system by clicking on the<br><b>EDIT</b><br>button<br>once added, your samples are available in the dropdown list",
                    sound: {
                        media: ['https://static.genoplot.com/media/samples.v2.mp3']
                    },
                    activate: 'leftSelectinput',
                },
                {
                    element: '#rightSelectIntro',
                    tooltipClass: 'samplesReady',
                    intro: "<p class=introHeader>Select Source Groups</p>This works like the previous step, except you are now selecting groups that you wish to use as potential source populations for determining ancestry",
                    old: "<br><br>As with the sample selection, source groups are searchable by name, country or age<br>You can can also select individual source samples rather than whole groups by clicking on the<br><b>INDIVIDUAL SAMPLES</b><br>switch",
                    activate: 'rightSelectinput',
                    validate: function() {
                        if (w.sampleArray.length < 1) {
                            setTimeout(() => {
                                if (w.introData.player) {
                                    w.introData.player.stop()
                                    w.introData.player.unload()
                                    delete w.introData.player;
                                }
                                setTimeout(() => {
                                    w.introData.player = new w.$howl({
                                        src: 'https://static.genoplot.com/media/runcalc.error.v2.mp3',
                                        autoplay: true,
                                        volume: 0.5,
                                        onend: function() {}
                                    });
                                    w.introData.played[0] = true;
                                }, 10)
                            }, 50)
                            return {
                                status: false,
                                activate: 'leftSelectinput'
                            }
                        } else {
                            return {
                                status: true
                            }
                        }
                    },
                    sound: {
                        media: ['https://static.genoplot.com/media/groups.v2.mp3']
                    },
                },
                {
                    element: '#runButton',
                    intro: `<p class=introHeader>Lets run the nMonte</p><p>Click the Run button!</p>`,
                    sound: {
                        media: ['https://static.genoplot.com/media/runcalc.step3.mp3']
                    },
                    tooltipClass: 'runButton',
                    validate: function() {
                        if (w.groupArray.length < 2) {
                            w.$stepAudio.play('https://static.genoplot.com/media/runstep.error.v2.mp3');
                            return {
                                status: false,
                                activate: 'rightSelectinput'
                            }
                        } else {
                            return {
                                status: true
                            }
                        }
                    }
                },
            ],
            resources: {
                samples: [4, 10, 1000],
                groups: [6, 20, 1000],
                checkfit: [20, 50, 100],
                batches: [200, 500, 1000],
                cycles: [200, 500, 1000],
                optimaFit: [false, false, true],
                individuals: [false, true, true]
            },
            gridKey: 0,
            modecomponents: {
                "HARAPPAWORLD": [
                    "S-Indian",
                    "Baloch",
                    "Caucasian",
                    "NE-Euro",
                    "SE-Asian",
                    "Siberian",
                    "NE-Asian",
                    "Papuan",
                    "American",
                    "Beringian",
                    "Mediterranean",
                    "SW-Asian",
                    "San",
                    "E-African",
                    "Pygmy",
                    "W-African"
                ],
                "EUROGENESK13": [
                    "North_Atlantic",
                    "Baltic",
                    "West_Med",
                    "West_Asian",
                    "East_Med",
                    "Red_Sea",
                    "South_Asian",
                    "East_Asian",
                    "Siberian",
                    "Amerindian",
                    "Oceanian",
                    "Northeast_African",
                    "Sub-Saharan"
                ],
                "MDLPWORLD22": [
                    'Pygmy',
                    'West-Asian',
                    'North-European-Mesolithic',
                    'Tibetan',
                    'Mesomerican',
                    'Arctic-Amerind',
                    'South-America_Amerind',
                    'Indian',
                    'North-Siberean',
                    'Atlantic_Mediterranean_Neolithic',
                    'Samoedic',
                    'Proto-Indo-iranian',
                    'East-Siberean',
                    'North-East-European',
                    'South-African',
                    'North-Amerind',
                    'Sub-Saharian',
                    'East-South-Aslan',
                    'Near_East',
                    'Melanesian',
                    'Paleo-Siberean',
                    'Austronesian'
                ],
                "EUROGENESK15": [
                    "Atlantic",
                    "Baltic",
                    "Eastern_Euro",
                    "West_Med",
                    "West_Asian",
                    "East_Med",
                    "Red_Sea",
                    "South_Asian",
                    "Southeast_Asian",
                    "Siberian",
                    "Amerindian",
                    "Oceanian",
                    "Northeast_African",
                    "Sub-Saharan"
                ],
                "DODECADK12B": [
                    "Gedrosia",
                    "Siberian",
                    "Northwest African",
                    "Southeast Asian",
                    "Atlantic Med",
                    "North European",
                    "South Asian",
                    "East African",
                    "Southwest Asian",
                    "East Asian",
                    "Caucasus",
                    "Sub Saharan"
                ],
                "GLOBE13": [
                    "Siberian",
                    "Amerindian",
                    "West African",
                    "Palaeo African",
                    "Southwest Asian",
                    "East Asian",
                    "Mediterranean",
                    "Australasian",
                    "Artic",
                    "West Asian",
                    "North European",
                    "South Asian",
                    "East African"
                ],
                "K36": [
                    "Amerindian",
                    "Arabian",
                    "Armenian",
                    "Basque",
                    "Central African",
                    "Central Euro",
                    "East African",
                    "East Asian",
                    "East Balkan",
                    "East Central Asian",
                    "East Central Euro",
                    "East Med",
                    "Eastern Euro",
                    "Fennoscandian",
                    "French",
                    "Iberian",
                    "Indo-Chinese",
                    "Italian",
                    "Malayan",
                    "Near Eastern",
                    "North African",
                    "North Atlantic",
                    "North Caucasian",
                    "North Sea",
                    "Northeast African",
                    "Oceanian",
                    "Omotic",
                    "Pygmy",
                    "Siberian",
                    "South Asian",
                    "South Central Asian",
                    "South Chinese",
                    "Volga-Ural",
                    "West African",
                    "West Caucasian",
                    "West Med"
                ]
            },
            progressStatus: "success",
            reqnum: 0,
            subResults: [],
            value: 45,
            max: 100,
            series2: [],
            filterResults: {},
            rowsSelected: false,
            barType: 'radialBar',
            chartHeight: 480,
            barHeight: 25,
            chartColors: [
                ["#1f78b4", "#a6cee3", "#33a02c", "#b2df8a", "#e31a1c", "#fb9a99", "#ff7f00", "#fdbf6f", "#6a3d9a", "#cab2d6", "#b15928", "#ffff99"],
                ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#676767"],
                ["#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#abdda4", "#66c2a5", "#3288bd"],
                ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
                ['#3b5998', '#F44336', '#828483', '#2e294e', '#1b998b', '#921236', '#e2c044', '#d7263d'],
                ['#a6611a', '#dfc27d', '#80cdc1', '#018571', '#d7191c', '#fdae61', '#a6d96a', '#1a9641']
            ],
            chartReady: false,
            saveLabel: this.loading === true ? '' : '',
            components: this.$store.getters.get('g25chartComponents') ? this.$store.getters.get('g25chartComponents') : [],
            size: 8,
            margin: 12,
            color: "white",
            cacheVersion: 0,
            maxSelects: 4,
            publicSamples: [],
            publicGroups: [],
            publicRawSamples: [],
            publicRawGroups: [],
            publicCalcs: [],
            schemaModelFields: {
                label: {
                    editable: false
                }
            },
            maxGroupExceeded: "",
            maxExceededMessage: "",
            multiselectValue: "",
            autocompleteValue: "",
            sampledata: this.$store.getters.get('g25chartSeries') ? this.$store.getters.get('g25chartSeries') : [],
            chartOptions: {
                plotOptions: {
                    radialBar: {
                        startAngle: 0,
                        endAngle: 270,
                        track: {
                            show: true,
                            background: '#a6a6a6',
                            opacity: 0.08
                        },
                        hollow: {
                            margin: 5,
                            size: '30%',
                            background: 'transparent',
                            image: undefined,
                        },
                        dataLabels: {
                            name: {
                                show: false,

                            },
                            value: {
                                show: false,
                            }
                        }
                    }
                },
                updated: Date.now(),
                colors: ['#1ab7ea', '#0084ff', '#39539E', '#0077B5'],
                labels: [1, 2, 3, 4],
                legend: {
                    show: true,
                    floating: true,
                    position: 'left',
                    labels: {
                        useSeriesColors: false,
                    },
                    markers: {
                        size: 0
                    },
                    format: function(seriesName, opts) {
                        if (seriesName.toString().substring(0, 4) === '<div') {
                            return opts.w.globals.series[opts.seriesIndex] ? ("<div class='result-tip'>" + opts.w.config.comps[opts.seriesIndex].replace(/_/g, " ") + "</div><b><div class='result-tip-value'>" + opts.w.globals.series[opts.seriesIndex].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>") : ("<div class='result-tip faded'>" + opts.w.config.comps[opts.seriesIndex].replace(/_/g, " ") + "</div><b><div class='result-tip-value faded'>" + opts.w.globals.series[opts.seriesIndex].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>")
                        } else {
                            return opts.w.globals.series[opts.seriesIndex] ? ("<div class='result-tip'>" + seriesName.replace(/_/g, " ") + "</div><b><div class='result-tip-value'>" + opts.w.globals.series[opts.seriesIndex].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>") : ("<div class='result-tip faded'>" + seriesName.replace(/_/g, " ") + "</div><b><div class='result-tip-value faded'>" + opts.w.globals.series[opts.seriesIndex].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>")
                        }
                    },
                    itemMargin: {
                        horizontal: 1,
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            height: 320
                        }
                    }
                }]
            },
            placeHolderG25: 'MySample1,0.1311242,0.1351371,0.0663244,0.0522766,0.0414375,0.0193681,0.0051037,0.0074196,0.0033759,-0.0026263,-0.0053512,0.0034099,-0.0084527,-0.0068843,0.0187853,0.0059151,-0.0067217,0.0019898,0.0033983,0.0043212,0.0055064,0.002361,0.0007352,0.0138402,0.000448\nMySample2,0.1274407,0.1341783,0.0602712,0.0440759,0.0408435,0.0163974,0.0054023,0.0072633,0.0042087,0.0019245,-0.0056347,0.0044274,-0.0098456,-0.0086761,0.01783,0.0056231,-0.0065161,0.0017477,0.0039087,0.0028161,0.00448,0.0033848,-0.0000051,0.0138921,-0.0006557\nMySample3,0.1318551,0.137043,0.0617883,0.044013,0.0392299...',
            placeHolderCustom: 'custom,12.00,15.00,6.00,0.00,6.00,1.00,0.00,0.00,3.00,5.00,0.00\nEnglish,13.00,14.00,6.00,5.00,4.00,1.00,0.00,0.00,1.00,0.00,0.00\nFrench,12.00,15.00,6.00,3.00,4.00,1.00,0.00,0.00,1.00,2.00,1.00\nGerman,13.00,13.00,8.00,7.00,4.00,2.00,1.00,1.00,1.00,1.00,0.00\nPolish,13.00,12.00,9.00,9.00,4.00,4.00,1.00,2.00,0.00,4.00,0.00\nTurkish,5.00,15.00,5.00,11.00,0.00,5.00,2.00,0.00,5.00,1.00,1.00\nLebanese,8.00,14.00,6.00,9.00,1.00,3.00,0.00,1.00,1.00,1.00,1.00\nAfrican,10.00,4.00,11.00,8.00,1.00,1.00,1.00,1.00,0.00,3.00,3.00\nGreek,12.00,15.00,2.00,3.00,2.00,1.00,1.00,1.00,0.00,3.00,1.00\nRussian,13.00,12.00,7.00,6.00,4.00,3.00,1.00,1.00,0.00,2.00,0.00\nMoroccan,5.00,13.00,1.00,7.00,3.00,4.00,3.00,1.00,7.00,3.00,1.00\nMongolian,12.00,15.00,2.00,5.00,1.00,2.00,0.00,1.00,0.00,2.00,0.00\nSpanish,13.00,15.00,4.00,1.00,5.00,1.00,0.00,0.00,2.00,4.00,0.00\nArmenian,11.00,10.00,2.00,1.00,3.00,0.00,0.00,0.00,4.00,2.00,0.00\nRomanian,10.00,5.00,2.00,5.00,3.00,2.00,0.00,0.00,3.00,3.00,0.00\nIndian,13.00,15.00,3.00,2.00,2.00,1.00,1.00,1.00,0.00,3.00,0.00',
        }
    },
    beforeMount() {},
    beforeCreate() {},
    created: async function() {
        this.g25mounted = false;
        this.simulating = false;
        this.filteredOptions = [];
        this.filteredGroupOptions = [];
        this.userSamples = [];
        if (this.user && this.user.username) this.init();
        let w = this;
        this.debouncedValidateCSV = debounce(this.validateCSV, 200)
        this.debouncedSearchSamples = debounce(this.searchSamples, 250)
        this.debouncedSearchGroups = debounce(this.searchGroups, 250)
        this.gridOptions = {
            scrollbarWidth: 20,
            rowHeight: 30,
            suppressHorizontalScroll: false,
            enableBrowserTooltips: false,
            animateRows: false,
            pagination: this.switches.paginateResults ? true : false,
            paginationPageSize: 20,
            floatingFilter: this.switches.filterResults ? true : false,
            sortingOrder: ['desc', 'asc'],
            onFirstDataRendered: function(params) {},
            onModelUpdated: function(params) {
                setTimeout(function() {
                    params.api.sizeColumnsToFit();
                }, 100)
            },
            onGridReady: function() {
                let height = w.$refs['mapwrapper'] && w.$refs['mapwrapper'].$el ? w.$refs['mapwrapper'].$el.clientHeight : 0
                if (height) w.gridHeight = height
                window.addEventListener('resize', w.resizeGrid)
            }
        }

    },
    beforeDestroy() {
        this.$eventBus.$off('appEvents', this.appEvents)
        this.$store.commit('change', {
            topClass: false
        })
        if (typeof(g25worker) != 'undefined') {
            requestIdleCallback(() => {
                console.log('Terminating G25 worker')
                g25worker.terminate()
            })
        }
        let w = this;
        if (w.$intro) {
            w.$intro.onchange(() => {});
            w.$intro.onbeforechange(() => {});
            w.$intro.oncomplete(() => {});
            w.$intro.onexit(() => {});
            w.$intro.exit();
            w.$intro._options = w.introOptions;
            w.$intro._currentStep = undefined;
        }
        window.removeEventListener('message', this.handleFrameMessage)
        window.removeEventListener('resize', this.resizeEChart)
        window.removeEventListener('resize', this.resizeGrid)
    },
    mounted: async function() {
        console.log(`Mount started ${Date.now() - routeStart} ms`)
        this.switches.scaled = true;
        this.syncStore('switches.scaled')
        let nstart = Date.now()
        let w = this;
        requestIdleCallback(async () => {
            this.$toasted.clear()
            this.cleared = Date.now()
            this.$store.commit('change', {
                spinner: false
            })
            w.src = false;
            if (typeof(g25worker) != 'undefined') {
                g25worker.status()
            }
            this.showshare = false
            this.saveReady2 = false
            //mounted
            window.addEventListener('message', this.handleFrameMessage)
            this.$store.commit('change', {
                g25Loaded: true
            })

            if (this.user && this.user.username) {
                this.proxyUser = this.user.username
            }
            this.initiated = Date.now()
            this.queryTimeStamp = Date.now();
            let header = document.querySelector('body #app #page .ag-theme-balham.rotated .ag-header')
            let header2 = document.querySelector('body #app #page .ag-theme-balham .ag-header')
            let height
            if (header) {
                height = (header.offsetHeight);
                header.style.setProperty('--mainHeaderSpacer', (186 - height) + 'px')
            } else {
                if (header2) {
                    height = 131
                    header2.style.setProperty('--mainHeaderSpacer', (186 - height) + 'px')
                }
            }
            this.mapReady = false;
            this.activePath = false;
            this.lastMarkerState = false;
            this.activeName = false;
            this.activeContent = false;
            this.exporting = false;
            this.markerArea = false;
            this.markerState = false;
            let sunOptions = this.sunOptions;
            let levels = sunOptions.series.levels;
            if (this.theme) {
                levels[2].label.color = '#f2f2f2'
            } else {
                levels[2].label.color = '#444'
            }
            this.sunOptions = sunOptions;
            window.addEventListener("resize", this.resizeEChart);
            //localStorage.setItem('g25Rerun', 'g25|Genoplot%2F17efba3783a')
            let rerun = localStorage.getItem('g25Rerun')
            if (rerun) {
                rerun = decodeURI(rerun).replace('%2F', '/')
                this.chartReady = false;
                this.g25Rerun = `${rerun.split('|')[0]}-shares.genoplot.com/${rerun.split('|')[1].replace(/:/,'/')}/samples`
                this.resetGroups()
                this.resetSamples()
                this.collapsed = true;
                localStorage.removeItem('g25Rerun')
                let sharekey = rerun
                this.getShare(sharekey);
            } else {
                var key = this.$store.getters.get('g25chartKey')
                var json = this.$store.getters.get('g25chartJSON')
                if (key && json && json.length > 0) {
                    this.processJSON(key)
                } else {
                    this.$store.commit('change', {
                        spinner: false
                    })
                }
            }
            this.toggleTheme()
            this.maintenance = false;
            this.startedcount = 0
            this.$store.commit('change', {
                topClass: false
            })
            this.$eventBus.$on('appEvents', this.appEvents)
            let theme = localStorage.getItem('genoTheme');
            if (theme && theme == 'dark') {
                this.theme = true;
            } else {
                this.theme = false;
            }
            if (!this.theme) {
                this.map.tooltip.backgroundColor = '#fff'
                this.map.tooltip.textStyle = {
                    color: 'gray'
                }
                this.map.visualMap.inRange.color = ['#1c425f88', '#1c425f88', '#1c425f88', '#1c425f88', '#1c425f88']
                this.map.geo.itemStyle = {
                    normal: {
                        areaColor: '#2c526f55',
                        areaColor: '#1c425f88',
                        borderColor: '#fff',
                    },
                    emphasis: {
                        areaColor: '#2c526f',
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        shadowBlur: 20,
                        borderWidth: 2,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            } else {
                this.map.visualMap.inRange.color = ["rgb(50, 60, 72)", "rgb(50, 60, 72)", "rgb(50, 60, 72)", "rgb(50, 60, 72)", "rgb(50, 60, 72)"]
                this.map.tooltip.backgroundColor = '#000000bb'
                this.map.tooltip.textStyle = {
                    color: 'white'
                }
                this.map.geo.itemStyle = {
                    normal: {
                        areaColor: '#323c48',
                        borderColor: 'silver'
                    },
                    emphasis: {
                        areaColor: '#729bb5',
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        shadowBlur: 20,
                        borderWidth: 2,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
            this.embed = false
            requestIdleCallback(async () => {
                let currentDT = Math.floor(Date.now() / 1000)
                let cache = localStorage.getItem('cacheVer') ? JSON.parse(localStorage.getItem('cacheVer')) : {
                    groups: {
                        g25: currentDT
                    },
                    samples: currentDT,
                    tos: 0,
                    calcVersion: currentDT
                }
                var UTF8to16 = function(convertMe) {
                    var out = ""
                    for (var i = 0; i < convertMe.length; i += 2) {
                        var charCode = convertMe.charCodeAt(i) * 256;
                        charCode += convertMe.charCodeAt(i + 1);
                        out += String.fromCharCode(charCode)
                    }
                    return out;
                }
                var queryParam = '?v=0.'
                var stage = this.$store.getters.get('env') === 'production' ? '' : 'staging/';
                let publicCalcs = window.g25cache && window.g25cache.getCalculators ? window.g25cache.getCalculators : await this.$dbCache.getCalculators(cache, 'g25', stage)
                this.publicCalcs = JSON.parse(JSON.stringify(publicCalcs))
                w.publicGroups = window.g25cache && window.g25cache.getG25Groups ? window.g25cache.getG25Groups : await this.$dbCache.getG25Groups(cache, 'g25', stage)
                w.publicSamples = window.g25cache && window.g25cache.getSampleGroups ? window.g25cache.getSampleGroups : await this.$dbCache.getSampleGroups(cache, 'g25', stage)
                if (window.location.search && window.location.search.substr(0, 11) == '?calculator') {
                    w.spinner = true;
                    w.$nextTick(() => {
                        let shared = decodeURI(window.location.search.replace(/\?calculator=/, ''))
                        if (shared.split('%3A').length > 1) {
                            let calculator = shared.split('%3A')[1]
                            let user = shared.split('%3A')[0]
                            let calc = this.publicCalcs.find(x => decodeURI(x.calculator) == decodeURI(calculator) && decodeURI(x.user) == decodeURI(user))
                            if (calc) {
                                this.resetSamples();
                                this.resetGroups()
                                let mode = calc.type
                                this.mode = mode;
                                this.resetMode(mode)
                                this.switches.calculator = true
                                this.setCalculator()
                                this.groupArray = [calc]
                                this.switches.groupSamples = false;
                                this.syncStore('switches.groupSamples')
                            }
                        }
                        w.spinner = false;
                    })
                }
                let customGroups = []
                let output = []
                w.publicSamples.forEach(x => {
                    let indexes = []
                    x.samples.map((sample, i) => {
                        x.originalGroup = sample.group
                        if (sample.alias) {
                            x.group = sample.alias
                            x.alias = sample.alias
                        }
                        if (sample.customgroup) {
                            indexes.push(i)
                            let customIndex = customGroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customGroups[customIndex].samples.push(sample)
                            } else {
                                customGroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    label: sample.customgroup + ' [' + sample.group + ']',
                                    type: sample.mode,
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    if (indexes.length > 0) {
                        x.samples = x.samples.filter((value, index) => indexes.indexOf(index) == -1)
                    }
                })
                this.customGroups = customGroups
                w.publicRawGroups = window.g25cache && window.g25cache.getRawGroupsCache ? window.g25cache.getRawGroupsCache : await this.$dbCache.getRawGroupsCache(cache, 'g25', stage)
                w.publicRawSamples = window.g25cache && window.g25cache.getRawGroupedSamplesCache ? window.g25cache.getRawGroupedSamplesCache : await this.$dbCache.getRawGroupedSamplesCache(cache, 'g25', stage)
                if (this.sampleArray && this.sampleArray[0] && ((this.sampleArray[0].entityType == 'user' && this.sampleArray[0].type !== this.mode) || (this.sampleArray[0].entityType != 'user' && (this.sampleArray[0].mode !== this.mode) || (this.mode == 'G25' && (this.sampleArray[0].mode != 'G25' && this.sampleArray[0].mode != undefined))))) {
                    this.resetSamples();
                }
                if (this.switches.calculator && this.groupArray && this.groupArray[0] && this.groupArray[0].calculator && this.groupArray[0].type && this.groupArray[0].type !== this.mode || this.switches.calculator && this.groupArray[0] && !this.groupArray[0].calculator || !this.switches.calculator && this.groupArray && this.groupArray[0] && this.groupArray[0].calculator || this.groupArray && this.groupArray[0] && this.groupArray[0].type && this.groupArray[0].type !== this.mode) {
                    this.resetGroups()
                }
            })
            console.log(`nMonte mounted: ${Date.now() - nstart} ms`)
            if (this.newUser) {
                this.startTour()
                }
            this.g25mounted = true;
        });
    },
    components: {
        [Button.name]: Button,
        [Checkbox.name]: Checkbox,
        TransitionExpand,
        SamplesModal,
        CalcSamplesModal,
        //CalcModal,
        CheckFitsModal,
        OraclesModal,
        EditSamplesModal,
        AgGridVue,
        rightpanel,
        CollapseItem,
        Collapse,
        Tabs,
        TabPane,
        [Switch.name]: Switch,
        VueSlider,
        Social
    },
    directives: {
        'dragscroll': dragscroll
    },
    methods: {
        async runAnalyzeResults() {
            this.recordEvent('analyzeButton', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            if (this.secondaryTabs == 'table' && this.gridApi && this.gridApi.getSelectedRows && this.gridApi.getSelectedRows() && this.gridApi.getSelectedRows().length) {
                let selectedRows = this.gridApi.getSelectedRows();
                let chartindex = 0;
                chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '').replace(/_/g, ' ')} (${x.alias.split(':')[0].replace(/_/g, ' ')})`.trim() == selectedRows[0].sample.replace(/_/g, ' ').trim())
                this.currentChartIndex = chartindex;
            } else {
                let profile = this.categories[this.currentIndex]
                let chartindex = 0;
                chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[0].replace(/-raw/, '').replace(/_/g, ' ')} ► ${x.alias.split(':')[1]}`.replace(/_/g, ' ').trim() == profile.replace(/-raw/, '').replace(/_/g, ' ').trim())
                this.currentChartIndex = chartindex;
            }
            this.currentChartIndex = this.currentChartIndex < 0 ? 0 : this.currentChartIndex
            await analyzeResults(this, invokeAnalyzeResults, 'nmonte')
        },
        startTour() {
            let w = this;
            w.$modal.hide('dialog');
            let buttons = [{
                    title: 'Yes',
                    default: true,
                    handler: async () => {
                        w.$modal.hide('dialog');
                        w.$stepAudio.unlockAudioContext()
                        w.$stepAudio.play('https://static.genoplot.com/media/runcalc.step1.mp3', 11);
                        setTimeout(() => {
                            w.$nextTick(() => {
                            w.startIntro()
                            })
                            w.spinner = false;
                        }, g25 ? 500 : 50)
                    } // Button click handler
                },
                {
                    title: 'No',
                    handler: () => {
                        w.$modal.hide('dialog');
                    } // Button click handler
                }
            ]
            this.$modal.show('dialog', {
                title: ' ',
                text: '<p style="font-size: 1.3em;font-weight:700;">Would you like to run a G25 model?</p>',
                class: 'alert green',
                buttons: buttons
            })
        },
        async createSim() {
            let w = this;
            let samples = w.csv.split('\n').filter(x => x)
            let results = []
            let queryResults = []
            let queryErrors = []
            let errors = [];
            w.crSim = 0;
            if (samples.length) {
                w.simulating = true;
                try {
                    let simArray = samples.map(async record => {
                        let sample = record.split(',')[0]
                        let length = !w.mode || w.mode == 'G25' ? 25 : w.mode && w.modecomponents[w.mode] ? w.modecomponents[w.mode].length : 25
                        let coords = record.split(',').slice(-1 * length).join(',')
                        let subId = w.user.username + Date.now()
                        let params = {
                            sub: w.user.username,
                            id: subId,
                            sample: w.user.username + ':' + sample,
                            coords: coords,
                            sim: false,
                            quiet: true,
                            mode: w.mode
                        }
                        const observable = w.$apollo.subscribe({
                            query: onPublishResultSub,
                            variables: {
                                id: subId
                            }
                        });
                        let checkSub = function() {
                            if (subscription !== false) {
                                endSubscription()
                                var status = `${new Date().toLocaleString()}: Query ${subId} did not complete ${w.reqnum} subqueries/${w.sampleArray.length} within 15 seconds of first subquery`
                                console.log(status);
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'setError',
                                    component: 'nav',
                                    params: status
                                })
                            }
                            w.simulating = false;
                        }
                        let subTimer;
                        w.errorArray = []
                        var noresultTimer = setTimeout(function() {
                            checkSub();
                            clearTimeout(subTimer);
                        }, 60000)
                        const realtimeResults = function realtimeResults(data) {
                            try {
                                var result = JSON.parse(data.data.onPublishResult.result)
                                if (result && result.coords && !result.error) {
                                    w.crSim = w.crSim - 1;
                                    let coords = result.sample + ',' + result.coords;
                                    queryResults.push(coords);
                                    if (w.crSim == 0) {
                                        endSubscription();
                                        w.mode = 'G25'
                                        w.resetMode('G25')
                                        w.$nextTick(() => {
                                            w.csv = ''
                                            queryResults.map(x => {
                                                console.log('x', x);
                                                w.csv = w.csv + x + '\n'
                                            })
                                        })
                                    }
                                    if (queryResults.length === 0) {
                                        subTimer = setTimeout(function() {
                                            checkSub();
                                        }, 15000)
                                    }
                                }
                            } catch (err) {
                                console.log(err)
                            }
                        }
                        let data = await w.$apollo.query({
                            query: invokeSimQuery,
                            variables: {
                                event: JSON.stringify(params)
                            }
                        })

                        function endSubscription() {
                            console.log('ending subscription...');
                            subscription.unsubscribe();
                            subscription = false;
                            w.simulating = false;
                        }
                        let subscription = observable.subscribe({
                            next: realtimeResults,
                            complete: console.log,
                            connect: function(evt) {
                                console.log('connected ', evt)
                            },
                            error: function(error) {
                                console.log('subscription error', error)
                            }
                        })
                        if (data && data.data && data.data.invokeSim && data.data.invokeSim.status) {
                            results.push(data.data)
                            w.crSim = w.crSim + 1;
                            console.log(`Simulation created for ${params.sample} (${params.mode})`)
                        } else {
                            console.log(`Simulation failed for ${params.sample} (${params.mode})`, data)
                            errors.push(data)
                        }
                    })
                    await Promise.all(simArray);
                } catch (err) {
                    w.simulating = false;
                    w.$modal.show('dialog', {
                        class: 'warning',
                        title: 'Error',
                        text: err.message || err
                    })
                }
            }
        },
        async convertToJson() {
            let w = this;
            try {
                let components = w.modecomponents[w.mode] || w.modecomponents.HARAPPAWORLD;
                let image = w.imageDrop;
                w.spinner = true;
                let data = await w.$apollo.query({
                    query: getImageJsonQuery,
                    variables: {
                        data: JSON.stringify({
                            file: image,
                            components: components
                        })
                    },
                    fetchPolicy: 'network-only'
                })
                if (data && data.data && data.data.getImageJson && data.data.getImageJson.result) {
                    let result = JSON.parse(data.data.getImageJson.result)
                    if (!result.json || !result.paste || !result.coords || (result.json && typeof(result.json) == 'object' && Object.values(result.json).every(v => v == 0))) {
                        let error = result.error ? result.error : 'Unable to parse Image';
                        w.$modal.show('dialog', {
                            class: 'warning',
                            title: 'Error',
                            text: error
                        })
                        w.spinner = false;
                        return;
                    }
                    if (result.coords) {
                        let count = !w.customSampleCount || w.customSampleCount == 0 ? 1 : w.customSampleCount + 1;
                        let coords = result.coords.replace(/^sample,/, `sample${count},`)
                        w.csv = w.csv && w.customSampleCount > 0 ? w.csv + '\n' + coords : coords;
                    }
                } else {
                    w.$modal.show('dialog', {
                        class: 'warning',
                        title: 'Error',
                        text: 'Unable to parse Image'
                    })
                }
                w.spinner = false;
            } catch (err) {
                w.spinner = false;
                console.log('err', err.message || err)
                w.$modal.show('dialog', {
                    class: 'warning',
                    title: 'Error',
                    text: err.message || err
                })
            }
        },
        async onDrop(e) {
            let w = this;
            w.imageDrop = undefined;
            try {
                w.isDragOver = false
                const file = e.dataTransfer.files[0]
                if (file && file.type.startsWith('image/')) {
                    w.readFile(file)
                }
            } catch (err) {
                console.log(err);
                w.spinner = false;
                w.$modal.show('dialog', {
                    class: 'warning',
                    title: 'Error',
                    text: err.message || err
                })
            }
        },
        async onPaste(e) {
            let w = this;
            w.imageDrop = undefined
            const text = e.clipboardData.getData('text/plain')
            if (text) {
                try {
                    w.csv = w.csv && w.customSampleCount > 0 ? w.csv + '\n' + text : text;
                } catch (err) {
                    console.log(err);
                }
            } else {
                const files = e.clipboardData.files
                if (files.length) {
                    const file = files[0]
                    if (file.type.startsWith('image/')) {
                        w.readFile(file)
                    }
                }
            }
        },
        async readFile(file) {
            const reader = new FileReader()
            let w = this;
            reader.onload = async evt => {
                w.imageDrop = evt.target.result
                let data = await w.convertToJson()
            }
            reader.readAsDataURL(file)
        },
        destroyIntro() {
            let w = this;
            if (w.introData.player) {
                w.introData.player.stop()
                w.introData.player.unload()
                delete w.introData.player;
            }
            w.introData = {};
            if (w.$intro) {
                w.$intro.onchange(() => {});
                w.$intro.onbeforechange(() => {});
                w.$intro.oncomplete(() => {});
                w.$intro.onexit(() => {});
                w.$intro.exit();
                w.$intro._options = w.introOptions;
                w.$intro._currentStep = undefined;
            }
        },
        requiresSub(option) {
            let w = this;
            w.switches.optimaFit = 0;
            w.syncStore('switches.optimaFit')
            let goldsub = w.subs && w.subs.subType.includes('gold') ? true : false
            let buttons = [{
                title: 'Cancel',
                default: true,
                handler: () => {
                    w.closable = false;
                    w.$modal.hide('dialog');
                } // Button click handler
            }]
            if (!goldsub) {
                buttons.unshift({
                    title: 'Subscribe',
                    handler: () => {
                        w.createNew = false;
                        w.$modal.hide('dialog');
                        w.recordEvent('subButtonAnalyze', {
                            'event_category': 'function',
                            'event_label': 'User initiated'
                        })
                        w.$eventBus.$emit('appEvents', {
                            exec: 'checkSubStatus',
                            component: 'nav',
                        })
                    } // Button click handler
                })
            }
            w.$modal.show('dialog', {
                title: 'Subscription required',
                text: "This feature requires a PRO subscription",
                class: 'alert',
                buttons: buttons
            })
        },
        sampleInitials(options) {
            let name = options.user ? options.user : (options.alias || options.group)
            let initials = name ? name.substr(0, 1).toUpperCase() : ''
            return initials;
        },
        customDescription(options) {
            let description = options.alias ? `${options.sample}: ${options.description.replace(new RegExp(options.group, 'g'), options.alias)}` : `${options.sample}: ${options.description}`
            console.log('description', description);
            return description.replace(/<.*>/ig, '')
        },
        setHeight() {
            console.error('finished!!!!!')
        },
        getSampleDetail(option) {
            let w = this;
            let name = option.label ? option.label : w.customSample(option)
            let description = option.description || false
            let ethnicity = option.ethnicity || false
            if (option.origin) ethnicity = ethnicity ? ethnicity + ' from ' + option.origin : option.origin
            let detail = `${name}<br>${description ? description + '<br>' : ''}${ethnicity || ''}`
            return detail
        },
        selectElementContents: function(el) {
            var range = document.createRange();
            range.selectNodeContents(el);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        },
        getFrameSource: async function() {
            let w = this;
            return new Promise((resolve, reject) => {
                let img = new Image()
                img.onload = () => {
                    console.log('img ping worked')
                    resolve(true)
                }
                img.onerror = (err) => {
                    console.log('img ping failed')
                    reject(true)
                }
                img.async = true
                img.src = w.$store.getters.get('env') === 'staging' ? "https://devdiscuss.genoplot.com/assets/images/ping.png?iframe=" + Date.now() : "https://discussions.genoplot.com/assets/images/ping.png?iframe=" + Date.now()
            })
        },
        handleFrameMessage: function(message) {
            //console.log(message);
            let w = this;
            if (message && message.data && message.origin.slice(-12) == 'genoplot.com') {
                if (message.data.from == 'discussions' && message.data.event == 'action' && message.data.action && message.data.component) {
                    w.execFunc({
                        exec: message.data.action,
                        component: message.data.component,
                        params: message.data.params || undefined
                    })
                }
                if (message.data.source == 'genoplot' && message.data.event == 'iframedError') {
                    console.log(message.data);
                }
            }
        },
        execFunc(remoteFunc) {
            if (remoteFunc.exec == 'navigate' && remoteFunc.component == 'discussions') {
                console.log('navigating', remoteFunc.params);
                this.$router.push(remoteFunc.params)
            } else {
                this.$eventBus.$emit('appEvents', remoteFunc)
            }
        },
        showDetails(slug) {
            console.log('showing ' + slug);
            this.spinner = true
            this.maintenance = false;
            this.embed = true
            let qs = `?iframe=true&embedded=true`
            let theme = this.$store.getters.get('slider')['theme'] ? this.$store.getters.get('slider')['theme'].value : 'system'
            qs = qs + `&theme=${theme}`
            let url = this.$store.getters.get('env') === 'staging' ? `https://devdiscuss.genoplot.com/topic/${slug}${qs}` : `https://discussions.genoplot.com/topic/${slug}${qs}`
            this.getFrameSource().then(() => {
                this.src = url
                this.showshare = true;
            }).catch(err => {
                this.spinner = false;
                this.maintenance = true;
                this.showshare = true;
            })
        },
        onSubmit: function(evt) {
            let w = this;
        },
        searchGroups: function(input) {
            let search = input.toLowerCase();
            let options = this.groupOptions;
            let searchmode = this.mode == 'G25' ? true : false
            const {
                filteredData,
                filterString
            } = filterData(search, options, searchmode ? 'refs' : 'label');
            //console.log('Filter String:', filterString);
            this.filteredGroupSamples = filteredData && filteredData.length ? filteredData.slice(0, 1000) : [{
                empty: true
            }]
            return;
        },
        searchSamples: function(input) {
            let search = input.toLowerCase();
            let options = this.sampleJSON.filter(x => x.samples.filter(y => y.mode === 'raw' || y.mode === this.mode || y.type === this.mode).length > 0)
            console.log(search, options.length);
            if (!input || input.length < 3) {
                this.filteredOptions = options.slice(0, 1000)
                return;
            }
            const {
                filteredData,
                filterString
            } = filterData(search, options, 'refs', 'samples');
            //console.log('Filter String:', filterString);
            this.filteredOptions = filteredData && filteredData.length ? filteredData.slice(0, 1000) : [{
                empty: true
            }]
            return
        },
        validateCSV: function() {
            let w = this;
            w.customSampleCount = 0;
            if (this.csv && this.csv.length > 0) {
                try {
                    let csv = this.csv.split('\n').filter(x => x != '')
                    let returnval = true
                    let numeric = true
                    let unique = true
                    let dupes = false
                    let uniquesArr = []
                    let dupesArr = []
                    let samplelength = true
                    let existing = 0
                    if (!this.isAdmin) {
                        if (this.sampleArray.length + csv.length > w.resources.samples[w.subType]) {
                            this.csvValidation = `Too many samples. Maximum is ${w.resources.samples[w.subType]} samples per run`
                            return false
                        }
                    }
                    let length = !w.mode || w.mode == 'G25' ? 25 : w.mode && w.modecomponents[w.mode] ? w.modecomponents[w.mode].length : 25
                    csv.map(x => {
                        if (x.split(',').length !== length + 1) returnval = false;
                        x.split(',').map((y, n) => {
                            if (n > 0 && isNaN(parseFloat(y))) numeric = false
                        })
                    })
                    if (returnval && numeric) {
                        let message
                        let names = csv.map(x => x.split(',')[0].split(':').slice(-1)[0])
                        names.map(x => {
                            if (x.length < 2) {
                                samplelength = false
                            }
                        })
                        if (!samplelength) {
                            this.csvValidation = 'Sample names need to be at least 2 characters long';
                            return false
                        }
                        if (names.length !== [...new Set(names)].length) {
                            message = `Sheet contains ${names.length - [...new Set(names)].length} duplicated sample names`
                            dupes = true
                        }
                        if (dupes) {
                            message = !unique && dupes ? `${names.length - [...new Set(names)].length} duplicated name(s) in sheet and ${existing} existing or invalid sample name(s)` : dupes ? `Sheet contains ${names.length - [...new Set(names)].length} duplicated sample name(s)` : !unique && !dupes ? `Sheet contains ${existing} existing or invalid sample name(s) ${JSON.stringify(uniquesArr).replace(/"/g,'')}` : `Sheet contains ${existing} existing sample name(s)`
                            this.csvValidation = message
                            return false
                        }
                        this.csvValidation = ''
                        //w.formstate.pasted._setValidity(true);
                        w.customSampleCount = csv.length
                        //console.log(w.formstate);
                        this.unchanged = false;
                        this.queryTimeStamp = Date.now();
                        return true
                    } else {
                        let message = false
                        w.customSampleCount = 0;
                        if (!returnval) message = `Some rows do not contain ${length} values`
                        if (!numeric) message = message ? message + ' & ' + 'some values are not numeric' : 'Some values in provided data are not numeric'
                        this.csvValidation = message
                        return false
                    }
                } catch (err) {
                    console.log(err)
                    this.csvValidation = 'Error validating CSV data'
                    return false
                }
            } else {
                return
            }
        },
        isAllOptionsSelectedInGroup(group, custom) {
            //console.log(Date.now(),group.group, this.sampleArray.filter(x => x.customgroup  == group.group).length)
            if (this.sampleArray.filter(x => (custom ? x.customgroup : x.group) == group.group).length == group.samples.length) {
                return true
            } else {
                return false
            }
            /*
            return group.samples.every((sample) => {
                return this.sampleArray.some((val) => val.sample === sample.sample)
            });
            */
        },
        removeGroupOrOption(data, removeOptionFunction) {
            if (data.samples) {
                if (data.customgroup) {
                    this.sampleArray = this.sampleArray.filter(x => x.customgroup !== data.group)
                } else {
                    this.sampleArray = this.sampleArray.filter(x => x.group !== data.group)
                }
            } else {
                removeOptionFunction(data);
            }
        },
        authState: function(info) {
            if (info === 'signedIn') {
                this.init
            }
        },
        copyCalc: function(data) {
            let url = `https://genoplot.com/g25?calculator=${data.option.user}:${encodeURI(data.option.label)}`
            copy(url);
            this.$modal.show('dialog', {
                class: 'alert',
                title: 'Link to sharable calculator',
                text: `The <a target='_blank' href=${url}> link </a> for this calculator has been copied to the clipboard<br/>`,
            })
        },
        onLoad: function(evt) {
            console.log('loaded', evt)
            if (evt.target.src != '') {
                this.frameDisplay = 'block'
                this.spinner = false;
                this.frameReady = true
                this.saveReady2 = true
            }
        },
        closeDrawer: function() {
            this.frameDisplay = 'none'
            this.showshare = false
            this.saveReady2 = false
            this.frameReady = false
            this.spinner = false;
            this.embed = false;
        },
        putImage: async function(svg, prefix, path, sigparams, element, type) {
            console.log('putting', prefix, path, sigparams, element, type)
            let w = this;
            w.spinner = true;
            if (type == 'png') {
                try {
                    async function convertSvgToPngBlob(svgString) {
                        const div = document.createElement('div');
                        div.style.position = 'absolute';
                        div.style.left = '-9999px';
                        div.innerHTML = svgString.trim();
                        document.body.appendChild(div);
                        try {
                            let bgcolor = w.theme ? '#14191f' : '#f2f2f2';
                            const blob = await domtoimage.toBlob(div.firstChild, {
                                bgcolor: bgcolor
                            });
                            svg = await blob.arrayBuffer();
                            document.body.removeChild(div);
                        } catch (error) {
                            console.log('error', error);
                            document.body.removeChild(div);
                            w.spinner = false;
                        }
                    };
                    let blob = await convertSvgToPngBlob(svg);
                } catch (err) {
                    console.log('err', err)
                    document.body.removeChild(div);
                    w.spinner = false;
                }
            };
            let data = await w.$apollo.query({
                query: getFilebaseSignatureQuery,
                variables: {
                    params: JSON.stringify(sigparams)
                },
                fetchPolicy: 'network-only'
            })
            if (data && data.data && data.data.getFilebaseSignature && data.data.getFilebaseSignature.result) {
                let result = JSON.parse(data.data.getFilebaseSignature.result);
                let signedUrl = result.url;
                let options = {
                    headers: {
                        'Content-Type': sigparams.contentType,
                        'Content-Encoding': 'gzip',
                        'Cache-Control': 'max-age=86400'
                    }
                }
                const operation = w.$retry.operation({
                    retries: 3,
                    factor: 2,
                    minTimeout: 125,
                    maxTimeout: 1000,
                    randomize: false,
                });
                operation.attempt(async (currentAttempt) => {
                    w.spinner = true;
                    console.log('sending request: ', currentAttempt, ' attempt');
                    try {
                        axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(svg)), options)
                            .then(function(result) {
                                w.spinner = false
                                w.exporting = false
                                w.currentShare = false;
                                console.log(`${prefix}/${path}`)
                                if (w.markerState) {
                                    w.markerState.savedlink = `${prefix}/${path}`
                                }
                                w.lastMarkerState = w.markerState;
                                delete w.markerArea
                                if (element !== 'savedImage') {
                                    w.showShared(`${prefix}/${path}`, element)
                                } else {
                                    return `${prefix}/${path}`
                                }
                            })
                            .catch(function(err) {
                                if (operation.retry(err)) {
                                    return;
                                }
                                w.spinner = false
                                w.exporting = false;
                                console.log(err);
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'show',
                                    component: 'nav',
                                    params: {
                                        title: "Error",
                                        text: "unable to upload Image",
                                        class: 'warning'
                                    }
                                })
                            });
                    } catch (e) {
                        if (operation.retry(e)) {
                            return;
                        }
                    }
                })
            } else {
                console.log(data);
                w.spinner = false
                w.exporting = false;
                w.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: "Error",
                        text: "unable to upload Image",
                        class: 'warning'
                    }
                })
            }
        },
        getShare: async function(key, norerun) {
            console.log('getting share', key)
            let w = this;
            w.$store.commit('change', {
                spinner: true
            })
            let variables = {
                key: key
            };
            try {
                let data = await w.$apollo.query({
                    query: getShareQuery,
                    variables: variables,
                    fetchPolicy: 'network-only'
                })
                w.$store.commit('change', {
                    spinner: false
                })
                if (data && data.data && data.data.getShare && data.data.getShare.params) {
                    let buffer = Buffer.from(data.data.getShare.params, 'base64')
                    let jsonStr = w.$zlib.unzipSync(buffer).toString()
                    let params = JSON.parse(jsonStr)
                    if (params.samples) {
                        w.g25customsamples = params.samples
                        w.g25Rerun = params.type + '-shares.genoplot.com/' + params.path + '/samples'
                    }
                    if (norerun) {
                        return params
                    } else {
                        w.rerun(params);
                    }
                } else {
                    return false
                }
            } catch (err) {
                console.log(err)
                w.$store.commit('change', {
                    spinner: false
                })
                this.collapsed = false;
                return false
            }
        },
        getComps: function() {
            var arr = JSON.parse(JSON.stringify(this.groupArray));
            var averaged = this.switches.groupAveraged ? true : false
            var median = this.switches.groupMedian ? true : false
            var submitArr = []
            var quantity = 0;
            arr.forEach(group => {
                if (group.label) {
                    group.label = group.label.replace(' ► ', ':')
                    let vgroup = group.v ? (group.label.split(':').length > 1 ? group.label.split(':')[0] + '|' + group.v + ':' + group.label.split(':')[1] : group.label + '|' + group.v) : this.mode !== 'G25' ? (group.label.split(':').length > 1 ? group.label.split(':')[0] + '|' + this.mode + ':' + group.label.split(':')[1] : group.label.split(':')[0] + '|' + this.mode) : group.label;
                    submitArr.push(vgroup)
                    quantity = quantity + group.samples;
                } else {
                    submitArr.push(group.group + ':' + group.sample)
                    quantity = quantity + 1;
                }
            })
            quantity = averaged ? submitArr.length : quantity
            var obj = {}
            if (averaged || median) {
                var suffix = averaged ? ' (AVG)' : ' (MED)';
                submitArr.forEach(comp => {
                    let group = comp.split('|').length > 1 && (comp.split('|')[1].split(':')[0] > 2 || comp.split('|')[1].split(':')[0].length > 2) ? comp.split('|')[0] : comp
                    if (group.split(':').length > 1) {
                        obj[group.split(':')[0]] = true
                    } else {
                        var suf = group + suffix;
                        obj[suf] = true
                    }
                })
            } else {
                submitArr.forEach(comp => {
                    let group = comp.split('|').length > 1 && comp.split('|')[1].split(':')[0] > 2 && !this.switches.custom ? comp.split('|')[0] : comp.split('|').length > 1 && comp.split('|')[1].split(':')[0] > 2 && this.switches.custom ? (comp.split(':').length > 1 ? comp.split('|')[0] + ' • ' + comp.split(':')[1] : comp.split('|')[0]) : comp.split(':').length > 1 && this.switches.custom ? comp.replace(/:/, ' • ') : comp
                    if (group.split(':').length > 1 && !this.switches.custom) {
                        obj[group.split(':')[0]] = true
                    } else {
                        obj[group] = true
                    }
                })
            }
            return Object.keys(obj);
        },
        setMap: function() {
            setTimeout(() => {
                this.showMap = true;
            }, 0)
        },
        toggleDrawer: function() {
            this.drawer = !this.drawer
        },
        recordEvent: function(evt, meta) {
            meta.component = this.component;
            let ignore = ['routechange', 'calculators', 'groupsamples', 'setcredits', 'refreshcache', 'getuser', 'rerun', 'reset']
            this.$gtag.event(evt, meta);
            if (ignore.indexOf(evt.toLowerCase()) < 0) this.$genericevent.trackEvent(evt, meta);
        },
        setGroupArray: function(params) {
            this.groupArray = []
            params.groups.map(x => {
                let groupIndex = this.publicGroups.findIndex(y => y.label === x)
                if (groupIndex >= 0) this.groupArray.push(this.publicGroups[groupIndex])
            })
            this.syncStore('groupArray');
            this.components = params.groups
            this.$store.commit('change', {
                g25chartComponents: this.components
            })
            var chartColors = this.chartColors[this.slider.colors.value - 1]
            var colors = [...chartColors].slice(0, this.groupArray.length);
            this.$store.commit('change', {
                g25chartColors: colors
            })
        },
        getSamples: async function() {
            this.download('similarity');
            return;
            this.$store.commit('change', {
                spinner: true
            })
            let w = this;
            let results = []
            let arr = this.sampleArray;
            const sampleResultsArr = arr.map(async sample => {
                let variables = {
                    sample: sample.sample,
                    group: sample.v ? sample.group + '|' + sample.v : sample.type === 'raw' ? sample.group + '|' + this.mode : sample.group
                }
                let query = w.isAdmin ? getGenoplotsamples : getFilteredGenoplotsamples;
                let data = await w.$apollo.query({
                    query: query,
                    variables: variables,
                    fetchPolicy: 'network-only'
                })
                query = w.isAdmin ? 'getGenoplotsamples' : 'getFilteredGenoplotsamples';
                if (data && data.data && data.data[query] && data.data[query].coords) {
                    let similar = (variables.group + ':' + sample.sample).replace(/ /g, '_')
                    let coords = data.data[query].coords ? data.data[query].coords.split(',') : data.data[query].coords
                    let group = w.heatmapJSON.find(x => x.name === variables.sample && x.group === variables.group)
                    if (group) {
                        let length = group.data.length
                        similar = group.data.find(x => parseInt(x.y) == 2 * length)
                        if (similar) {
                            similar = (sample.group + '[' + similar.x + ']:' + sample.sample).replace(/ /g, '_')
                        }
                    }
                    let result = {
                        '': similar
                    };
                    if (coords.length > 0) coords.map((x, i) => {
                        let pc = 'PC' + (i + 1);
                        result[pc] = parseFloat(x)
                    })
                    results.push(result);
                }
            })
            try {
                const sampleResults = await Promise.all(sampleResultsArr);
                if (results.length > 0) {
                    this.getXLS().then((res) => {
                        var wb = XLSX.utils.book_new();
                        var ws = XLSX.utils.json_to_sheet(results, {
                            skipHeader: false
                        });
                        XLSX.utils.book_append_sheet(wb, ws, "results");
                        XLSX.writeFile(wb, "datasheet.csv", {
                            compression: true
                        });
                        this.$store.commit('change', {
                            spinner: false
                        })
                    }).catch(err => {
                        this.$store.commit('change', {
                            spinner: false
                        })
                        console.log(err)
                    })
                } else {
                    this.$store.commit('change', {
                        spinner: false
                    })
                    console.log('Nothing to export..')
                }
            } catch (err) {
                consoleWithNoSource(err)
                this.$store.commit('change', {
                    spinner: false
                })
            }
        },
        resetMode: function(evt) {
            this.getUserSamples()
            try {
                this.$refs.leftSelectinput.updateSearch('');
                this.$refs.rightSelectinput.updateSearch('');
            } catch (err) {}
            this.markerState = false;
            this.resetCustomSamples()
            this.filteredSamples = []
            this.filteredGroupSamples = []
            if (evt !== 'G25') {
                //this.switches.calculator = true
                //this.setCalculator();
                //this.switches.groupSamples = false;
                //this.syncStore('switches.groupSamples')
                this.sampleArray = this.sampleArray.filter(x => x.type == 'raw' || x.mode == evt)
                this.syncStore('sampleArray');
                if (this.groupArray[0] && this.groupArray[0].type !== 'raw') {
                    this.groupArray = [];
                    this.syncStore('groupArray');
                }
                //this.groupArray = this.groupOptions.find(calc => calc.type === evt) ? [ this.groupOptions.find(calc => calc.type === evt) ] : []
            } else {
                this.sampleArray = [];
                this.syncStore('sampleArray');
                this.groupArray = [];
                this.syncStore('groupArray');
            }

        },
        resizeEChart: function() {
            let echarts = Object.keys(this.$refs).filter(x => x.indexOf('echart-') >= 0)
            let w = this;
            echarts.map(chart => {
                if (w.$refs[chart]) {}
            })
        },
        resizeGrid: function() {
            let w = this;
            setTimeout(function() {
                w.gridOptions.api.sizeColumnsToFit();
                let height = w.$refs['mapwrapper'] && w.$refs['mapwrapper'].$el ? w.$refs['mapwrapper'].$el.clientHeight : 800
                w.gridMargin = height
                console.log('clientHeight', height)
            }, 500)
        },
        debounce1: function(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this,
                    args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) {
                        func.apply(context, args);
                    }
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) {
                    func.apply(context, args);
                }
            };
        },
        newColor: function(H, hue, sat, lum) {
            hue = hue ? hue : 0
            lum = lum ? lum : 0
            sat = sat ? sat : 0
            let r = 0,
                g = 0,
                b = 0,
                a = 1;

            if (H.length == 5) {
                r = "0x" + H[1] + H[1];
                g = "0x" + H[2] + H[2];
                b = "0x" + H[3] + H[3];
                a = "0x" + H[4] + H[4];
            } else if (H.length == 9) {
                r = "0x" + H[1] + H[2];
                g = "0x" + H[3] + H[4];
                b = "0x" + H[5] + H[6];
                a = "0x" + H[7] + H[8];
            } else if (H.length == 7) {
                r = "0x" + H[1] + H[2];
                g = "0x" + H[3] + H[4];
                b = "0x" + H[5] + H[6];
                a = "0xff";
            }
            r /= 255;
            g /= 255;
            b /= 255;
            let cmin = Math.min(r, g, b),
                cmax = Math.max(r, g, b),
                delta = cmax - cmin,
                h = 0,
                s = 0,
                l = 0;

            if (delta == 0)
                h = 0;
            else if (cmax == r)
                h = ((g - b) / delta) % 6;
            else if (cmax == g)
                h = (b - r) / delta + 2;
            else
                h = (r - g) / delta + 4;

            h = Math.round(h * 60);

            if (h < 0)
                h += 360;

            l = (cmax + cmin) / 2;
            s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
            s = +(s * 100).toFixed(1);
            l = +(l * 100).toFixed(1);

            a = (a / 255).toFixed(3);
            return "hsla(" + (h + hue) + "," + (s + sat) + "%," + (l + lum) + "%," + a + ")";
        },
        appEvents: function(info) {
            if (typeof(info) === 'object' && (info.component === 'g25' || info.component === 'global')) {
                if (this[info.exec]) {
                    this[info.exec](info.params)
                }
            }
        },
        getUserSamples: async function(nextToken) {
            var w = this;
            if (!nextToken) {
                this.$store.commit('change', {
                    userSamples: []
                })
            }
            let currentSamples = nextToken ? this.$store.getters.get('userSamples') : []
            let proxy = (this.isAdmin && this.user && this.user.username && this.user.username == 'Genoplot' && this.$store.getters.get('proxyUser') != this.user.username) ? w.$store.getters.get('proxyUser') : false
            if (proxy) console.log('getting samples for ' + proxy)
            console.log(`getting${nextToken ? ' more ' : ' '}user samples...`)
            if (proxy || w.user && w.user.username) {
                try {
                    let variables = {
                        owner: proxy ? proxy : w.user.username,
                        type: w.mode
                    }
                    if (nextToken) variables.nextToken = nextToken
                    let data = await w.$apollo.query({
                        query: queryByOwnerType,
                        variables: variables,
                        fetchPolicy: 'network-only'
                    })
                    w.initiated = Date.now()
                    if (data && data.data && data.data.queryByOwnerTypeIndex && data.data.queryByOwnerTypeIndex.items && data.data.queryByOwnerTypeIndex.items.length > 0) {
                        var samples = data.data.queryByOwnerTypeIndex.items
                        samples = currentSamples.concat(samples);
                        samples.sort((a, b) => a.sample.toLowerCase() > b.sample.toLowerCase() ? 1 : a.sample.toLowerCase() < b.sample.toLowerCase() ? -1 : 0)
                        samples.forEach((sample, index) => {
                            sample.sample = sample.sample
                            sample.alias = this.alias
                            sample.index = sample.group + ':' + sample.sample
                            sample.type = sample.type ? sample.type : 'G25';
                            sample.refs = ((sample.alias || sample.group) + ':' + sample.sample + (sample.ethicity || '') + (sample.origin || '')).toLowerCase();
                            sample.class = sample.outlier ? 'outlier user' : 'default user';
                        })
                        this.$store.commit('change', {
                            userSamples: samples
                        })
                        if (data.data.queryByOwnerTypeIndex.nextToken) await w.getUserSamples(data.data.queryByOwnerTypeIndex.nextToken)
                    } else {
                        console.log(`No samples associated with ${w.user.username} found`);
                        var userSamples = [{
                            group: w.user.username,
                            samples: []
                        }]
                        //this.userSamples = userSamples
                        this.$store.commit('change', {
                            userSamples: []
                        })
                    }
                    this.filteredOptions = []
                    /*
                    setTimeout(() => {
                        if (this.publicSamples && this.publicSamples.length == 0) {
                            console.log('refreshing cache')
                            this.refreshCache()
                        }
                    }, 3000)
                    */
                } catch (error) {
                    console.log('getOwnerSamples', error);
                };
            }
        },
        init: async function() {
            var w = this;
            name = this.user.username + ':sampleArray'
            requestIdleCallback(async () => {
                var lsampleArray = localStorage.getItem(name);
                if (lsampleArray) {
                    this.$store.commit('change', JSON.parse(lsampleArray))
                    this.sampleArray = JSON.parse(lsampleArray).sampleArray
                }
                name = this.user.username + ':groupArray'
                var lgroupArray = localStorage.getItem(name);
                if (lgroupArray) {
                    this.$store.commit('change', JSON.parse(lgroupArray))
                    this.groupArray = JSON.parse(lgroupArray).groupArray
                }
                w.getUserSamples()
                let proxy = (this.isAdmin && this.user && this.user.username && this.user.username == 'Genoplot' && this.$store.getters.get('proxyUser') != this.user.username) ? w.$store.getters.get('proxyUser') : false
                w.$apollo.query({
                        query: getOwnerCalcsQuery,
                        variables: {
                            user: proxy ? proxy : w.user.username
                        },
                        fetchPolicy: 'network-only'
                    })
                    .then(data => {
                        if (data && data.data && data.data.queryGenoCalcsByOwner && data.data.queryGenoCalcsByOwner.items && data.data.queryGenoCalcsByOwner.items.length > 0) {
                            var calcs = data.data.queryGenoCalcsByOwner.items
                            calcs.map(calc => {
                                calc.label = calc.calculator;
                                calc.pca = calc.pca;
                                calc.class = 'default calc';
                            })
                            this.$store.commit('change', {
                                userCalcs: calcs
                            })
                            this.userCalcs = calcs
                            console.log('getting user calcs...')
                        } else {
                            this.userCalcs = []
                            this.$store.commit('change', {
                                userCalcs: []
                            })
                        }
                    })
                    .catch(error => {
                        console.log('getOwnerCalcs', error);
                    });
                var name = this.user.username + ':slider'
                var slider = localStorage.getItem(name);
                if (slider) {
                    slider = JSON.parse(slider).slider
                    let currentSlider = JSON.parse(JSON.stringify(this.slider))
                    Object.keys(currentSlider).map(key => {
                        if (!slider[key]) slider[key] = currentSlider[key]
                    })
                    this.$store.commit('change', {
                        slider: slider
                    })
                }
                name = this.user.username + ':switches'
                var lswitches = localStorage.getItem(name);
                if (lswitches) this.$store.commit('change', JSON.parse(lswitches))
                if (this.switches.calculator && this.groupArray.length > 0) {
                    try {
                        let settings = typeof(this.groupArray[0].settings) === 'string' ? JSON.parse(this.groupArray[0].settings) : this.groupArray[0].settings
                        this.switches.lite = settings && settings.nmonte ? false : true
                    } catch (err) {
                        console.log(err);
                    }
                }
            })
        },
        rerun: async function(params) {
            console.log('rerun', params);
            setTimeout(() => {
                this.collapsed = true;
            }, 0)
            this.spinner = true
            this.resetGroups()
            this.resetSamples()
            this.resetCustomSamples()
            if (params.samples) {
                let key = params.type + '|' + params.path.replace(/\//, ':')
                params = await this.getShare(key, true)
            }
            console.log('params', params);
            if (params.published) {
                this.topics[params.path] = params.published
            }
            //this.$store.commit('change', { geo: w.geo })
            let evt = 'collapse-select';
            try {
                Object.keys(params.switches).map(x => {
                    this.switches[x] = params.switches[x]
                    this.syncStore('switches.' + x)
                })
                this.switches.lite = params.switches.lite ? params.switches.lite : false
                this.syncStore('switches.lite')
                Object.keys(params.sliders).map(x => {
                    if (x !== 'colors') {
                        this.slider[x].value = params.sliders[x]
                    }
                })
                if (params.calculator) {
                    this.switches.calculator = true
                    this.setCalculator();
                    this.switches.groupSamples = false;
                    this.syncStore('switches.groupSamples')
                } else {
                    this.switches.calculator = false
                    this.setCalculator();
                    this.switches.groupSamples = false;
                    this.syncStore('switches.groupSamples')
                }
                this.slider.limit.value = params.sliders.limit ? params.sliders.limit : this.slider.limit.data[0][0]
                this.slider.min.value = params.sliders.min ? params.sliders.min : this.slider.min.data[0][0]
                this.syncStore('slider')
            } catch (err) {
                console.log('unable to reset switches/sliders for rerun', err)
            }
            setTimeout(() => {
                try {
                    this.csv = params.csv
                    if (params.modetype) {
                        this.mode = params.modetype;
                    } else {
                        this.mode = 'G25'
                    }
                    Object.keys(params.switches).map(x => {
                        this.switches[x] = params.switches[x]
                    })
                    this.activePath = params.path
                    this.rerunswitch = params.replay || false;
                    this.activeName = params.name ? params.name : false;
                    this.activeContent = params.content || undefined

                    if (params.calculator) {
                        if (params.calcGroupsArray) {
                            this.calcGroupsArray = params.calcGroupsArray.map(x => {
                                return {
                                    name: x,
                                    label: x.replace(/_/g, ' ')
                                }
                            })
                        }
                        this.sampleArray = [];
                        params.categories.map(x => {
                            if (params.samples && params.samples.length > 0 && params.samples.indexOf(x.split(' ► ').length > 1 ? `${x.split(' ► ')[0]}:${x.split(' ► ')[1]}` : x) >= 0) {
                                let entityType = undefined
                                let sample = false
                                if (params.samples.findIndex(y => y == x.split(' ')[0] + ':' + x.split(' ')[2]) >= 0) entityType = 'user'
                                let sampleIndex = this.sampleOptions.findIndex(s => s.group === x.split(' ')[0] && s.samples.find(y => x.split(' ')[2] == y.sample))
                                if (sampleIndex >= 0 && this.sampleOptions[sampleIndex]) {
                                    sample = {
                                        ...this.sampleOptions[sampleIndex].samples.find(y => x.split(' ')[2] == y.sample)
                                    }
                                }
                                if (!sample) {
                                    sample = {
                                        index: x.split(' ')[0] + (entityType != 'user' && params.version ? `|${params.version}` : '') + ':' + x.split(' ')[2],
                                        group: x.split(' ')[0],
                                        sample: x.split(' ')[2],
                                        entityType: entityType,
                                        type: params.modetype
                                    }
                                }
                                this.sampleArray.push(sample)
                            } else {
                                let sample = this.sampleOptions.find(s => s.group === x.split(' ')[0]) ? this.sampleOptions.find(s => s.group === x.split(' ')[0]).samples.find(s => s.sample === x.split(' ')[2]) : false
                                if (sample) {
                                    this.sampleArray.push(sample);
                                } else {
                                    console.log('sample not found', x);
                                }
                            }
                        })
                        this.syncStore('sampleArray');
                        let calc = this.groupOptions.find(calc => calc.calculator === params.calculator.split(':')[1] && calc.user === params.calculator.split(':')[0] && calc.description && calc.samples)
                        this.groupArray = calc ? [calc] : params.samples ? [{
                            calculator: params.calculator.split(':')[1],
                            label: params.calculator.split(':')[1],
                            user: params.calculator.split(':')[0],
                            samples: params.calcSamplesQuantity,
                            description: params.calcDescription,
                            scaled: params.calcScaled !== undefined ? params.calcScaled : params.switches.scaled ? 1 : 0,
                            public: 0,
                            aggregated: params.aggregatedCalc !== undefined ? params.aggregatedCalc : true,
                            type: params.modetype
                        }] : []
                        this.syncStore('groupArray');
                        if (params.samples) {
                            setTimeout(() => {
                                let w = this;
                                var json = params
                                let key = json.key
                                w.colors = json.colors;
                                w.components = json.components;
                                let sampleObj = {}
                                json.json.map(x => {
                                    Object.keys(x.sampleResult).map(y => sampleObj[y] = true)
                                })
                                w.$store.commit('change', {
                                    g25calcComponents: json.calcComponents
                                })
                                w.$store.commit('change', {
                                    g25calcSampleComponents: Object.keys(sampleObj)
                                })
                                w.$store.commit('change', {
                                    g25chartJSON: json.json
                                })
                                w.processJSON(key)
                            }, 0)
                        }
                        setTimeout(() => {
                            if (params.samples) {
                                this.$root.$emit(evt, 'collapse');
                                this.collapsed = false;
                            } else {
                                this.$root.$emit(evt, 'activate');
                                this.collapsed = false;
                            }
                        }, 0)
                    } else {
                        params.categories.map(x => {
                            let alias;
                            let lookup = x.replace(/ ► /, ':')
                            if (!params.csv || lookup.split(':')[0] != 'Custom') {
                                let lookupGroup = lookup.split(':')[0]
                                let lookupSample = lookup.split(':')[1]
                                alias = this.sampleOptions.find(s => s.group == lookupGroup && (s.originalGroup && s.originalGroup != lookupGroup))
                                if (alias) {
                                    x = alias.originalGroup + ' ► ' + lookupSample
                                }
                            }
                            let sample
                            if (params.samples && params.samples.length > 0) {
                                let entityType = undefined
                                if (params.samples.findIndex(y => y == x.split(' ')[0] + ':' + x.split(' ')[2]) >= 0 || params.csv && x.split(' ')[0] == 'Custom') entityType = 'user'
                                sample = {
                                    index: x.split(' ')[0] + (entityType && entityType != 'user' && params.version ? `|${params.version}` : '') + ':' + x.split(' ')[2],
                                    group: x.split(' ')[0],
                                    alias: alias ? alias.group : undefined,
                                    sample: x.split(' ')[2],
                                    entityType: entityType,
                                    type: params.modetype
                                }
                                if (entityType && entityType != 'user') sample.v = params.version
                                if (!params.csv || (params.csv && x.split(' ')[0] != 'Custom')) {
                                    this.sampleArray.push(sample)
                                }
                            } else {
                                sample = this.sampleOptions.find(s => s.group === x.split(' ')[0]) ? this.sampleOptions.find(s => s.group === x.split(' ')[0]).samples.find(s => s.sample === x.split(' ')[2]) : false
                                if (sample) this.sampleArray.push(sample);
                            }
                        })
                        this.syncStore('sampleArray');
                        let groupSwitch = this.switches.groupSamples
                        params.groupArray.map(x => {
                            if (x.split(':').length > 1) {
                                if (params.samples && params.samples.findIndex(y => y == x) >= 0) {
                                    let alias;
                                    let samplegroup = this.sampleOptions.find(s => s.originalGroup == x.split(':')[0])
                                    if (samplegroup) {
                                        alias = samplegroup.samples.find(s => s.alias && s.index == x)
                                    }
                                    let sample;
                                    //console.log(x, 'aliasgroup', alias, this.sampleOptions)
                                    if (alias) {
                                        sample = {
                                            class: 'default user',
                                            group: alias.group,
                                            sample: alias.sample,
                                            alias: alias.alias,
                                            label: alias.index.replace(/ /, '_')
                                        }
                                    } else {
                                        sample = {
                                            class: 'default user',
                                            group: x.split(':')[0],
                                            sample: x.split(':')[1],
                                            label: x.replace(/ /, '_')
                                        }
                                    }
                                    this.groupArray.push(sample)
                                } else {
                                    this.switches.groupSamples = true
                                    this.syncStore('groupSamples')
                                    let group = this.groupOptions.find(group => group.index === x.replace(/ /, '_'))
                                    if (group && group.v && params.version) group.v = params.version
                                    if (group) this.groupArray.push(group)
                                }
                            } else if (x.split(' [').length > 1) {
                                let customgroup = x.split(' [')[0]
                                let type = params.modetype
                                this.groupArray.push({
                                    class: 'default user',
                                    type: type,
                                    customgroup: customgroup,
                                    ethnicity: x,
                                    label: x,
                                    samples: 1
                                })
                            } else {
                                this.switches.groupSamples = false
                                this.syncStore('groupSamples')
                                let group = this.groupOptions.find(group => group.label === x.replace(/ /, '_'))
                                if (group && group.v && params.version) group.v = params.version
                                if (group) this.groupArray.push(group)
                            }
                        })
                        this.switches.groupSamples = groupSwitch;
                        this.switches.heatmap = params.switches.heatmap ? params.switches.heatmap : false;
                        this.syncStore('groupSamples')
                        this.syncStore('groupArray');
                        //console.log('arrays', this.groupArray, this.sampleArray)
                        if (params.geo) {
                            this.$store.commit('change', {
                                geo: params.geo
                            })
                        }
                        if (params.samples) {
                            setTimeout(() => {
                                let w = this;
                                var json = params
                                let key = json.components[0]
                                w.colors = json.colors;
                                w.components = json.components;
                                w.$store.commit('change', {
                                    g25heatmapJSON: json.heatmap
                                })
                                w.$store.commit('change', {
                                    g25chartJSON: json.json
                                })
                                w.processJSON(key)
                            }, 0)
                        }
                        setTimeout(() => {
                            if (params.samples) {
                                this.$root.$emit(evt, 'collapse');
                                this.collapsed = false;
                            } else {
                                this.$root.$emit(evt, 'activate');
                                this.collapsed = false;
                            }
                        }, 0)
                    }
                    try {
                        Object.keys(params.switches).map(x => {
                            this.switches[x] = params.switches[x]
                        })
                        this.switches.lite = params.switches.lite ? params.switches.lite : false
                        Object.keys(params.sliders).map(x => {
                            if (x !== 'colors') {
                                this.slider[x].value = params.sliders[x]
                            }
                        })
                        this.slider.limit.value = params.sliders.limit ? params.sliders.limit : this.slider.limit.data[0][0]
                        this.slider.min.value = params.sliders.min ? params.sliders.min : this.slider.min.data[0][0]
                    } catch (err) {
                        console.log('unable to reset switches/sliders for rerun', err)
                    }
                    this.markerState = params.markerState ? params.markerState : false;
                    this.lastMarkerState = this.markerState;
                } catch (err) {
                    console.log(err);
                    this.collapsed = false;
                    setTimeout(() => {
                        this.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: "Error",
                                text: "Unable to rerun  model<br>Perhaps some of the groups or samples are no longer available.",
                                class: 'warning'
                            }
                        })
                    }, 300)
                }
            }, 0)

        },
        share: function(obj) {
            let w = this;
            let functions = {
                facebook: function(params) {
                    let path = params.path
                    let theme = params.theme
                    w.shareUrl = {
                        social: 'facebook',
                        shareQuote: 'my Genoplot Ancestry model',
                        shareUrl: params.shareUrl ? params.shareUrl : 'https://genoplot.com/shared/g25/?share=' + path + '#' + theme,
                        shareDesc: "Genetic Ancestry Modeling",
                        shareTitle: "Global 25 ancestry models"
                    }
                },
                twitter: function(params) {
                    let shareHash = 'genoplot,genetics,geneology,ancestry,global25,nmonte'
                    let path = params.path
                    let theme = params.theme
                    w.shareUrl = {
                        social: 'twitter',
                        shareHash: shareHash,
                        shareVia: 'genoplot',
                        shareText: 'my Genoplot Ancestry model',
                        shareUrl: params.shareUrl ? params.shareUrl : 'https://genoplot.com/shared/g25/?share=' + path + '#' + theme
                    }
                },
                reddit: function(params) {
                    let shareHash = 'genoplot,genetics,ancestry,global25,nmonte' + w.components.map(x => x.replace(/ ► /g, '_').replace(/ /g, '')).join(',')
                    let path = params.path
                    let theme = params.theme
                    w.shareUrl = {
                        social: 'reddit',
                        shareHash: shareHash,
                        shareVia: 'genoplot',
                        shareText: 'my Genoplot Ancestry model',
                        shareUrl: params.shareUrl ? params.shareUrl : 'https://genoplot.com/shared/g25/?share=' + path + '#' + theme
                    }
                }
            }
            functions[obj.name](obj.params)
        },
        showShared: async function(url, element) {
            let w = this;
            let buttons = [{
                title: "Copy URL",
                handler: (i, event) => {
                    copy(url)
                    document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                }
            }, {
                title: "Copy URL (BBCode)",
                handler: (i, event) => {
                    let bburl = `[URL="${url}"][IMG]${url}[/IMG][/URL]`
                    copy(bburl)
                    document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                }
            }, {
                title: 'Close',
                default: true
            }]
            w.$modal.show('dialog', {
                title: 'Link to sharable image',
                text: `You can now share an image of this ${element} from this <a style='color:steelblue;' target='_blank' href=${url}>link</a>`,
                buttons: buttons,
                clickToClose: false,
                beforeClosed: function(event) {
                    console.log('closing', event)
                }
            })
        },
        saveImage: async function() {
            let el = 'chart'
            let type = 'svg'
            let w = this;
            console.log('started')
            w.$store.commit('change', {
                spinner: true
            })
            setTimeout(() => {
                w.exporting = true;
                let element = 'chart'
                try {
                    let image = type;
                    let contentType = "image/svg+xml"
                    let fileType = 'image'
                    let path = `${w.user.username}/${element}-${Date.now().toString(16)}`
                    let sigparams = {
                        filePath: path,
                        fileType: fileType,
                        contentType: contentType
                    }
                    let node = document.getElementById(el);
                    let style = {
                        margin: 0,
                        padding: 0
                    }
                    domtoimage.toSvg(node, {
                            bgcolor: this.theme ? 'black' : 'white',
                            style: style
                        })
                        .then(async function(blob) {
                            let prefix = 'https://shared.genoplot.com/file/genofiles'
                            let svg = blob.replace(/data\:image\/svg\+xml\;charset\=utf-8\,/, '').replace(/\%0A/g, '')
                            let style = ''
                            let background = w.theme ? '#000000b5' : '#ffffffb5'
                            let title = w.theme ? 'black' : 'white'
                            let string = `#maplegend-wrapper { background: ${background} !important;} `
                            string = el === 'sunburst' ? string + ` .title-container .title {background: ${title} !important;}` : string
                            style = `<style>${string}</style>`
                            svg = svg.replace(/\>\<foreignObject/, `>${style}<foreignObject`)
                            var svgBlob = new Blob([svg], {
                                type: "image/svg+xml;charset=utf-8"
                            });
                            var svgUrl = URL.createObjectURL(svgBlob);
                            w.spinner = true;
                            let result = await w.putImage(svg, prefix, path, sigparams, 'savedImage', type)
                            console.log('done', result);
                        }).catch(function(err) {
                            console.log(err);
                            w.$store.commit('change', {
                                spinner: false
                            })
                            w.exporting = false;

                        })
                } catch (err) {
                    console.log(err);
                    w.spinner = false
                    w.exporting = false;
                }
            }, 0)
        },
        uploadImage: async function(el, type) {
            let w = this;
            type = w.screenshot ? 'svg' : 'png'
            console.log('started', type)
            w.$store.commit('change', {
                spinner: true
            })
            setTimeout(() => {
                delete w.markerArea
                w.editedImageUrl = undefined
                w.editedImageUrl2 = undefined
                w.exporting = true;
                let element = (el === 'table' || el === 'map') ? el : el === 'apex-heatmap' ? 'heatmap' : 'chart'
                try {
                    let image = type;
                    let contentType = type == 'png' ? "image/png" : "image/svg+xml"
                    let fileType = 'image'
                    let name = w.alias ? w.alias : w.user.username;
                    let path = `${name}/${element}-${Date.now().toString(16)}`
                    let sigparams = {
                        filePath: path,
                        fileType: fileType,
                        contentType: contentType
                    }
                    let node = document.getElementById(el);
                    let style = el === 'table' && type == 'svg' ? {
                        marginTop: '-50px',
                        padding: 0
                    } : el === 'barchart' ? {
                        'margin': 0,
                        'width': '100%',
                        marginTop: '-10px',
                        padding: 'unset'
                    } : el === 'table' ? {
                        marginLeft: 0,
                        marginTop: '-50px',
                        padding: 0,
                        paddingLeft: '50px',
                        paddingRight: '10px'
                    } : el === 'apex-heatmap' ? {
                        marginTop: '-25',
                        padding: 0
                    } : el === 'map' ? {
                        marginTop: '50px',
                        padding: 0
                    } : el === 'grid' ? {
                        margin: 0,
                        padding: 0,
                        paddingLeft: '50px',
                    } : {
                        margin: 0,
                        padding: 0
                    }
                    domtoimage.toSvg(node, {
                            bgcolor: this.theme && el === 'table' ? '#14191f' : this.theme ? '#14191f' : '#f2f2f2',
                            style: style
                        })
                        .then(async function(blob) {
                            let prefix = 'https://shared.genoplot.com/file/genofiles'
                            let svg = blob.replace(/data\:image\/svg\+xml\;charset\=utf-8\,/, '').replace(/\%0A/g, '')
                            let style = ''
                            if (element === 'chart') {
                                let background = w.theme ? '#14191f;' : '#f2f2f2;'
                                let title = w.theme ? 'black' : 'white'
                                let string = `#maplegend-wrapper { background: ${background} !important;} `
                                string = el === 'sunburst' ? string + ` .title-container .title {background: ${title} !important;}` : string
                                style = `<style>${string}</style>`
                            } else {
                                if (w.theme) {
                                    style = "<style>* { pointer-events: none;}foreignObject, foreignObject > *, foreignObject .switchChartType { background: #000 !important;}</style>"
                                } else {
                                    style = "<style>* { pointer-events: none;}</style>"
                                }
                            }
                            svg = svg.replace(/\>\<foreignObject/, `>${style}<foreignObject`)
                            var svgBlob = new Blob([svg], {
                                type: "image/svg+xml;charset=utf-8"
                            });
                            var svgUrl = URL.createObjectURL(svgBlob);
                            w.markup = '<svg xmlns="http://www.w3.org/2000/svg"></svg>'
                            if (el === 'sunburst' || el === 'map' || el === 'apex-wrapper' || el === 'tabled') {
                                let image = document.getElementById('editImage')
                                image.onload = () => {
                                    if (!w.markerArea) {
                                        console.log('Loading markers')
                                        let markerArea = new markerjs2.MarkerArea(image);
                                        markerArea.addCloseEventListener(data => {
                                            delete w.markerArea
                                            if (!w.markup || w.markup === '<svg xmlns="http://www.w3.org/2000/svg"></svg>') {
                                                w.exporting = false;
                                                w.spinner = false;
                                                //w.editedImageUrl = undefined
                                                //w.editedImageUrl2 = undefined
                                            } else {
                                                w.spinner = false;
                                                //w.editedImageUrl = undefined
                                                //w.editedImageUrl2 = undefined
                                            }
                                        })
                                        markerArea.addRenderEventListener(async (dataUrl, state) => {
                                            w.editedImageUrl2 = dataUrl;
                                            let replaceStr = svg.substring(svg.indexOf("<svg"), svg.indexOf(">"))
                                            let newSVG = document.getElementById('markerSVG').outerHTML
                                            w.markup = newSVG;
                                            console.log('markup as pushed')
                                            if (newSVG) {
                                                let markup = newSVG.replace(/<svg xml.*?view/, replaceStr + ' view')
                                                svg = svg.replace(/\/foreignObject\>/, `/foreignObject>${markup}`)
                                                svg = svg.replace(/style=""/, `style="padding:10px;` + (w.theme ? `background: #14191f;"` : `background: #f2f2f2;"`))
                                            }
                                            w.markerState = state;
                                            w.spinner = true
                                            await w.putImage(svg, prefix, path, sigparams, element, type)
                                            w.editedImageUrl = undefined
                                            w.editedImageUrl2 = undefined
                                        });
                                        w.markerArea = markerArea
                                        w.spinner = false;
                                    }
                                    let theme = (w.slider.colors.value - 1) % 5
                                    let colors = w.chartColors[theme];
                                    w.markerArea.settings.defaultColorSet = w.theme ? colors.concat(['transparent', '#ffffff', '#181818', '#f2f2f2' ]) : colors.concat(['transparent', '#e31a1c', '#181818', '#f2f2f2'])
                                    w.markerArea.settings.displayMode = 'popup';
                                    w.markerArea.renderAtNaturalSize = false;
                                    w.markerArea.settings.defaultOpacitySteps = [0.05, 0.1, 0.15, 0.2, 0.25, 0.5, 0.75, 1]
                                    w.markerArea.settings.defaultColor = w.theme ? '#ffffff' : '#e31a1c'
                                    w.markerArea.settings.defaultFontFamilies = ["Segoe UI", "Helvetica", "Arial", "sans-serif"]
                                    w.markerArea.settings.defaultFontFamily = "Segoe UI"
                                    w.markerArea.settings.savedlink = false;
                                    w.markerArea.renderImageType = "image/svg+xml;charset=utf-8"
                                    w.markerArea.renderMarkersOnly = true;
                                    w.markerArea.availableMarkerTypes = ["ArrowMarker", 'LineMarker', 'MeasurementMarker', "FreehandMarker", "FrameMarker", "HighlightMarker", EllipseMarker2, HighlightEllipseMarker, 'CalloutMarker', "TextMarker"];
                                    if (w.markerState && w.markerState.savedlink) {
                                        w.markerArea.settings.savedlink = w.markerState.savedlink
                                    }
                                    w.markerArea.show();
                                    if (w.markerState) {
                                        w.markerArea.restoreState(w.markerState);
                                    }
                                }
                                w.editedImageUrl = svgUrl;
                            } else {
                                w.putImage(svg, prefix, path, sigparams, element, type)
                            }
                        }).catch(function(err) {
                            console.log(err);
                            w.$store.commit('change', {
                                spinner: false
                            })
                            w.exporting = false;

                        })
                } catch (err) {
                    w.spinner = false
                    w.exporting = false;
                    console.log(err);
                }
            }, 0)
        },
        saveShare: async function(params) {
            console.log('saving', params);
            let w = this;
            if (this.saveReady2) {
                let title = this.shareTitle ? this.shareTitle : ''
                let url = this.src
                if (params == 'save') {
                    this.showshare = false;
                    let url = this.src.split('/').reverse()
                    let id = url[0]
                    id = id.substr(0, id.length - 1).replace(/#/, '')
                    let user = url[1].replace(/\#/, '').replace('?share=', '')
                    let component = url[2]
                    let rerun = `${component}|${user}:${id}`
                    this.pcaRerun = `${rerun.split('|')[0]}-shares.genoplot.com/${rerun.split('|')[1].replace(/:/,'/')}/samples`
                    let sharekey = rerun
                    this.getShare(sharekey);
                } else {
                    this.share({
                        name: params,
                        params: {
                            title: title,
                            shareUrl: url
                        }
                    })
                }
                return;
            }
            let recordSave = params == 'save' ? `save-${this.component}` : `share-${params}-${this.component}`
            this.recordEvent(recordSave, {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            w.createNew = true;
            params = params || 'save'
            if (w.subId !== w.lastShared || !w.currentShare) {
                //if (w.activePath) {
                if (w.activePath && w.activePath.split('/').length > 1 && (w.activePath.split('/')[0] == w.user.username || w.activePath.split('/')[0] == w.alias)) {
                    let buttons = [{
                            title: 'Update',
                            handler: () => {
                                w.createNew = false;
                                saveShare();
                                w.$modal.hide('dialog');
                            } // Button click handler
                        },
                        {
                            title: 'Create New',
                            handler: () => {
                                w.createNew = true;
                                saveShare();
                                w.$modal.hide('dialog');
                            } // Button click handler
                        },
                        {
                            title: 'Cancel',
                            default: true,
                            handler: () => {
                                w.closable = false;
                                w.$modal.hide('dialog');
                            } // Button click handler
                        }
                    ]
                    this.$modal.show('dialog', {
                        title: 'Update or Create New?',
                        text: 'Do you want to save to existing Model<br/>or save as a new Model?',
                        class: undefined,
                        buttons: buttons
                    })
                } else {
                    saveShare()
                }

                function saveShare() {
                    let version = w.sampleArray.findIndex(x => x.v !== undefined && x.v !== 0)
                    version = (version >= 0 ? w.sampleArray[version].v : 0)
                    if (version == 0) {
                        version = w.groupArray.findIndex(x => x.v !== undefined && x.v !== 0)
                        version = (version >= 0 ? w.groupArray[version].v : 0)
                    }
                    let samples = []
                    let usersamples = {}
                    w.groupArray.map(x => {
                        if (x.entityType === 'user' || x.type === 'user' || x.customgroup) {
                            if (x.customgroup) {
                                if (!usersamples[x.label]) {
                                    samples.push(x.label)
                                    usersamples[x.label] = true
                                }
                            } else {
                                if (!usersamples[x.index]) {
                                    samples.push(x.index)
                                    usersamples[x.index] = true;
                                }
                            }
                        }
                    })
                    w.sampleArray.map(x => {
                        if (x.entityType === 'user' || x.type === 'user') {
                            if (!usersamples[x.index]) {
                                samples.push(x.index)
                                usersamples[x.index] = true;
                            }
                        }
                    })

                    let payload = {
                        date: Date.now(),
                        version: version,
                        user: w.user.username,
                        json: w.chartJSON,
                        csv: w.csv,
                        markerState: w.lastMarkerState,
                        heatmap: w.heatmapJSON ? w.heatmapJSON : false,
                        geo: w.geo ? w.geo : false,
                        replay: w.rerunswitch,
                        shareType: params,
                        sort: !w.lastSort ? true : false,
                        index: w.currentIndex,
                        mapOptions: w.mapOptions,
                        key: w.chartKey,
                        mode: w.mode,
                        modetype: w.mode,
                        samples: samples,
                        categories: w.categories,
                        components: w.components,
                        colors: w.$store.getters.get('g25chartColors'),
                        calcComponents: w.calcComponents.length > 0 ? w.calcComponents : undefined,
                        aggregatedCalc: w.calcComponents.length > 0 ? w.groupArray[0].aggregated : undefined,
                        calcSamplesQuantity: w.calcComponents.length > 0 ? w.groupArray[0].samples : undefined,
                        calcScaled: w.calcComponents.length > 0 ? w.groupArray[0].scaled : undefined,
                        calcDescription: w.calcComponents.length > 0 ? w.groupArray[0].description : undefined,
                        calculator: w.calcComponents.length > 0 && w.groupArray[0] && w.groupArray[0].calculator && w.groupArray[0].user ? w.groupArray[0].user + ':' + w.groupArray[0].calculator : undefined,
                        groupArray: w.groupArray.map(x => x.index ? x.index : x.label),
                        calcGroupsArray: w.calcGroupsArray.map(x => x.name),
                        sliders: {
                            colors: (w.slider.colors.value - 1) % 5,
                            batches: w.slider.batches.value,
                            cycles: w.slider.cycles.value,
                        },
                        switches: {
                            scaled: w.switches.scaled,
                            penalty: w.switches.penalty,
                            groupAveraged: w.switches.groupAveraged,
                            groupMedian: w.switches.groupMedian,
                            removeOutliers: w.switches.removeOutliers,
                            heatmap: w.switches.heatmap,
                            calculator: w.switches.calculator,
                            lite: w.switches.lite
                        },
                        primaryTab: w.primaryT === "" ? "chart" : w.primaryT,
                        secondaryTab: w.secondaryT === "" ? "table" : w.secondaryT
                    }
                    if (w.alias && !(w.activeName && !w.createNew) || w.alias && !w.createNew && w.activePath && w.activePath.split('/')[0] == w.alias) {
                        payload.alias = w.alias;
                    }
                    if (parseInt(w.slider.limit.value)) payload.sliders.limit = w.slider.limit.value
                    if (parseInt(w.slider.min.value)) payload.sliders.min = w.slider.min.value
                    if (w.g25customsamples && w.g25Rerun && samples.length > 0) {
                        samples.map(x => {
                            if (w.g25customsamples.findIndex(y => y == x) >= 0) payload.customsamples = w.g25Rerun
                        })
                    }
                    let defaultName = w.activeName && !w.createNew ? w.activeName : (payload.categories && payload.categories[0] ? (payload.categories[0].split(':').length > 1 ? payload.categories[0].split(':')[1].split('@')[0] : payload.categories[0].split(' ').reverse()[0]).split('@')[0] : '') + (payload.components ? '| ' + payload.components.join(', ').replace(/_/g, ' ') : '')
                    let postContent = w.activeContent && !w.createNew ? w.activeContent : undefined
                    w.rerunswitch = false;
                    if (w.subType > 0) {
                        let buttons = [{
                                title: 'OK',
                                handler: () => {
                                    try {
                                        let input = document.getElementById('saveDialog')
                                        defaultName = input.textContent || defaultName
                                        w.activeName = w.createNew ? false : defaultName
                                        w.activeContent = w.createNew ? undefined : postContent
                                        let rerunswitch = document.getElementById('rerunSwitch')
                                        w.rerunswitch = rerunswitch.checked || false
                                        let post = document.getElementById('shared-description')
                                        postContent = post.value || undefined
                                        if (!defaultName || (defaultName && defaultName.length < 16)) {
                                            w.$modal.show('dialog', {
                                                title: 'Title is too short',
                                                text: 'Please set a longer title. Titles need to be at least 16 characters long. You are short by ' + (16 - defaultName.length) + ' characters',
                                            })
                                        } else {
                                            save(defaultName)
                                            w.$modal.hide('saveDialog');
                                        }
                                    } catch (err) {
                                        w.$modal.show('dialog', {
                                            class: 'warning',
                                            title: 'Error',
                                            text: err
                                        })
                                        console.log(err);
                                    }
                                } // Button click handler
                            },
                            {
                                title: 'Cancel',
                                default: true,
                                handler: () => {
                                    w.closable = false;
                                    w.$modal.hide('saveDialog');
                                } // Button click handler
                            }
                        ]
                        if (w.createNew || !w.createNew) {
                            w.$modal.show('saveDialog', {
                                title: 'Model Name',
                                //text: `<input id="nameDialog" autofocus spellcheck="false" autocomplete="false"  value=${'"' + defaultName + '"'}> <textarea id="shared-description" name="shared-description" rows="4" cols="50">Optional</textarea> <style>#nameDialog { width: 600px;margin-bottom: 10px;}</style>`,
                                //class: undefined,
                                payload: {
                                    ...payload,
                                    ...{
                                        name: defaultName,
                                        type: 'g25',
                                        content: postContent
                                    }
                                },
                                width: 600,
                                buttons: buttons
                            })
                            setTimeout(() => {
                                let input = document.getElementById('saveDialog');
                                if (input && w.createNew) {
                                    input.focus();
                                    w.selectElementContents(input)
                                }
                            }, 100)
                        } else {
                            save()
                        }
                    } else {
                        save()
                    }

                    async function save(defname) {
                        let name = w.alias ? w.alias : w.user.username;
                        defname = defname && defname.toLowerCase().includes(w.mode.toLowerCase()) ? defname : defname + ' (' + w.mode.toUpperCase() + ')'
                        //let path = !w.createNew && w.activePath ? w.user.username + '/' + w.activePath.split('/')[1] : `${w.user.username}/${Date.now().toString(16)}`
                        let path = !w.createNew && w.activePath ? w.user.username + '/' + w.activePath.split('/')[1] : `${name}/${Date.now().toString(16)}`
                        payload.name = defaultName
                        if (w.subType > 0) {
                            w.activePath = path;
                            w.activeName = defaultName;
                        }
                        payload.name = defname
                        payload.replay = w.rerunswitch
                        let type = 'g25'
                        path = path;
                        let theme = w.theme ? 2 : 1
                        payload.path = path
                        payload.content = postContent;
                        if (w.topics && w.topics[path] && !w.createNew) payload.published = w.topics[path]
                        payload.theme = theme
                        payload.type = type
                        if (postContent) payload.content = postContent
                        let contentType = 'application/json'
                        w.spinner = true
                        let sigparams = {
                            filePath: path,
                            fileType: type,
                            shareType: payload.shareType,
                            email: w.user.email,
                            username: w.user.username,
                            contentType: contentType,
                            jsonPayload: payload
                        }
                        if (w.env && typeof(w.env) == 'string' && (w.env == 'development' || w.env == 'staging')) {
                            sigparams.debug = true
                            sigparams.env = 'dev'
                        }
                        let data = await w.$apollo.query({
                            query: getS3SignatureQuery,
                            variables: {
                                params: JSON.stringify(sigparams)
                            },
                            fetchPolicy: 'network-only'
                        })
                        if (data && data.data && data.data.gets3Signature && data.data.gets3Signature.result) {
                            let result = JSON.parse(data.data.gets3Signature.result);
                            w.spinner = false;
                            if (result.url && !result.uploaded) {
                                let signedUrl = result.url;
                                let options = {
                                    headers: {
                                        'Content-Type': contentType,
                                        'Content-Encoding': 'gzip'
                                    }
                                }
                                axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(JSON.stringify(payload))), options)
                                    .then(function(result) {
                                        w.spinner = false
                                        w.currentShare = {
                                            params: params,
                                            theme: theme,
                                            path: path
                                        }
                                        w.lastShared = w.plotId
                                        showShare(params, path, theme)
                                    })
                                    .catch(function(err) {
                                        w.spinner = false
                                        console.log(err);
                                        w.$eventBus.$emit('appEvents', {
                                            exec: 'show',
                                            component: 'nav',
                                            params: {
                                                title: "Error",
                                                text: "unable to save model",
                                                class: 'warning'
                                            }
                                        })
                                    });
                            } else if (result.uploaded) {
                                w.spinner = false
                                w.currentShare = {
                                    params: params,
                                    theme: theme,
                                    path: path
                                }
                                w.lastShared = w.plotId
                                showShare(params, path, theme)
                            } else {
                                w.spinner = false
                                console.log(result);
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'show',
                                    component: 'nav',
                                    params: {
                                        title: "Error",
                                        text: "unable to save model",
                                        class: 'warning'
                                    }
                                })

                            }
                        } else {
                            w.spinner = false
                            console.log(data);
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: "Error",
                                    text: "unable to save PCA",
                                    class: 'warning'
                                }
                            })
                        }
                    }
                }
            } else {
                let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
                let genoTheme = this.getInitialColorMode(value)
                w.currentShare.theme = genoTheme == 'dark' ? 2 : 1
                showShare(params, w.currentShare.path, w.currentShare.theme)
            }

            function showShare(params, path, theme) {
                let value = theme == 2 ? 'dark' : 'light'
                let genoTheme = w.getInitialColorMode(value)
                theme = genoTheme == 'dark' ? 2 : 1
                if (params === 'save') {
                    let url = 'https://genoplot.com/shared/g25/?share=' + path + '#' + theme
                    let buttons = [{
                        title: "Copy URL",
                        handler: (i, event) => {
                            copy(url)
                            document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                        }
                    }, {
                        title: '<a href="mailto:?subject=my Genoplot PCA&body=' + url + '" >Email</a>'
                    }, {
                        title: 'Close',
                        default: true
                    }]
                    w.$modal.show('dialog', {
                        title: 'Share',
                        text: "You can now share this model from this <a target='_blank' href='https://genoplot.com/shared/g25/?share=" + path + "#" + theme + "'>link</a>",
                        buttons: buttons,
                        clickToClose: false,
                        class: 'alert',
                        beforeClosed: function(event) {
                            console.log('closing', event)
                        }
                    })
                } else {
                    w.share({
                        name: params,
                        params: {
                            theme: theme,
                            path: path
                        }
                    })
                }
            }
        },
        saveShare2: function(params) {
            let w = this;
            params = params || 'save'
            if (w.subId !== w.lastShared || !w.currentShare) {
                w.spinner = true
                //let categories = this.categories.map( x => x.replace(/ ► /,':')).map( x => this.sampleArray.find( s => s.index === x )).map( x => x.index + '|' + ( x.v ? x.v : -1 ))
                let payload = {
                    date: Date.now(),
                    version: w.groupArray[0] && w.groupArray[0].v ? w.groupArray[0].v : 0,
                    user: w.user.username,
                    json: w.chartJSON,
                    shareType: params,
                    sort: !w.lastSort ? true : false,
                    index: w.currentIndex,
                    key: w.chartKey,
                    mode: w.mode,
                    categories: w.categories,
                    components: w.components,
                    colors: w.$store.getters.get('g25chartColors'),
                    calcComponents: w.calcComponents.length > 0 ? w.calcComponents : undefined,
                    calculator: w.calcComponents.length > 0 && w.groupArray[0] && w.groupArray[0].calculator && w.groupArray[0].user ? w.groupArray[0].user + ':' + w.groupArray[0].calculator : undefined,
                    groupArray: w.groupArray.map(x => x.index ? x.index : x.label),
                    sliders: {
                        colors: (w.slider.colors.value - 1) % 5,
                        batches: w.slider.batches.value,
                        cycles: w.slider.cycles.value,
                    },
                    switches: {
                        scaled: w.switches.scaled,
                        penalty: w.switches.penalty,
                        groupAveraged: w.switches.groupAveraged,
                        groupMedian: w.switches.groupMedian,
                        removeOutliers: w.switches.removeOutliers,
                        calculator: w.switches.calculator
                    },
                    primaryTab: w.primaryT === "" ? "chart" : w.primaryT,
                    secondaryTab: w.secondaryT === "" ? "table" : w.secondaryT
                }
                let path = `${w.user.username}/${Date.now().toString(16)}`
                //path = w.subType === 0 ? 'base/' + path : path;
                path = w.subType === 0 ? path : path;
                let theme = w.theme ? 2 : 1
                let type = 'g25'
                payload.path = path
                payload.theme = theme
                payload.type = type
                let contentType = 'application/json'
                axios.post('https://genoplot.com/api/s3upload', {
                        filePath: path,
                        fileType: type,
                        contentType: contentType,
                    })
                    .then(function(result) {
                        var signedUrl = result.data.url;
                        var options = {
                            headers: {
                                'Content-Type': contentType,
                                'Content-Encoding': 'gzip'
                            }
                        };
                        return axios.put(signedUrl, w.$zlib.gzipSync(new Buffer.from(JSON.stringify(payload))), options);
                    })
                    .then(function(result) {
                        w.spinner = false
                        w.currentShare = {
                            params: params,
                            theme: theme,
                            path: path
                        }
                        w.lastShared = w.subId;
                        showShare(params, path, theme)
                    })
                    .catch(function(err) {
                        w.spinner = false
                        console.log(err);
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: "Error",
                                text: "unable to save G25 model(s)",
                                class: 'warning'
                            }
                        })
                    });

            } else {
                showShare(params, w.currentShare.path, w.currentShare.theme)
            }

            function showShare(params, path, theme) {
                if (params === 'save') {
                    let url = 'https://genoplot.com/shared/g25/?share=' + path + '#' + theme
                    let buttons = [{
                        title: "Copy URL",
                        handler: (i, event) => {
                            copy(url)
                            document.getElementById('button-dialog-' + i).textContent = "URL Copied!"
                        }
                    }, {
                        title: '<a href="mailto:?subject=my Genoplot Global 25 model&body=' + url + '" >Email</a>'
                    }, {
                        title: 'Close',
                        default: true
                    }]
                    w.$modal.show('dialog', {
                        title: 'Share',
                        text: "You can now share this Global 25 model from this <br><a target='_blank' href='https://genoplot.com/shared/g25/?share=" + path + "#" + theme + "'>link</a><br>",
                        buttons: buttons,
                        clickToClose: false,
                        class: 'alert',
                        beforeClosed: function(event) {
                            console.log('closing', event)
                        }
                    })
                } else {
                    w.share({
                        name: params,
                        params: {
                            theme: theme,
                            path: path
                        }
                    })
                }
            }
        },
        startIntro: function() {
            this.recordEvent('runWalkThru', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            let w = this;
            w.sampleArray = []
            w.groupArray = []
            w.switches.calculator = false;
            w.setCalculator();
            w.$intro.exit();
            w.$intro.setOptions({
                scrollToElement: false,
                doneLabel: 'Close',
                showBullets: false,
                steps: w.steps
            })
            w.$store.commit('change', {
                g25chartJSON: []
            })
            w.collapsed = true;
            w.introData.played = {};
            let evt = 'collapse-select';
            w.$root.$emit(evt, 'activate');
            if (w.steps[0].sound) {
                setTimeout(() => {
                    w.introData.player = new w.$howl({
                        src: w.steps[0].sound.media,
                        autoplay: true,
                        volume: 0.5,
                        onend: function() {}
                    });
                    w.introData.played[0] = true;
                }, 0)

            }
            setTimeout(() => {
            let name = this.user.username + ':' + 'runmonte'
            localStorage.setItem(name, true)
                w.$intro.onafterchange(function(targetElement) {
                    let step = targetElement.dataset.step
                });
                w.$intro.onbeforechange(function(targetElement) {
                    let el = targetElement.id;
                    let stepindex = w.steps.findIndex(x => x.element == `#${el}`)
                    let step = w.steps[stepindex]
                    if (w.introData.player) {
                        w.introData.player.stop()
                        w.introData.player.unload()
                        delete w.introData.player;
                    }
                    if (step && step.validate) {
                        let response = step.validate()
                        if (response && response.activate) {
                            setTimeout(() => {
                                w.$refs[response.activate].activate()
                            }, 50)
                        }
                        return response && response.status ? undefined : false
                    }
                });
                w.$intro.onexit(function(targetElement) {
                    if (w.introData.player) {
                        w.introData.player.stop()
                        w.introData.player.unload()
                        delete w.introData.player;
                    }
                })

                w.$intro.onchange(function(targetElement) {
                    let el = targetElement.id;
                    let stepindex = w.steps.findIndex(x => x.element == `#${el}`)
                    let step = w.steps[stepindex]
                    let introjs = w.steps[stepindex];
                    if (introjs.sound) {
                        setTimeout(() => {
                            w.introData.player = new w.$howl({
                                src: introjs.sound.media,
                                autoplay: true,
                                volume: 0.5,
                                onend: function() {}
                            });
                            w.introData.played[step] = true;
                        }, 0)
                    }
                    if (introjs.activate) {
                        setTimeout(() => {
                            w.$refs[introjs.activate].activate()
                        }, 500)
                    }
                });

                w.$nextTick(() => {
                    w.$intro.start();
                })
            }, 300)
        },
        keySort: function(key) {
            return function naturalSort(a, b) {
                var naturalKey = key

                function isInt(str) {
                    if (isNaN(parseInt(str))) {
                        return false
                    } else {
                        return true
                    }
                }
                var aIsString = isInt(a[naturalKey]) ? false : true
                var bIsString = isInt(b[naturalKey]) ? false : true
                var aIsNumeric = isInt(a[naturalKey]) ? true : false
                var bIsNumeric = isInt(b[naturalKey]) ? true : false
                if (aIsString && bIsString) {
                    if (a[naturalKey] < b[naturalKey]) return -1;
                    if (a[naturalKey] > b[naturalKey]) return 1;
                    return 0
                } else if (aIsNumeric && bIsNumeric) {
                    return parseFloat(a[naturalKey]) - parseFloat(b[naturalKey]);
                } else if (aIsString && bIsNumeric) {
                    return -1;
                } else if (aIsNumeric && bIsString) {
                    return 1;
                } else if (aIsString || aIsNumeric) {
                    return -1;
                } else if (bIsString || bIsNumeric) {
                    return 1;
                } else {
                    return 0;
                }
            };
        },
        setCurrentTable: function(event) {
            let w = this;
            if (event === 'table') {
                w.showTable = true
                setTimeout(function() {
                    w.gridOptions.api.sizeColumnsToFit();
                }, 500)
            } else {
                w.showTable = false
            }
        },
        setCurrentChart: function(event) {
            this.cleared = Date.now()
            let w = this;
            if (event === 'chart') {
                this.showMap = false;
                this.onSelectionChanged();
            }
            if (event === 'map') {
                let height = w.$refs['mapwrapper'] && w.$refs['mapwrapper'].$el ? w.$refs['mapwrapper'].$el.clientHeight : 0
                console.log('height', height)
                if (height) w.gridHeight = height
                this.showMap = true;
            } else {
                w.gridHeight = 0;
                this.showMap = false;
            }
            this.currentShare = false;
        },
        resetMap: function(params, instance, echarts) {
            let w = this;
            let pin;
            w.map.fullmap = w.map.fullmap || 1
            let increment = function() {
                if (w.map.series && w.map.series[1] && w.map.series[1].data) {
                    pin = w.map.series[1].data.find(x => x.symbol == 'pin')
                }
                if (!w.map.geo.center && pin && pin.value) {
                    w.map.geo.center = pin.value;
                    w.map.geo.zoom = 4;
                    w.map.fullmap = w.map.fullmap + 1
                } else {
                    w.map.geo.center = undefined
                    w.map.geo.zoom = 1.25
                    w.map.fullmap = w.map.fullmap + 1
                }
                w.$refs['echartmap'].mergeOptions({
                    geo: {
                        center: w.map.geo.center,
                        zoom: w.map.geo.zoom
                    }
                })
                w.mapOptions = {
                    geo: {
                        center: w.map.geo.center,
                        zoom: w.map.geo.zoom
                    }
                }
            }
            if (w.map.fullmap < 2) {
                w.fullmap = false
                increment()
            } else {
                if (w.map.fullmap == 2) {
                    w.fullmap = true
                    w.map.fullmap = 3
                } else if (w.map.fullmap == 3) {
                    increment()
                } else if (w.map.fullmap >= 4) {
                    w.fullmap = false
                    w.map.fullmap = 1
                }
            }

        },
        mapAction: function(params) {
            if (params.value || params.data.value) {
                let value = params.data.value ? params.data.value : params.value
                let center = value === [0, 0] ? undefined : value
                let zoom = value === [0, 0] || !value ? 1.25 : 4
                this.map.geo.center = center;
                this.map.geo.zoom = zoom;
                this.$refs['echartmap'].mergeOptions({
                    geo: {
                        center: center,
                        zoom: zoom
                    }
                })
                this.mapOptions = {
                    geo: {
                        center: center,
                        zoom: zoom
                    }
                }
            } else {
                this.map.geo.center = undefined
                this.map.geo.zoom = 1.25
                this.$refs['echartmap'].mergeOptions({
                    geo: {
                        center: undefined,
                        zoom: 1.25
                    }
                })
                this.mapOptions = {}
            }
        },
        log: function(event) {
            console.log('fired', event);
        },
        download: async function(event) {
            let w = this;
            let calculator = false;
            this.recordEvent(`download-${event}`, {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            if (event === 'groups' || event === 'samples' || event === 'similarity') {
                let subId = this.$store.getters.get('user').username + ':' + Date.now();
                this.$store.commit('change', {
                    subId: subId
                })
                if (event === 'groups' && w.groupArray[0].calculator) {
                    try {
                        this.$store.commit('change', {
                            spinner: true
                        })
                        let errorArr = []
                        let params = {
                            sub: subId,
                            calculator: w.groupArray[0].calculator,
                            sample: this.$store.getters.get('user').username,
                            creator: w.groupArray[0].user
                        }
                        const data = await w.$apollo.query({
                            query: getCalcQuery,
                            variables: {
                                params: JSON.stringify(params)
                            }
                        })
                        if (data.data && data.data.getCalc && data.data.getCalc.result) {
                            let buffer = Buffer.from(data.data.getCalc.result, 'base64')
                            let jsonStr = w.$zlib.unzipSync(buffer).toString()
                            let result = JSON.parse(jsonStr)
                            if (result) {
                                w.getXLS().then((res) => {
                                    let wb = XLSX.utils.book_new();
                                    result = result.map(x => {
                                        let sample = {
                                            sample: x.sample
                                        };
                                        if (w.mode !== 'G25' && w.modecomponents[w.mode]) {
                                            x.coords.split(',').map((y, i) => {
                                                sample[w.modecomponents[w.mode][i]] = parseFloat(y)
                                            })
                                        } else {
                                            x.coords.split(',').map((y, i) => {
                                                sample[`PC${i  + 1}`] = parseFloat(y)
                                            });
                                        }
                                        return sample
                                    })
                                    var ws = XLSX.utils.json_to_sheet(result, {
                                        skipHeader: false
                                    });
                                    XLSX.utils.book_append_sheet(wb, ws, "results");
                                    XLSX.writeFile(wb, "calculator_datasheet.csv", {
                                        compression: true
                                    });
                                    this.$store.commit('change', {
                                        spinner: false
                                    })
                                })
                            } else {
                                console.log(`calculator not found`)
                                this.$store.commit('change', {
                                    spinner: false
                                })
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'show',
                                    component: 'nav',
                                    params: {
                                        title: 'Error',
                                        text: `Calculator not found, this is probably an error that should be reported to the Genoplot support team`,
                                        class: 'warning'
                                    }
                                })
                            }
                        } else {
                            console.log(`calculator not found`)
                            this.$store.commit('change', {
                                spinner: false
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: 'Error',
                                    text: `Calculator not found, this is probably an error that should be reported to the Genoplot support team`,
                                    class: 'warning'
                                }
                            })
                        }
                    } catch (err) {
                        this.$store.commit('change', {
                            spinner: false
                        })
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Error',
                                text: err,
                                class: 'failure'
                            }
                        })

                    }
                } else {
                    let name = event === 'groups' ? 'sources' : event === 'samples' ? 'targets' : 'categorized'
                    name = name + '_datasheet.csv'
                    let number = 0
                    w.sampleArray.map(x => {
                        number = number + (x.samples ? x.samples : 1)
                    })
                    let max = w.subType > 0 ? 500 : 250
                    if (number > max) {
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Maximum download size exceeded',
                                text: `You've selected ${number} samples<br/><b>The maximum number of samples that can be exported to a datasheet is ${max}</b><br/>If you need more than w number, please export in multiple batches`,
                                class: 'alert'
                            }
                        })
                    } else {
                        this.$store.commit('change', {
                            spinner: true
                        })
                        let unscaled = this.mode !== 'G25' ? false : this.switches.scaled ? false : true;
                        let filtered = this.switches.removeOutliers ? true : false
                        let arr = event === 'groups' ? w.groupArray : w.sampleArray
                        let customsamples = false;
                        let submitArr = []
                        let submitFiltered = []
                        if (event === 'samples' || event === 'similarity') {
                            arr.forEach(sample => {
                                let vsample = w.mode !== 'G25' && sample.mode ? sample.group + '|' + w.mode : sample.v ? sample.group + '|' + sample.v : sample.group;
                                submitArr.push(vsample + ':' + sample.sample)
                                if (this.g25customsamples && this.g25customsamples.length > 0 && this.g25customsamples.findIndex(x => x.split(':')[1] == sample.sample && x.split(':')[0] == vsample) >= 0) customsamples = this.g25Rerun
                            })
                        } else {
                            arr.forEach(group => {
                                if (group.label) {
                                    group.label = group.label.replace(' ► ', ':')
                                    let vgroup = group.v ? (group.label.split(':').length > 1 ? group.label.split(':')[0] + '|' + group.v + ':' + group.label.split(':')[1] : group.label + '|' + group.v) : w.mode !== 'G25' ? (group.label.split(':').length > 1 ? group.label.split(':')[0] + '|' + w.mode + ':' + group.label.split(':')[1] : group.label.split(':')[0] + '|' + w.mode) : group.label;
                                    if (w.g25customsamples && w.g25customsamples.length > 0 && w.g25customsamples.findIndex(sample => sample.split(':')[1] == group.sample && sample.split(':')[0] == group.group) >= 0) customsamples = w.g25Rerun
                                    submitArr.push(vgroup)
                                } else {
                                    submitArr.push(group.group + ':' + group.sample)
                                    quantity = quantity + 1;
                                    if (w.g25customsamples && w.g25customsamples.length > 0 && w.g25customsamples.findIndex(sample => sample.split(':')[1] == group.sample && sample.split(':')[0] == group.group) >= 0) customsamples = w.g25Rerun
                                }
                            })
                        }
                        let params = {
                            groups: submitArr,
                            subId: subId,
                            custom: w.switches.custom ? true : false,
                            mode: w.mode !== 'G25' ? w.mode : undefined,
                            raw: w.mode !== 'G25' ? true : false,
                            version: w.mode !== 'G25' ? undefined : w.publicGroups[0].v,
                            unscaled: unscaled,
                            customsamples: customsamples
                        }
                        let query = getSamplesQuery
                        let results = []
                        let data = await w.$apollo.query({
                            query: query,
                            variables: {
                                params: JSON.stringify(params)
                            },
                            fetchPolicy: 'network-only'
                        })
                        let notdownloaded = []
                        if (data && data.data.getSamples && data.data.getSamples.samples) {
                            let buffer = Buffer.from(data.data.getSamples.samples, 'base64')
                            let jsonStr = w.$zlib.unzipSync(buffer).toString()
                            let samples = JSON.parse(jsonStr)
                            if (!w.isAdmin) {
                                notdownloaded = samples.filter(x => x.download == 1 && x.ogroup != w.user.username).map(x => {
                                    return x.ogroup + ' ► ' + x.osample
                                })
                                samples = samples.filter(x => !x.download || x.ogroup == w.user.username)
                            }
                            samples.map(x => {
                                let result;
                                if (event === 'similarity') {
                                    x.sample = x.sample.replace('_outlier', '')
                                    let similar = x.group + ':' + x.sample
                                    let coords = x.coords
                                    let group = w.heatmapJSON.find(y => y.name === x.sample && y.group.split('|')[0] === x.group)
                                    if (group) {
                                        let length = group.data.length
                                        similar = group.data.find(x => parseInt(x.y) == 2 * length)
                                        if (similar) {
                                            similar = ((x.alias ? x.alias : x.group) + '[' + similar.x + ']:' + x.sample).replace(/ /g, '_')
                                        }
                                    }
                                    result = {
                                        'sample': similar
                                    };
                                } else {
                                    result = {
                                        'sample': (x.alias ? x.alias : x.group) + ':' + x.sample + (w.switches.scaled && w.mode === 'G25' ? '_scaled' : '')
                                    };
                                }
                                if (x.coords.length > 0) x.coords.map((y, i) => {
                                    if (w.mode !== 'G25' && w.modecomponents[w.mode]) {
                                        result[w.modecomponents[w.mode][i]] = parseFloat(y)
                                    } else {
                                        result[`PC${i  + 1}`] = parseFloat(y)
                                    }
                                })
                                results.push(result);
                            })
                        }
                        try {
                            if (results.length > 0) {
                                this.getXLS().then((res) => {
                                    var wb = XLSX.utils.book_new();
                                    var ws = XLSX.utils.json_to_sheet(results, {
                                        skipHeader: false
                                    });
                                    XLSX.utils.book_append_sheet(wb, ws, "results");
                                    XLSX.writeFile(wb, name, {
                                        compression: true
                                    });
                                    this.$store.commit('change', {
                                        spinner: false
                                    })
                                    if (notdownloaded.length > 0) {
                                        w.$eventBus.$emit('appEvents', {
                                            exec: 'show',
                                            component: 'nav',
                                            params: {
                                                title: '',
                                                text: notdownloaded.length > 0 ? `Some samples filtered due to user preferences:<br/>${notdownloaded}` : `No downloadable samples found in current selection`,
                                                class: 'warning'
                                            }
                                        })
                                    }
                                }).catch(err => {
                                    this.$store.commit('change', {
                                        spinner: false
                                    })
                                    console.log(err)
                                })
                            } else {
                                this.$store.commit('change', {
                                    spinner: false
                                })
                                console.log('Nothing to export..', notdownloaded)
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'show',
                                    component: 'nav',
                                    params: {
                                        title: '',
                                        text: notdownloaded.length > 0 ? `Some samples filtered due to user preferences:<br/>${notdownloaded}` : `No downloadable samples found in current selection`,
                                        class: 'warning'
                                    }
                                })
                            }
                        } catch (err) {
                            consoleWithNoSource(err)
                            this.$store.commit('change', {
                                spinner: false
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: 'Error!',
                                    text: err,
                                    class: 'failure'
                                }
                            })
                        }
                    }
                }
            } else {}
        },
        toggleGrid: function(klass) {
            var layout = klass === 0 ? 'Chart' : klass === 1 ? 'Data' : 'Both';
            this.$store.commit('change', {
                showGrid: klass
            })
            var slider = this.slider;
            slider.layout.value = layout;
            this.$store.commit('change', {
                slider: slider
            })
        },
        featureRequest(item) {
            this.recordEvent(item, {
                'event_category': 'feature',
                'event_label': 'click'
            })
            if (item !== 'calculators') {
                this.$eventBus.$emit('spinner', 'run')
                setTimeout(() => {
                    this.$eventBus.$emit('spinner', 'stop')
                }, 3000)
                var options = {
                    save: {
                        title: 'Save Report',
                        text: "Save to the cloud functionality is coming soon!<br/><br/>In the meantime, you can export charts, maps and data to svg, png and xls files on your device<br><br><b>Right-click on the charts and tables to see the options available</b>",
                        class: 'alert'
                    },
                    upload: {
                        title: 'Upload Raw DNA files',
                        text: "Thank you for your interest,the ability to upload raw DNA files will be available in an upcoming release!"
                    },
                    twitter: {
                        title: 'Share to Twitter',
                        text: "The ability to share your results to Twitter will be available in the next release!"
                    },
                    facebook: {
                        title: 'Share to Facebook',
                        text: "The ability to share your results to Facebook will be available in a future release!"
                    },
                    instagram: {
                        title: 'Share to Instagram',
                        text: "The ability to share your results to Instagram will be available in a future release!"
                    },
                    calculators: {
                        title: 'Custom Calculators',
                        text: "Thank you for your interest, but custom calculators are not yet available"
                    }
                }
                var title = options[item].title
                var text = options[item].text
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: title,
                        text: text,
                        class: 'alert'
                    }
                })
            }
        },
        editSamples: function(event) {
            this.queryTimeStamp = Date.now();
            this.recordEvent('editSamples', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            //this.switches.calculator = false;
            //this.setCalculator();
            this.$modal.show('SamplesModal', {
                groupJSON: this.groupJSON,
                sampleJSON: this.sampleJSON,
                showNonRawUploadIcons: this.showNonRawUploadIcons,
                add: event === 'add' ? true : false
            });
            return;
        },
        editCalculators: function(event) {
            this.recordEvent('editCalculators', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            this.$modal.show('CalcSamplesModal', {
                groupJSON: this.groupJSON,
                sampleJSON: this.sampleJSON,
                add: event === 'add' ? true : false
            });
            return;
        },
        customExec: function(event) {
            this.featureRequest('save')
            return;
            this.chartReady = !this.chartReady
            this.$store.commit('change', {
                spinner: !this.running
            })
            this.progress = this.progress === 0 ? 50 : 0;
            return false;
        },
        onDragStopped() {
            var headers = [];
            var columns = this.gridOptions.columnApi.getAllGridColumns()
            columns.forEach((col, i) => {
                if (col.colDef.field !== 'sample' && col.colDef.field !== 'distance') {
                    headers.push(col.colDef.field)
                }
            })
            this.$store.commit('change', {
                g25chartComponents: headers
            })
            this.components = headers;
            var series = this.series;
            var result = []
            headers.forEach(component => {
                result.push(series.find(item => item.name === component))
            })
            this.$store.commit('change', {
                g25chartSeries: result
            })
        },
        selectBarChart: function(index) {
            if (index || index === 0) {
                this.currentIndex = index;
                this.$store.commit('change', {
                    currentIndex: index
                })
                let profile = this.categories[this.currentIndex]
                let chartindex = 0;
                chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[0].replace(/-raw/, '')} ► ${x.alias.split(':')[1]}`.replace(/_/g, ' ').trim() == profile.replace(/-raw/, '').replace(/_/g, ' ').trim())
                this.currentChartIndex = chartindex;
                this.currentChartIndex = this.currentChartIndex < 0 ? 0 : this.currentChartIndex
                let labels = []
                let colors = []
                let comps = []
                this.newcomponents.forEach((comp, i) => {
                    labels.push("<div class='result-tip'>" + comp.replace(/_/g, " ") + "</div><b><div class='result-tip-value'>" + this.newseries[i].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>")
                })
                var chartOptions = JSON.parse(JSON.stringify(this.chartOptions))
                chartOptions.labels = labels;
                chartOptions.colors = this.newcolors;
                chartOptions.legend.offsetY = (16 - this.newcomponents.length) * 4 - 20
                this.chartOptions = chartOptions;
                this.map.series[0].data = this.mapseries
                if (this.switches.calculator && this.calcComponents.length > 0) this.sunOptions.series.data = this.sunburstSeries
            } else {
                return false;
            }
        },
        onHeatmapClicked(sample) {
            let index = this.categories.findIndex(x => x.split('@')[0] === sample)
            if (index >= 0) {
                this.currentIndex = index;
                this.$store.commit('change', {
                    currentIndex: index
                })
                let labels = []
                let colors = []
                let comps = []
                this.newcomponents.forEach((comp, i) => {
                    labels.push("<div class='result-tip'>" + comp.replace(/_/g, " ") + "</div><b><div class='result-tip-value'>" + this.newseries[i].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>")
                })
                var chartOptions = JSON.parse(JSON.stringify(this.chartOptions))
                chartOptions.labels = labels;
                chartOptions.updated = Date.now();
                chartOptions.colors = this.newcolors;
                chartOptions.legend.offsetY = (16 - this.newcomponents.length) * 4 - 20
                this.chartOptions = chartOptions;
                this.map.series[0].data = this.mapseries
                if (this.switches.calculator && this.calcComponents.length > 0) this.sunOptions.series.data = this.sunburstSeries
            }
        },
        onSelectionChanged() {
            if (this.gridOptions && this.gridOptions.api) {
                this.gridApi = this.gridOptions.api;
                var selectedRows = this.gridApi.getSelectedRows();
                //console.log(`${this.chartJSON[1].profile.split(':')[1].replace(/-raw/, '').replace(/_/g, ' ')} (${this.chartJSON[1].profile.split(':')[0]})`)
                //console.log(selectedRows[0].sample.replace(/_/g, ' ').trim())
                if (selectedRows.length > 0) {
                    this.rowsSelected = true;
                    let index = this.categories.findIndex(x => x.replace(/_/g, ' ').split('@')[0] === selectedRows[0].sample.split(' (').reverse().join(' ► ').replace(/\)/, '').replace(/_/g, ' '))
                    let chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '').replace(/_/g, ' ')} (${x.alias.split(':')[0].replace(/_/g, ' ')})`.trim() == selectedRows[0].sample.replace(/_/g, ' ').trim())
                    this.currentChartIndex = chartindex;
                    this.currentChartIndex = this.currentChartIndex < 0 ? 0 : this.currentChartIndex
                    this.currentIndex = index;
                    this.$store.commit('change', {
                        currentIndex: index
                    })
                    let labels = []
                    let colors = []
                    let comps = []
                    this.newcomponents.forEach((comp, i) => {
                        labels.push("<div class='result-tip'>" + comp.replace(/_/g, " ") + "</div><b><div class='result-tip-value'>" + this.newseries[i].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>")
                    })
                    var chartOptions = JSON.parse(JSON.stringify(this.chartOptions))
                    chartOptions.labels = labels;
                    chartOptions.updated = Date.now();
                    chartOptions.colors = this.newcolors;
                    chartOptions.legend.offsetY = (16 - this.newcomponents.length) * 4 - 20
                    this.chartOptions = chartOptions;
                    this.map.series[0].data = this.mapseries
                    if (this.switches.calculator && this.calcComponents.length > 0) this.sunOptions.series.data = this.sunburstSeries
                } else {
                    this.rowsSelected = false;
                }
            }
        },
        onSortChanged(event) {
            var columns = this.gridOptions.columnApi.getAllGridColumns()
            var sorted = columns.find(col => typeof(col.sort) !== 'undefined');
            //if (sorted && sorted.colDef && sorted.colDef.field) this.processJSON(sorted.colDef.field, sorted.sort);
        },
        copyTableSelectionBB() {
            var w = this;
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsArray = []
            selectedRows.forEach(function(selectedRow, index) {
                selectedRowsArray.push(selectedRow);
            });
            let headers;
            if (selectedRowsArray.length === 1) {
                if (w.switches.heatmap && !w.switches.calculator) {
                    headers = {}
                    let w = this;
                    let components = []
                    w.columnDefs.map((comp, i) => {
                        if (i > 1) {
                            components.push(comp.headerName.replace(/\(.*\)/, ''))
                        }
                    })
                    headers.key = 'Results'
                    headers.value = ''
                    headers.results = ''
                    var tabledata = []
                    var currentIndex = this.currentIndex ? this.currentIndex : 0
                    var sample = selectedRowsArray[0]
                    tabledata.push({
                        key: 'Sample:',
                        value: sample.sample.replace(/_/g, ' ').replace(/:/g, " ► "),
                        results: ''
                    })
                    tabledata.push({
                        key: 'Nearest:',
                        value: sample.display && sample.display.findIndex(x => parseFloat(sample.distance) == parseFloat(x.toFixed(2))) >= 0 ? sample.distance + ` (${components[sample.display.findIndex( x => parseFloat(sample.distance) == parseFloat(x.toFixed(2)))]})` : sample.distance,
                        results: ''
                    })
                    components.forEach((comp, i) => {
                        if (sample.display && sample.display[i] && typeof(sample.display[i]) !== 'undefined') {
                            let obj = {}
                            obj.key = i === 0 ? 'Results:' : ''
                            obj.value = comp.replace(/_/g, ' ')
                            obj.results = sample.display && sample.display[i] ? sample.display[i] : 0
                            if (parseFloat(obj.results) > 0) tabledata.push(obj);
                        }
                    })
                } else {
                    headers = {}
                    let w = this;
                    headers.key = 'Results'
                    headers.value = ''
                    headers.results = ''
                    var tabledata = []
                    var currentIndex = this.currentIndex ? this.currentIndex : 0
                    var sample = selectedRowsArray[0]
                    tabledata.push({
                        key: 'Sample:',
                        value: sample.sample.replace(/_/g, ' ').replace(/:/g, " ► "),
                        results: ''
                    })
                    tabledata.push({
                        key: 'Fit:',
                        value: sample.distance,
                        results: ''
                    })
                    w.components.forEach((result, i) => {
                        if (typeof(sample[result]) !== 'undefined') {
                            let obj = {}
                            obj.key = i === 0 ? 'Results:' : ''
                            obj.value = result.replace(/_/g, ' ')
                            obj.results = sample[result]
                            if (sample[result] && parseFloat(sample[result]) > 0) tabledata.push(obj);
                        }
                    })
                }
                var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
                var replaceHeaders = new RegExp('<thead>(.*?)</thead>')
                copyhtml = copyhtml.replace(replaceHeaders, '')
                copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
                var replace = new RegExp(' class=.*?]', 'g')
                copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']')
                let size = tabledata.length > 6 ? 1 : 1
                copyhtml = `[size=${size}]${copyhtml}[/size]`
                if (w.subId === w.lastShared) copyhtml = `[URL="https://genoplot.com/shared/g25/?share=${w.currentShare.path + '#' + w.currentShare.theme}"][IMG]https://genoplot.com/genoplot16.png[/IMG]&#8194;[B][SIZE=3]GenoPlot[/SIZE][/B][/URL]\n` + copyhtml
            } else {
                let headers = {}
                headers.sample = 'Sample'
                headers.distance = w.switches.heatmap && !w.switches.calculator ? 'Nearest' : 'Fit'
                let components = []
                if (w.switches.heatmap && !w.switches.calculator) {
                    w.columnDefs.map((comp, i) => {
                        if (i > 1) {
                            components.push(comp.headerName.replace(/\(.*\)/, ''))
                        }
                    })
                } else {
                    w.components.map(comp => {
                        components.push(comp)
                    })
                }
                components.forEach(comp => headers[comp.replace(/_/g, ' ')] = comp.replace(/_/g, ' '))
                var tabledata = []
                selectedRows.forEach(sample => {
                    var obj = {};
                    obj.distance = sample.distance;
                    if (w.switches.heatmap && !w.switches.calculator) {
                        obj.sample = sample.display && sample.display.findIndex(x => parseFloat(sample.distance) == parseFloat(x.toFixed(2))) >= 0 ? sample.sample.replace(/\(.*\)/, `(${components[sample.display.findIndex( x => parseFloat(sample.distance) == parseFloat(x.toFixed(2)))]})`) : sample.sample
                        components.map((comp, n) => {
                            obj[comp] = typeof(sample.display[n]) !== 'undefined' ? parseFloat(sample.display[n].toFixed(2)) : 0
                        });
                    } else {
                        obj.sample = sample.sample
                        components.map((comp, n) => {
                            obj[comp.replace(/_/g, ' ')] = typeof(sample[comp]) !== 'undefined' ? sample[comp] : 0
                        });
                    }
                    tabledata.push(obj)
                })
                var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
                copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
                var replace = new RegExp(' class=.*?]', 'g')
                copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']').replace(/:/g, " ► ")
                copyhtml = `[size=1]${copyhtml}[/size]`
                if (w.subId === w.lastShared) copyhtml = `[URL="https://genoplot.com/shared/g25/?share=${w.currentShare.path + '#' + w.currentShare.theme}"][IMG]https://genoplot.com/genoplot16.png[/IMG]&#8194;[B][SIZE=3]GenoPlot[/SIZE][/B][/URL]\n\n` + copyhtml
            }
            copy(copyhtml, {
                ashtml: false,
            });
        },
        copyTableSelection(type) {
            let selectedRows = this.gridApi.getSelectedRows();
            let w = this;
            let headers = {}
            headers.sample = 'Sample'
            headers.distance = w.switches.heatmap && !w.switches.calculator ? 'Nearest' : 'Fit'
            let components = []
            if (w.switches.heatmap && !w.switches.calculator) {
                w.columnDefs.map((comp, i) => {
                    if (i > 1) {
                        components.push(comp.headerName.replace(/\(.*\)/, ''))
                    }
                })
            } else {
                w.components.map(comp => {
                    components.push(comp)
                })
            }
            components.forEach(comp => headers[comp.replace(/_/g, ' ')] = comp.replace(/_/g, ' '))
            var tabledata = []
            selectedRows.forEach(sample => {
                var obj = {};
                obj.distance = sample.distance;
                if (w.switches.heatmap && !w.switches.calculator) {
                    obj.sample = sample.display && sample.display.findIndex(x => parseFloat(sample.distance) == parseFloat(x.toFixed(2))) >= 0 ? sample.sample.replace(/\(.*\)/, `(${components[sample.display.findIndex( x => parseFloat(sample.distance) == parseFloat(x.toFixed(2)))]})`) : sample.sample
                    components.map((comp, n) => {
                        obj[comp] = typeof(sample.display[n]) !== 'undefined' ? parseFloat(sample.display[n].toFixed(2)) : 0
                    });
                } else {
                    obj.sample = sample.sample
                    components.map((comp, n) => {
                        obj[comp.replace(/_/g, ' ')] = typeof(sample[comp]) !== 'undefined' ? sample[comp] : 0
                    });
                }
                tabledata.push(obj)
            })
            var copyhtml = new Table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            let copytext = this.$yaml.stringify(tabledata, 2).replace(/-\n/g, '\n').replace(/'/g, '')
            if (type && type == 'md') {
                let table = []
                let tablehead = Object.keys(headers).map(x => headers[x])
                table.push(tablehead);
                tabledata.map(x => {
                    let row = []
                    Object.keys(headers).map(y => {
                        row.push(typeof(x[y]) == 'string' ? x[y].replace('<b>', '').replace('</b><br/><br/>', '').replace('<br/>', ' ') : x[y])
                    })
                    table.push(row);
                })
                let copyhtml = w.$mdtable(table)
                copy(copyhtml, {
                    asHtml: false
                });
            } else if (type === 'text') {
                copy(copytext, {
                    asHtml: false,
                });
            } else {
                copy(copyhtml, {
                    asHtml: true,
                });
            }
        },
        detailResults: function(bb) {
            let w = this;
            if (!bb) {
                let string = ''
                let index = this.currentIndex || 0
                let json = this.chartJSON[w.currentChartIndex]
                let output = {}
                output['Calculator Result'] = {
                    Fit: json.distance.toFixed(4),
                    Scores: json.result
                }
                if (json.groupResult) output['Group Result'] = json.groupResult
                if (json.sampleResult) output['Sample Result'] = json.sampleResult
                if (json.mapResult) output['Geo Result'] = json.mapResult
                //consoleWithNoSource(JSON.stringify(output, null, 2))
                //consoleWithNoSource(this.$yaml.stringify(output).replace(/-\n/g,'\n').replace(/'/g,''))
                let result = this.$yaml.stringify(output, 4, 3).replace(/-\n/g, '\n').replace(/'/g, '')
                //consoleWithNoSource(result)
                copy(result, {
                    asHtml: false,
                });
            } else {
                let tabledata = []
                let index = this.currentIndex || 0
                let json = this.chartJSON[w.currentChartIndex]
                tabledata.push({
                    key: `[B][size=1]Detailed Results[/size][/B]`,
                    value: w.groupArray[0] ? `${decodeURI(w.groupArray[0].label).trim()} by ${decodeURI(w.groupArray[0].user).trim()}` : '',
                    value: '',
                    results: '',
                    subresults: ''
                })
                tabledata.push({
                    key: `Sample:   ${json.profile.replace(/_/g, ' ').replace(/:/g, " ► ")}`,
                    value: '',
                    results: '',
                    subresults: ''
                })
                let headers = {
                    key: 'Detailed Results',
                    value: '',
                    results: '',
                    subresults: ''
                }
                tabledata.push({
                    key: `Fit:    ${json.distance}`,
                    value: '',
                    results: '',
                    subresults: ''
                })
                tabledata.push({
                    key: '[B]Calculator Result[/B]',
                    value: '',
                    results: '',
                    subresults: ''
                })
                Object.keys(json.result).forEach((result, i) => {
                    let obj = {}
                    obj.key = ' ' + result.replace(/_/g, ' ').replace(/:/g, " ► ")
                    obj.results = ''
                    obj.value = '  ' + json.result[result]
                    obj.subresults = ''
                    tabledata.push(obj);
                })
                tabledata.push({
                    key: '[B]Group Result[/B]',
                    value: '',
                    results: '',
                    subresults: ''
                })
                Object.keys(json.groupResult).forEach((result, i) => {
                    let obj = {}
                    obj.key = ' ' + result.replace(/_/g, ' ').replace(/:/g, " ► ")
                    obj.results = ''
                    obj.value = '  ' + json.groupResult[result]
                    obj.subresults = ''
                    tabledata.push(obj);
                })
                tabledata.push({
                    key: '[B]Sample Result[/B]',
                    value: '',
                    results: '',
                    subresults: ''
                })
                Object.keys(json.sampleResult).forEach((result, i) => {
                    let obj = {}
                    obj.key = ' ' + result.replace(/_/g, ' ').replace(/:/g, " ► ")
                    obj.results = ''
                    obj.value = '  ' + json.sampleResult[result]
                    obj.subresults = ''
                    tabledata.push(obj);
                })
                tabledata.push({
                    key: '[B]Geo Result[/B]',
                    value: '',
                    results: '',
                    subresults: ''
                })
                Object.keys(json.mapResult).forEach((result, i) => {
                    let obj = {}
                    obj.results = ''
                    obj.key = ' ' + result.replace(/_/g, ' ').replace(/:/g, " ► ")
                    obj.value = json.mapResult[result] && json.mapResult[result].value ? '  ' + json.mapResult[result].value : ''
                    obj.subresults = ''
                    tabledata.push(obj);
                    if (json.mapResult[result] && json.mapResult[result].regional && Object.keys(json.mapResult[result].regional).length > 0) {
                        Object.keys(json.mapResult[result].regional).forEach((region, i) => {
                            let obj = {}
                            obj.results = ''
                            obj.key = '[I]   ' + region.replace(/_/g, ' ') + '[/I]'
                            obj.value = '[I]  ' + json.mapResult[result].regional[region] + '[/I]'
                            obj.subresults = ''
                            tabledata.push(obj);
                        })
                    }
                })
                var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
                var replaceHeaders = new RegExp('<thead>(.*?)</thead>')
                copyhtml = copyhtml.replace(replaceHeaders, '')
                copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
                var replace = new RegExp(' class=.*?]', 'g')
                copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']')
                let size = tabledata.length > 6 ? 1 : 1
                copyhtml = `[size=${size}]${copyhtml}[/size]`
                copy(copyhtml, {
                    asHtml: false,
                });
            }
        },
        fadeResults: function() {
            this.chartReady = false;
        },
        showResults: function() {
            if (this.series && this.series.length > 0) {
                this.chartReady = true;
            }
        },
        resetCustomSamples: function(evt) {
            this.customSampleCount = 0;
            this.csv = undefined;
            if (this.formstate._reset) this.formstate._reset()
        },
        resetSamples: function(event) {
            this.sampleArray = [];
            var name = this.user.username + ':' + 'sampleArray'
            this.$store.commit('change', {
                sampleArray: []
            })
            localStorage.setItem(name, JSON.stringify({
                sampleArray: []
            }));
            if (this.groupArray.length === -100) {
                this.$eventBus.$emit('appEvents', {
                    exec: 'reset',
                    component: 'nav'
                })
            }
            if (this.groupArray.length === 0) {
                this.chartReady = false;
                this.$store.commit('change', {
                    g25chartSeries: []
                })
                this.$store.commit('change', {
                    g25chartKey: false
                })
                this.$store.commit('change', {
                    g25chartJSON: []
                })
            }
        },
        setCalculator: function() {
            try {
                this.$refs.leftSelectinput.updateSearch('');
                this.$refs.rightSelectinput.updateSearch('');
            } catch (err) {}
            this.calcGroupsArray = []
            this.filteredGroupOptions = []
            if (!this.switches.calculator) {
                this.switches.lite = false
                this.syncStore('switches.lite');
            }
            this.syncStore('switches.calculator');
        },
        resetCalcGroups: function() {
            this.calcGroupsArray = []
        },
        resetGroups: function() {
            this.markerState = false;
            this.activeName = false;
            this.activeContent = false;
            this.activePath = false;
            this.groupArray = [];
            this.calcGroupsArray = []
            this.$store.commit('change', {
                groupArray: []
            })
            var name = this.user.username + ':' + 'groupArray'
            localStorage.setItem(name, JSON.stringify({
                groupArray: []
            }));
            if (this.sampleArray.length === -100) {
                this.$eventBus.$emit('appEvents', {
                    exec: 'reset',
                    component: 'nav'
                })
            }
            if (this.sampleArray.length === 0) {
                this.chartReady = false;
                this.$store.commit('change', {
                    g25chartSeries: []
                })
                this.$store.commit('change', {
                    g25chartKey: false
                })
                this.$store.commit('change', {
                    g25chartJSON: []
                })
            }
            let localname = this.user.username + ':switches'
            let lswitches = localStorage.getItem(localname);
            if (lswitches) this.$store.commit('change', JSON.parse(lswitches))
        },
        setChartReady: function() {
            //this.series = this.sampledata;
            this.chartReady = true;
        },
        getDetail: function(comp) {
            if (this.groupJSON) {
                var group = this.groupJSON.find(x => x.label === comp)
                if (group && (group.origin || group.age)) {
                    var label = group.label.replace(/_/g, " ");
                    var age = group.age ? group.age : null
                    var origin = group.origin ? group.origin : null
                    //returnLabel(label, age, origin);
                    if ((age !== null && typeof(age) !== 'undefined') || (origin !== null && typeof(origin) !== 'undefined')) {
                        age = age === null || typeof(age) === 'undefined' ? '' : (age - 100000) < 0 ? -1 * (age - 100000) + ' BCE' : age - 100000 + ' CE';
                        origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                        return (origin + ' ' + label + '  ' + age).replace(/_/g, ' ')
                    } else {
                        return label.replace(/_/g, ' ')
                    }
                } else {
                    return comp.replace(/_/g, ' ')
                }
            } else {
                return comp.replace(/_/g, ' ')
            }

            function returnLabel(label, age, origin) {}
        },
        writeSheet() {
            if (!this.switches.calculator && this.switches.heatmap && this.sampleArray.length > 0) {
                this.getSamples();
            } else {
                if (this.sheet) {
                    this.$store.commit('change', {
                        spinner: true
                    })
                    this.getXLS().then((res) => {
                        var wb = XLSX.utils.book_new();
                        var ws = XLSX.utils.aoa_to_sheet(this.sheet);
                        XLSX.utils.book_append_sheet(wb, ws, "results");
                        XLSX.writeFile(wb, "results.csv", {
                            compression: true
                        });
                        this.$store.commit('change', {
                            spinner: false
                        })
                    }).catch(err => {
                        this.$store.commit('change', {
                            spinner: false
                        })
                        console.log(err)
                    })
                } else {
                    console.log('Nothing to export..')
                }
            }
        },

        createImage: async function(el, type) {
            console.log('creating image: ', el);
            var filename = el === 'apex-wrapper' ? 'chart' : el === 'apex-heatmap' ? 'heatmap' : el;
            var w = this;
            w.exporting = true;
            w.$store.commit('change', {
                spinner: true
            })
            var node = document.getElementById(el);
            var style = el === 'table' ? {
                marginTop: '-50px',
                marginLeft: '100px',
                padding: 0
            } : el === 'barchart' ? {
                'margin': 0,
                'width': '100%',
                marginTop: '-10px',
                padding: 'unset'
            } : el === 'apex-heatmap' ? {
                marginTop: '-25',
                padding: 0
            } : {
                margin: 100,
                padding: 0
            }
            if (type && type === 'svg') {
                console.log(el, this.theme && el === 'table' ? '#14191f' : this.theme ? 'black' : 'white');
                domtoimage.toSvg(node, {
                        bgcolor: this.theme && el === 'table' ? '#14191f' : this.theme ? 'black' : 'white',
                        style: style
                    })
                    .then(async function(blob) {
                        let svg = blob.replace(/data\:image\/svg\+xml\;charset\=utf-8\,/, '').replace(/\%0A/g, '')
                        let style = ''
                        let element = (el === 'table' || el === 'map') ? el : el === 'apex-heatmap' ? 'heatmap' : 'chart'
                        if (element === 'chart') {
                            let background = w.theme ? '#000000b5' : '#ffffffb5'
                            let title = w.theme ? 'black' : 'white'
                            let string = `#maplegend-wrapper { background: ${background} !important;} `
                            string = el === 'sunburst' ? string + ` .title-container .title {background: ${title} !important;}` : string
                            style = `<style>${string}</style>`
                        } else {
                            style = "<style>* { pointer-events: none;}</style>"
                        }
                        svg = svg.replace(/\>\<foreignObject/, `>${style}<foreignObject`)
                        blob = new Blob([svg], {
                            type: 'image/svg+xml'
                        });
                        window.saveAs(blob, `${filename}.svg`);
                        w.$store.commit('change', {
                            spinner: false
                        })
                        w.exporting = false;

                    }).catch(function(err) {
                        console.log(err);
                        w.$store.commit('change', {
                            spinner: false
                        })
                        w.exporting = false;

                    })
            } else {
                var style = el === 'table' ? {
                    marginTop: '-50px',
                    padding: 0,
                } : el === 'grid2' ? {
                    marginLeft: 100,
                    padding: 0

                } : el === 'barchart' ? {
                    'margin-left': 'unset',
                    'width': '100%',
                    marginTop: '-10px',
                    padding: 'unset'
                } : {
                    marginLeft: 0,
                    padding: 0
                }
                let bgcolor = this.theme && el === 'apex-wrapper' ? '#14191f' : this.theme && el === 'table' ? '#14191f' : this.theme ? '#181818' : 'white';
                domtoimage.toBlob(node, {
                        bgcolor: bgcolor,
                        style: style
                    })
                    .then(function(blob) {
                        var img = new Image();
                        img.src = blob
                        w.$store.commit('change', {
                            spinner: false
                        })
                        w.exporting = false;
                        window.saveAs(blob, `${filename}.png`);
                    }).catch(function(err) {
                        console.log(err);
                        w.$store.commit('change', {
                            spinner: false
                        })
                        w.exporting = false;

                    })
            }

        },
        copyToClipForum() {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.distance = w.switches.heatmap && !w.switches.calculator ? 'Nearest' : 'Fit'
            let components = []
            if (w.switches.heatmap && !w.switches.calculator) {
                w.columnDefs.map((comp, i) => {
                    if (i > 1) {
                        components.push(comp.headerName.replace(/\(.*\)/, ''))
                    }
                })
            } else {
                w.components.map(comp => {
                    components.push(comp)
                })
            }
            components.forEach(comp => headers[comp.replace(/_/g, ' ')] = comp.replace(/_/g, ' '))
            var tabledata = []
            let gridOptions = w.gridOptions
            var count = gridOptions.api.getDisplayedRowCount();
            //w.rowData.forEach(sample => {
            for (var i = 0; i < count; i++) {
                let sample = gridOptions.api.getDisplayedRowAtIndex(i).data
                var obj = {};
                obj.distance = sample.distance;
                if (w.switches.heatmap && !w.switches.calculator) {
                    obj.sample = sample.display && sample.display.findIndex(x => parseFloat(sample.distance) == parseFloat(x.toFixed(2))) >= 0 ? sample.sample.replace(/\(.*\)/, `(${components[sample.display.findIndex( x => parseFloat(sample.distance) == parseFloat(x.toFixed(2)))]})`) : sample.sample
                    components.map((comp, n) => {
                        obj[comp] = typeof(sample.display[n]) !== 'undefined' ? parseFloat(sample.display[n].toFixed(2)) : 0
                    });
                } else {
                    obj.sample = sample.sample
                    components.map((comp, n) => {
                        obj[comp.replace(/_/g, ' ')] = typeof(sample[comp]) !== 'undefined' ? sample[comp] : 0
                    });
                }
                tabledata.push(obj)
            }
            var copyhtml = new Table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
            var replace = new RegExp(' class=.*?]', 'g')
            copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']').replace(/:/g, " ► ")
            copyhtml = `[size=1]${copyhtml}[/size]`
            //if (w.subId === w.lastShared) copyhtml = `[URL="https://genoplot.com/shared/g25/?share=${w.currentShare.path + '#' + w.currentShare.theme}"]GenoPlot[/URL]\n` + copyhtml
            if (w.subId === w.lastShared) copyhtml = `[URL="https://genoplot.com/shared/g25/?share=${w.currentShare.path + '#' + w.currentShare.theme}"][IMG]https://genoplot.com/genoplot16.png[/IMG]&#8194;[B][SIZE=3]GenoPlot[/SIZE][/B][/URL]\n\n` + copyhtml
            copy(copyhtml, {
                asHtml: false,
            });
        },
        copyToClip(type) {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.distance = w.switches.heatmap && !w.switches.calculator ? 'Nearest' : 'Fit'
            let components = []
            if (w.switches.heatmap && !w.switches.calculator) {
                w.columnDefs.map((comp, i) => {
                    if (i > 1) {
                        components.push(comp.headerName.replace(/\(.*\)/, ''))
                    }
                })
            } else {
                w.components.map(comp => {
                    components.push(comp)
                })
            }
            components.forEach(comp => headers[comp.replace(/_/g, ' ')] = comp.replace(/_/g, ' '))
            var tabledata = []
            w.rowData.forEach(sample => {
                var obj = {};
                obj.distance = sample.distance;
                if (w.switches.heatmap && !w.switches.calculator) {
                    obj.sample = sample.display && sample.display.findIndex(x => parseFloat(sample.distance) == parseFloat(x.toFixed(2))) >= 0 ? sample.sample.replace(/\(.*\)/, `(${components[sample.display.findIndex( x => parseFloat(sample.distance) == parseFloat(x.toFixed(2)))]})`) : sample.sample
                    components.map((comp, n) => {
                        obj[comp] = typeof(sample.display[n]) !== 'undefined' ? parseFloat(sample.display[n].toFixed(2)) : 0
                    });
                } else {
                    obj.sample = sample.sample
                    components.map((comp, n) => {
                        obj[comp.replace(/_/g, ' ')] = typeof(sample[comp]) !== 'undefined' ? sample[comp] : 0
                    });
                }
                tabledata.push(obj)
            })
            var copyhtml = new Table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            copyhtml = juice.inlineContent(copyhtml, tablecss)
            let copytext = this.$yaml.stringify(tabledata, 2).replace(/-\n/g, '\n').replace(/'/g, '')
            if (type && type == 'md') {
                let table = []
                let tablehead = Object.keys(headers).map(x => headers[x])
                table.push(tablehead);
                tabledata.map(x => {
                    let row = []
                    Object.keys(headers).map(y => {
                        row.push(typeof(x[y]) == 'string' ? x[y].replace('<b>', '').replace('</b><br/><br/>', '').replace('<br/>', ' ') : x[y])
                    })
                    table.push(row);
                })
                let copyhtml = w.$mdtable(table)
                copy(copyhtml, {
                    asHtml: false
                });
            } else if (type === 'text') {
                copy(copytext, {
                    asHtml: false,
                });
            } else {
                copy(copyhtml, {
                    asHtml: true,
                });
            }
        },
        copyToClipBB() {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.distance = w.switches.heatmap && !w.switches.calculator ? 'Nearest' : 'Fit'
            let components = []
            if (w.switches.heatmap && !w.switches.calculator) {
                w.columnDefs.map((comp, i) => {
                    if (i > 1) {
                        components.push(comp.headerName.replace(/\(.*\)/, ''))
                    }
                })
            } else {
                w.components.map(comp => {
                    components.push(comp)
                })
            }
            components.forEach(comp => headers[comp] = comp)
            var tabledata = []
            w.rowData.forEach(sample => {
                var obj = {};
                obj.distance = sample.distance;
                if (w.switches.heatmap && !w.switches.calculator) {
                    obj.sample = sample.display && sample.display.findIndex(x => parseFloat(sample.distance) == parseFloat(x.toFixed(2))) >= 0 ? sample.sample.replace(/\(.*\)/, `(${components[sample.display.findIndex( x => parseFloat(sample.distance) == parseFloat(x.toFixed(2)))]})`) : sample.sample
                    components.map((comp, n) => {
                        obj[comp] = typeof(sample.display[n]) !== 'undefined' ? parseFloat(sample.display[n].toFixed(2)) : 0
                    });
                } else {
                    obj.sample = sample.sample
                    components.map((comp, n) => {
                        obj[comp.replace(/_/g, ' ')] = typeof(sample[comp]) !== 'undefined' ? sample[comp] : 0
                    });
                }
                tabledata.push(obj)
            })
            var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
            copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
            var replace = new RegExp(' class=.*?]', 'g')
            copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']').replace(/:/g, " ► ")
            copyhtml = `[size=1]${copyhtml}[/size]`
            console.log(w.subId, w.lastShared, w.subId === w.lastShared)
            copy(copyhtml, {
                asHtml: false,
            });
        },
        rawData(index) {
            var index = index ? index : this.currentIndex ? this.currentIndex : 0
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.distance = w.switches.heatmap && !w.switches.calculator ? 'Nearest' : 'Fit'
            let components = []
            if (w.switches.heatmap && !w.switches.calculator) {
                w.columnDefs.map((comp, i) => {
                    if (i > 1) {
                        components.push(comp.headerName.replace(/\(.*\)/, ''))
                    }
                })
            } else {
                w.components.map(comp => {
                    console.log('comp', comp)
                    components.push(comp)
                })
            }
            components.forEach(comp => headers[comp] = comp)
            var tabledata = []
            var startIndex = index === -1 ? 0 : index;
            var endIndex = index === -1 ? w.rowData.length : index + 1;
            for (let n = startIndex; n < endIndex; n++) {
                let sample = w.rowData[n]
                var obj = {};
                obj.distance = sample.distance;
                if (w.switches.heatmap && !w.switches.calculator) {
                    obj.sample = sample.display && sample.display.findIndex(x => parseFloat(sample.distance) == parseFloat(x.toFixed(2))) >= 0 ? sample.sample.replace(/\(.*\)/, `(${components[sample.display.findIndex( x => parseFloat(sample.distance) == parseFloat(x.toFixed(2)))]})`) : sample.sample
                    components.map((comp, n) => {
                        obj[comp] = typeof(sample.display[n]) !== 'undefined' ? parseFloat(sample.display[n].toFixed(2)) : 0
                    });
                } else {
                    obj.sample = sample.sample
                    components.map((comp, n) => {
                        obj[comp.replace(/_/g, ' ')] = typeof(sample[comp]) !== 'undefined' ? sample[comp] : 0
                    });
                }
                tabledata.push(obj)
            }
            var pretty = JSON.stringify(tabledata, null, 2);
            console.log(pretty);
            copy(pretty, {
                asHtml: false,
            });
        },
        copySampleHtml(type) {
            var headers = {}
            var w = this;
            headers.key = ''
            headers.value = ''
            headers.results = ''
            var tabledata = []
            var currentIndex = this.currentIndex ? this.currentIndex : 0
            var sample = w.chartJSON[currentIndex]
            tabledata.push({
                key: '<b>Sample:</b><br/><br/>',
                value: sample.profile.replace(/_/g, ' ').replace(/:/g, " ►<br/>"),
                results: ''
            })
            if (sample.distance) {
                tabledata.push({
                    key: 'Fit:',
                    value: sample.distance ? sample.distance : '',
                    results: ''
                })
            }
            w.components.forEach((result, i) => {
                if (typeof(sample.result[result]) !== 'undefined') {
                    let obj = {}
                    obj.key = i === 0 ? 'Results:' : ''
                    obj.value = result.replace(/_/g, ' ')
                    obj.results = sample.result[result]
                    tabledata.push(obj);
                }
            })
            if (type && type == 'md') {
                let table = []
                tabledata.map(x => {
                    let row = []
                    Object.keys(headers).map(y => {
                        row.push(typeof(x[y]) == 'string' ? x[y].replace('<b>', '').replace('</b><br/><br/>', '').replace('<br/>', ' ') : x[y])
                    })
                    table.push(row);
                })
                let copyhtml = w.$mdtable(table, {
                    align: ['l', 'l', 'l']
                })
                console.log(copyhtml);
                copy(copyhtml, {
                    asHtml: false
                });
            } else {
                var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
                copy(`<p>${copyhtml}</p>`, {
                    asHtml: true
                });
            }
        },
        copySampleHtml2() {
            let type = 'html'
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.distance = 'Fit'
            w.components.forEach(comp => headers[comp] = comp.replace(/_/g, ' '))
            var tabledata = []
            var currentIndex = this.currentIndex ? this.currentIndex : 0
            var sample = w.chartJSON[currentIndex]
            var obj = {};
            obj.sample = sample.profile.replace(/_/g, ' ')
            obj.distance = sample.distance;
            w.components.forEach(result => obj[result] = typeof(sample.result[result]) !== 'undefined' ? sample.result[result] : 0);
            tabledata.push(obj)
            var copyhtml = new Table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            let copytext = this.$yaml.stringify(obj, 2).replace(/-\n/g, '\n').replace(/'/g, '')
            //copyhtml = juice.inlineContent(copyhtml, tablecss)
            if (type === 'text') {} else {
                copy(`<p>${copyhtml}</p>`, {
                    asHtml: true
                });
            }
        },
        copySampleToClipBB() {
            var headers = {}
            var w = this;
            headers.key = 'Results'
            headers.value = ''
            headers.results = ''
            var tabledata = []
            var currentIndex = this.currentIndex ? this.currentIndex : 0
            var sample = w.chartJSON[currentIndex]
            tabledata.push({
                key: 'Sample:',
                value: sample.profile.replace(/_/g, ' ').replace(/:/g, " ► "),
                results: ''
            })
            tabledata.push({
                key: 'Fit:',
                value: sample.distance,
                results: ''
            })
            w.components.forEach((result, i) => {
                if (typeof(sample.result[result]) !== 'undefined') {
                    let obj = {}
                    obj.key = i === 0 ? 'Results:' : ''
                    obj.value = result.replace(/_/g, ' ')
                    obj.results = sample.result[result]
                    tabledata.push(obj);
                }
            })
            var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
            var replaceHeaders = new RegExp('<thead>(.*?)</thead>')
            copyhtml = copyhtml.replace(replaceHeaders, '')
            copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
            var replace = new RegExp(' class=.*?]', 'g')
            copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']')
            let size = tabledata.length > 6 ? 1 : 1
            copyhtml = `[size=${size}]${copyhtml}[/size]`
            if (w.subId === w.lastShared && w.currentShare) copyhtml = `[URL="https://genoplot.com/shared/g25/?share=${w.currentShare.path + '#' + w.currentShare.theme}"][IMG]https://genoplot.com/genoplot16.png[/IMG]&#8194;[B][SIZE=3]GenoPlot[/SIZE][/B][/URL]\n` + copyhtml
            //copyhtml = `[color=#153545]${copyhtml}[/color]`
            copy(copyhtml, {
                asHtml: false,
            });
        },
        copySampleToClip(type) {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.distance = 'Fit'
            w.components.forEach(comp => headers[comp] = comp.replace(/_/g, ' '))
            var tabledata = []
            var currentIndex = this.currentIndex ? this.currentIndex : 0
            var sample = w.chartJSON[currentIndex]
            var obj = {};
            obj.sample = sample.profile.replace(/_/g, ' ')
            obj.distance = sample.distance;
            w.components.forEach(result => obj[result] = typeof(sample.result[result]) !== 'undefined' ? sample.result[result] : 0);
            tabledata.push(obj)
            var copyhtml = new Table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            let copytext = this.$yaml.stringify(obj, 2).replace(/-\n/g, '\n').replace(/'/g, '')
            copyhtml = juice.inlineContent(copyhtml, tablecss)
            if (type === 'text') {
                copy(copytext, {
                    asHtml: false,
                });
            } else {
                copy(copyhtml, {
                    asHtml: true,
                });
            }
        },
        chartaHeight() {
            var length = this.groupArray ? this.groupArray.length : 0
            var height = (length > 0 ? 20 * length : 20);
            return height
        },
        getChart(key) {
            var key = typeof(key) === 'undefined' ? 'Ganj_Dareh_N' : key;
            var json = this.chartJSON ? this.chartJSON : false
            if (!json) {
                var vm = this;
                axios.get('https://static.genoplot.com/public/results.json?v=12').then(response => {
                    var json = response.data
                    //vm.chartJSON = json;
                    vm.$store.commit('change', {
                        g25chartJSON: json
                    })
                    vm.processJSON(key)
                })
            } else {
                var vm = this;
                vm.processJSON(key)
            }

        },
        fullScreenGrid(event) {
            if (event && event == 'full') {
                this.$store.commit('change', {
                    topClass: true
                })
                let header = document.querySelector('body #app #page .ag-theme-balham.rotated .ag-header')
                let header2 = document.querySelector('body #app #page .ag-theme-balham .ag-header')
                let height
                if (header) {
                    height = (header.offsetHeight);
                    header.style.setProperty('--mainHeaderSpacer', (186 - height) + 'px')
                } else {
                    height = 131
                    header2.style.setProperty('--mainHeaderSpacer', (186 - height) + 'px')
                }
            } else {
                this.fullScreen = false;
                this.$store.commit('change', {
                    topClass: false
                })
            }
            console.log(event)
        },
        processJSON(key, rerun) {
            if (this.debug && this.env === 'development') console.log('processing JSON key ', key)
            var key = key;
            var json = JSON.parse(JSON.stringify(this.chartJSON))
            /*
            var jsonBlob = new Blob([JSON.stringify(json)], {
                type: "application/json"
            });
            window.saveAs(jsonBlob, `data.json`);
            */
            if (this.debug && this.env === 'development') console.log('JSON', json)
            this.$store.commit('change', {
                g25chartKey: key
            })
            if (key === 'distance' || key === 'sample') {
                var naturalKey = key === 'distance' ? key : 'profile';
                json.sort(this.keySort(naturalKey));
            } else {
                json.sort(function(a, b) {
                    var x = a.result[key] ? a.result[key] : 0;
                    var y = b.result[key] ? b.result[key] : 0;
                    return (x < y ? 1 : x > y ? -1 : a.profile < b.profile ? 1 : a.profile > b.profile ? -1 : 0)
                })
            }
            if (this.lastSort === key + 1) {
                json.reverse();
                this.$store.commit('change', {
                    lastSort: false
                })
            } else {
                this.$store.commit('change', {
                    lastSort: key
                })
            }
            let w = this;
            var categories = []
            json.forEach(function(s, n) {
                let index = w.sampleArray.find(x => x.index == s.profile)
                let profileIndex = w.sampleArray.find(x => x.index == s.profile)
                let profile = profileIndex ? `${profileIndex.originalGroup ? profileIndex.originalGroup : profileIndex.alias ? profileIndex.alias : profileIndex.group}:${profileIndex.sample}` : s.profile
                s.alias = profile || s.profile;
                if (index && index.alias) {
                    let alias = `${index.alias} ► ${s.profile.split(':')[1]}`
                    categories.push(alias)
                } else {
                    categories.push(s.profile.replace(/:/g, " ► "))
                }
            })
            w.$store.commit('change', {
                g25chartJSON: json
            })
            w.$store.commit('change', {
                g25chartCategories: categories
            })
            this.currentIndex = 0;
            this.currentChartIndex = 0;
            console.log('chartJSON', this.chartJSON, json)
            if (this.chartJSON && this.chartJSON.length) {
                if (this.secondaryTabs == 'table' && this.gridApi && this.gridApi.getSelectedRows && this.gridApi.getSelectedRows() && this.gridApi.getSelectedRows().length) {
                    let selectedRows = this.gridApi.getSelectedRows();
                    let chartindex = 0;
                    try {
                        chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '').replace(/_/g, ' ')} (${x.alias.split(':')[0].replace(/_/g, ' ')})`.trim() == selectedRows[0].sample.replace(/_/g, ' ').trim())
                    } catch (err) {
                        console.log('chartindex', chartindex, err);
                    }
                    this.currentChartIndex = chartindex;
                } else {
                    let profile = this.categories[this.currentIndex]
                    console.log('profile', profile, this.categories, this.currentIndex);
                    let chartindex = 0;
                    try {
                        chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[0].replace(/-raw/, '').replace(/_/g, ' ')} ► ${x.alias.split(':')[1]}`.replace(/_/g, ' ').trim() == profile.replace(/-raw/, '').replace(/_/g, ' ').trim())
                    } catch (err) {
                        console.log('chartindex', chartindex, err);
                    }
                    this.currentChartIndex = chartindex;
                }
            }
            this.currentChartIndex = this.currentChartIndex < 0 ? 0 : this.currentChartIndex
            if (this.debug && this.env === 'development') console.log('categories', categories)
            Array.prototype.rotate = function(n) {
                var len = this.length;
                return !(n % len) ? this.slice() :
                    this.map((e, i, a) => a[(i + (len + n % len)) % len]);
            };
            var components = JSON.parse(JSON.stringify(this.components))
            var index = components.indexOf(key);
            var colors = w.colors;
            colors = colors.rotate(index);
            var chartOptions = JSON.parse(JSON.stringify(w.chartOptions))
            components = components.rotate(index);
            var series = []
            let newcomponents = []
            let newcolors = []
            components.forEach(function(c, i) {
                var component = c;
                var data = [];
                json.forEach(function(y, t) {
                    var value = y.result[component] ? y.result[component] : 0;
                    if (y.result[component] && t === w.currentIndex) {
                        newcomponents.push(component)
                        let index = components.findIndex(x => x === component)
                        newcolors.push(w.colors[index % w.colors.length])
                    }
                    data.push(value)
                });
                series.push({
                    name: component,
                    data: data
                })
            })
            chartOptions.colors = newcolors;
            chartOptions.legend.offsetY = (16 - newcomponents.length) * 4 - 20
            w.$store.commit('change', {
                g25chartColors: colors
            })
            w.$store.commit('change', {
                g25chartSeries: series
            })
            if (this.switches.calculator && this.calcComponents.length > 0) {
                let mapseries = []
                w.calcComponents.forEach(function(c, i) {
                    var component = c;
                    var data = [];
                    json.forEach(function(y, t) {
                        let result = y.groupResult
                        var value = result[component] ? result[component] : 0;
                        data.push(value)
                    });
                    mapseries.push({
                        name: component,
                        data: data
                    })
                })
                w.$store.commit('change', {
                    g25calcSeries: mapseries
                })
                let sampleseries = []
                w.calcSampleComponents.forEach(function(c, i) {
                    var component = c;
                    var data = [];
                    json.forEach(function(y, t) {
                        let result = y.sampleResult
                        var value = result[component] ? result[component] : 0;
                        data.push(value)
                    });
                    sampleseries.push({
                        name: component.split(':')[1],
                        data: data,
                        parent: component.split(':')[0]
                    })
                })
                w.$store.commit('change', {
                    g25calcSampleSeries: sampleseries
                })
            }
            if (w.firstRun && w.gridApi) {
                w.gridApi.refreshCells({
                    force: true
                });
                w.$store.commit('change', {
                    g25firstRun: false
                })
            }
            var labels = []
            newcomponents.forEach((comp, i) => {
                labels.push(w.newseries[i] ? "<div class='result-tip'>" + comp.replace(/_/g, " ") + "</div><b><div class='result-tip-value'>" + w.newseries[i].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>" : '') // "<div class='result-tip faded'>" + comp.replace(/_/g, " ") + "</div><b><div class='result-tip-value faded'>" + w.newseries[i].toFixed(1).toString().replace(/\.0$/, '') + "</div></b>")
            })
            w.components = components;
            w.$store.commit('change', {
                g25chartComponents: components
            })
            chartOptions.labels = labels;
            chartOptions.comps = components;
            w.chartOptions = chartOptions;
            var showGrid = w.series[0] && w.series[0].data && w.series[0].data.length === 1 ? 0 : w.showGrid
            w.$store.commit('change', {
                showGrid: showGrid
            })
            this.mapReady = true;
            setTimeout(() => {
                w.map.series[0].data = w.mapseries
                if (w.switches.calculator && w.calcComponents.length > 0) {
                    let label = false
                    w.calcComponents.map(x => label = label === true ? true : x.split(':')[0] === x.split(':')[1] ? false : true)
                    w.sunOptions.series.levels[1].label.show = label;
                    w.sunOptions.series.data = w.sunburstSeries
                }
            }, 0)
            this.drawer = true;
            this.chartReady = true;
        },
        selectSearchText(ref) {
            this.$refs[ref].$refs.search.focus()
            this.$refs[ref].$refs.search.select()
        },
        syncNmonte(name) {
            this.switches.lite = !this.switches.lite
            this.syncStore(name);
        },
        syncStore(name, rerun) {
            let tempname = name;
            let w = this;
            if (tempname) {
                w.$nextTick(() => {
                    if (tempname == 'groupArray' && w.switches.calculator && w.groupArray.length > 0) {
                        w.slider.batches.value = 200
                        w.slider.cycles.value = 200
                    }
                    w.queryTimeStamp = Date.now();
                    w.unchanged = false;
                    w.currentShare = false;
                    var props = tempname.split('.')
                    var prop = props[0]
                    if (prop === 'switches' && props[1]) {
                        var swtch = props[1];
                        if (swtch === 'filterResults') {
                            w.gridOptions.floatingFilter = w.switches.filterResults ? true : false
                            w.gridKey = Date.now();
                        }
                        if (swtch === 'scaled') {
                            w.resetCustomSamples()
                        }
                        if (swtch === 'paginateResults') {
                            w.gridOptions.pagination = w.switches.paginateResults ? true : false
                            w.gridKey = Date.now();
                        }
                        if (swtch === 'groupSamples') {
                            w.filteredGroupSamples = []
                            let input = w.$refs['rightSelectinput'].$refs.search.value
                            if (input) {
                                setTimeout(() => {
                                    w.searchGroups(input);
                                }, 0)
                            }
                        }
                        if (swtch === 'removeOutliers' && this[prop].removeOutliers === true) {
                            this[prop].groupAveraged = false;
                            this[prop].groupMedian = false;
                        }

                        if (swtch === 'calculator') {
                            w.chartReady = false;
                            w.calcGroupsArray = []
                        }
                        if (swtch === 'calculator' && this[prop].calculator === true) {
                            w.switches.optimaFit = false;
                            w.switches.heatmap = false;
                        }
                        if (swtch === 'calculator') {
                            //w.g25customsamples = false;
                            let uname = w.user.username + ':' + 'groupArray'
                            localStorage.setItem(uname, JSON.stringify({
                                groupArray: []
                            }));
                            w.$store.commit('change', {
                                groupArray: []
                            })
                            w.groupArray = [];
                        }
                        if (swtch === 'groupAveraged' && this[prop].groupAveraged === true) {
                            this[prop].removeOutliers = false;
                            this[prop].groupMedian = false;
                        }
                        if (swtch === 'groupMedian' && this[prop].groupMedian === true) {
                            this[prop].groupAveraged = false;
                            this[prop].removeOutliers = false;
                        }
                    }
                    if (prop === 'slider' && props[1] && props[2]) {
                        var slider = props[1];
                        if (slider === 'colors') {
                            var theme = (props[2] - 1) % 5
                            var colors = w.chartColors[theme];
                            colors = colors.slice(0, w.components.length)
                            var chartOptions = JSON.parse(JSON.stringify(w.chartOptions))
                            chartOptions.colors = colors;
                            w.chartOptions = chartOptions;
                            if (w.categories.length === 1) {
                                w.series[0].data[0] = (w.series[0].data[0] * 1.000001).toFixed(1);
                            }
                            w.$store.commit('change', {
                                g25chartColors: colors
                            })
                            let heatmapColors = w.heatmapColors;
                            w.map.series[0].data = w.mapseries
                            if (w.switches.calculator && w.calcComponents.length > 0) {
                                if (w.categories.length === 1) {
                                    w.processJSON(w.components[0]);
                                } else {
                                    w.sunOptions.series.data = w.sunburstSeries;
                                }
                            }
                        }
                        if (slider === 'layout') {
                            var layout = props[2]
                            var showGrid = layout === 'Data' ? 1 : layout === 'Both' ? 2 : 0;
                            layout = w.chartColors[theme];
                            w.$store.commit('change', {
                                showGrid: showGrid
                            })
                        }
                    }
                    var obj = {};
                    obj[prop] = this[prop];
                    w.$store.commit('change', obj)
                    let localname = w.user.username + ':' + prop
                    localStorage.setItem(localname, JSON.stringify(obj));
                    if (tempname === 'sampleArray' && w.sampleArray.length === 0) w.resetSamples()
                    if (tempname === 'groupArray' && w.groupArray.length === 0) w.resetGroups()
                    if (tempname === 'groupArray' && w.switches.calculator && w.groupArray.length > 0) {
                        if (w.groupArray.length > 1) {
                            w.groupArray = w.groupArray.slice(-1);
                            w.calcGroupsArray = []
                            let lname = w.user.username + ':' + 'groupArray'
                            localStorage.setItem(lname, JSON.stringify({
                                groupArray: []
                            }));
                        }
                        if (w.groupArray[0].settings) {
                            let settings = typeof(w.groupArray[0].settings) === 'string' ? JSON.parse(w.groupArray[0].settings) : w.groupArray[0].settings
                            w.switches.lite = settings && settings.nmonte ? false : true
                            if (settings.grouped.removeoutliers) {
                                w.switches.removeOutliers = true
                                w.switches.groupAveraged = false
                                w.switches.groupMedian = false
                            }
                            if (settings.grouped.median) {
                                w.switches.removeOutliers = false
                                w.switches.groupAveraged = false
                                w.switches.groupMedian = true
                            }
                            if (settings.grouped.average) {
                                w.switches.removeOutliers = false
                                w.switches.groupAveraged = true
                                w.switches.groupMedian = false
                            }
                            w.slider.limit.value = settings.slider && settings.slider.limit && settings.slider.limit.value ? settings.slider.limit.value : w.slider.limit.data[0][0]
                            w.slider.min.value = settings.slider && settings.slider.min && settings.slider.min.value ? settings.slider.min.value : w.slider.min.data[0][0]
                            w.switches.penalty = settings.penalty
                            w.slider.batches.value = settings.nmonte && settings.slider.batches.value ? settings.slider.batches.value : 200
                            w.slider.cycles.value = settings.nmonte && settings.slider.cycles.value ? settings.slider.cycles.value : 200
                        } else {
                            w.slider.limit.value = w.slider.limit.data[0][0]
                            w.slider.min.value = w.slider.min.data[0][0]
                            w.slider.batches.value = 200
                            w.slider.cycles.value = 200
                            w.switches.removeOutliers = false
                            w.switches.groupAveraged = false
                            w.switches.groupMedian = false
                            w.switches.penalty = false
                        }
                    }
                })
            }
        },
        customCalcSmallLabel(calc) {
            return (`${unescape(calc.calculator)} by ${calc.owner ? calc.owner : calc.user}`)
        },
        customCalcLabel(calc) {
            if (calc && calc.description) {
                return (`${unescape(calc.calculator)} by ${calc.owner ? calc.owner : calc.user} - ${calc.description.replace(/\<br.*/,'')}`)
            } else {
                return (`${unescape(calc.calculator)} by ${calc.owner ? calc.owner : calc.user} - ${calc.description}`)
            }
        },
        unescape(string) {
            return unescape(string)
        },
        customLabel({
            label,
            alias,
            age,
            group,
            origin,
            ethnicity,
            type,
            v,
            outlier

        }) {
            if ((age !== null && typeof(age) !== 'undefined') || (origin !== null && typeof(origin) !== 'undefined')) {
                age = age === null || typeof(age) === 'undefined' ? '' : (age - 100000) < 0 ? -1 * (age - 100000) + ' BCE' : age - 100000 + ' CE';
                origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                //let message = (label.replace(/_/g, " ") + ' ( ' + age + ' ' + origin + ' )' + outlier).replace(/:/, ' ► ')
                let message = (alias ? alias + ' ► ' + label.split(' ► ')[1] : label.replace(/_/g, " ")) + ' ( ' + age + ' ' + origin + ' )' + outlier
                message = type == 'user' && ethnicity ? ethnicity + '(U) ' + message : message
                return message
            } else {
                origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                return alias ? alias + ' ► ' + label.split(':')[1].replace(/_/g, " ") : (label.replace(/_/g, " ") + outlier + origin).replace(/:/, ' ► ')
            }
        },
        customSample({
            group,
            sample,
            alias,
            age,
            origin,
            ethnicity,
            type,
            outlier,
            variability
        }) {
            group = alias ? alias : group
            if ((age !== null && typeof(age) !== 'undefined') || (origin !== null && typeof(origin) !== 'undefined')) {
                age = age === null || typeof(age) === 'undefined' ? '' : (age - 100000) < 0 ? -1 * (age - 100000) + ' BCE' : age - 100000 + ' CE';
                group = alias ? alias : group
                origin = origin === null || typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                variability = typeof(variability) !== 'undefined' && variability !== null ? ` (${(variability/3.5).toFixed(2)}%)` : ''
                var message = group + ' ► ' + (sample.split('@')[0]) + outlier + ' ( ' + age + ' ' + origin + ' )'
                //if (type === 'user') message = (ethnicity ? ethnicity + ' (U) ► ' : 'User ► ') + message
                if (type === 'user') message = (ethnicity ? `User (${ethnicity}) ` : 'User ► ') + message
                return message.replace(/_/g, ' ')
            } else {
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                variability = typeof(variability) !== 'undefined' && variability !== null ? ` (${(variability/3.5).toFixed(2)}%)` : ''
                return (group + ' ► ' + sample.split('@')[0] + outlier).replace(/_/g, ' ')
            }
        },
        resetTip() {
            this.tipDisabled = false;
        },
        runModerns(el) {
            console.log('running moderns')
            var w = this;
            var evt = 'collapse-select';
            setTimeout(() => {
                w.$root.$emit(evt, 'collapse');
            }, 0)
            let customSampleArr = [];
            if (el == 'quickselect' && w.csv && w.customSampleCount > 0) {
                try {
                    let csv = w.csv.split('\n').filter(x => x != '')
                    let length = !w.mode || w.mode == 'G25' ? 25 : w.mode && w.modecomponents[w.mode] ? w.modecomponents[w.mode].length : 25
                    csv.map(sample => {
                        customSampleArr.push({
                            sample: 'Custom:' + sample.split(',')[0].split(':').reverse()[0],
                            coords: sample.split(',').slice(-1 * length).join(',')
                        })
                    })
                } catch (err) {
                    console.log(err);
                }
            }
            w.$store.commit('change', {
                spinner: true
            })
            let fullsample
            let index = w.currentIndex ? w.currentIndex : 0
            if (customSampleArr.length) {
                let index = 0;
                let element = this.$refs.quickselect
                if (element) {
                    let linenumber = element.value.substr(0, element.selectionStart).split("\n").length
                    index = linenumber && linenumber > 0 && customSampleArr[linenumber - 1] ? linenumber - 1 : 0
                }
                fullsample = {
                    group: customSampleArr[index].sample.split(':')[0],
                    sample: customSampleArr[index].sample.split(':')[1],
                    coords: customSampleArr[index].coords,
                    coords2: customSampleArr[index].coords
                };
            } else if (el.option) {
                fullsample = el.option
            } else {
                if (w.sampleArray && w.sampleArray.length > 0 && w.sampleArray.find(x => x.index === w.categories[index].replace(/ ► /g, ':'))) {
                    fullsample = w.sampleArray.find(x => x.index === w.categories[index].replace(/ ► /g, ':'))
                } else {
                    fullsample = w.allSamples.find(x => x.index === w.categories[index].replace(/ ► /g, ':'))
                }
            }
            console.log('fullsample', fullsample);
            if (!this.onLine) {
                this.spinner = false;
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: 'Application offline',
                        text: 'Please refresh the page and re-run when the application is connected to the internet'
                    }
                });
                return false;
            }
            var subId = this.$store.getters.get('user').username + ':' + this.queryTimeStamp;
            var eta = 2000
            console.log(`ETA for query is ${Math.round(eta/1000)} seconds`);
            let execArray = ['allModernAverages', 'customUsers', 'allAncientAverages']
            let results = []
            let nearest = []
            this.recordEvent('getSampleInfo', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            async function getModerns() {
                w.start = Date.now()
                const fitsArr = execArray.map(async calc => {
                    try {
                        console.log('calc', calc);
                        var subId = w.$store.getters.get('user').username + ':' + w.queryTimeStamp;
                        let checkfit = w.resources.checkfit[w.subType]
                        let params = {
                            sub: subId,
                            calculator: calc,
                            raw: false,
                            coords: fullsample.coords ? fullsample.coords : undefined,
                            coords2: fullsample.coords2 ? fullsample.coords2 : undefined,
                            scaled: w.switches.calculator && w.groupArray[0] && w.groupArray[0].scaled ? true : !w.switches.calculator ? w.switches.scaled : true,
                            creator: 'internalGenoplot'
                        }
                        params.sample = fullsample.group + ':' + fullsample.sample
                        params.sample = fullsample.v ? params.sample.split(':')[0] + '|' + fullsample.v + ':' + params.sample.split(':')[1] : params.sample
                        //console.log('calling jsfit', getFitsQuery,  params);
                        const data = await w.$apollo.query({
                            query: getFitsQuery,
                            variables: {
                                params: JSON.stringify(params)
                            }
                        })
                        if (data && data.data && data.data.getFits && data.data.getFits.nearest) {
                            nearest = JSON.parse(data.data.getFits.nearest)
                            nearest = nearest.map((x, i) => {
                                let sample = x.sample == 'Average' ? x.group : x.sample
                                sample = x.ethnicity && x.ethnicity != 'Sindhi' ? `${sample} (${x.ethnicity})` : x.origin ? `${sample} (${x.origin.split(' Dated')[0]})` : x.sample == 'Average' ? sample : `${x.sample} (${x.group})`
                                return {
                                    ...x,
                                    ...{
                                        index: i,
                                        _row: sample,
                                        sample: sample
                                    }
                                }
                            })
                            results.push({
                                calc: calc,
                                nearest: nearest
                            })
                        }
                        w.progress = 0;
                    } catch (err) {
                        console.log(err);
                        var error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                        w.$eventBus.$emit('appEvents', {
                            exec: 'setError',
                            component: 'nav',
                            params: error
                        })
                    }
                })
                try {
                    const fits = await Promise.all(fitsArr);
                    console.log('showing fits', results);
                    w.$store.commit('change', {
                        spinner: false
                    })
                    if (results.length > 0) {
                        setTimeout(() => {
                            console.log('showing fits');
                            w.$modal.show('checkfits', {
                                results: {
                                    sample: fullsample,
                                    nearest: results
                                },
                            });
                        }, 300)
                    }
                } catch (err) {
                    console.log(err)
                    w.$store.commit('change', {
                        spinner: false
                    })
                }
            }
            getModerns();
        },
        runOracles() {
            this.recordEvent('runOracles', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            if (this.secondaryTabs == 'table' && this.gridApi && this.gridApi.getSelectedRows && this.gridApi.getSelectedRows() && this.gridApi.getSelectedRows().length) {
                let selectedRows = this.gridApi.getSelectedRows();
                let chartindex = 0;
                chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '').replace(/_/g, ' ')} (${x.alias.split(':')[0].replace(/_/g, ' ')})`.trim() == selectedRows[0].sample.replace(/_/g, ' ').trim())
                this.currentChartIndex = chartindex;
            } else {
                let profile = this.categories[this.currentIndex]
                let chartindex = 0;
                //chartindex = this.chartJSON.findIndex(x =>  `${x.profile.split(':')[1].replace(/-raw/, '')} (${x.profile.split(':')[0]})`.trim()  == this.categories[this.currentIndex].replace(/-raw/, '').trim())
                chartindex = this.chartJSON.findIndex(x => `${x.alias.split(':')[0].replace(/-raw/, '').replace(/_/g, ' ')} ► ${x.alias.split(':')[1]}`.replace(/_/g, ' ').trim() == profile.replace(/-raw/, '').replace(/_/g, ' ').trim())
                this.currentChartIndex = chartindex;
            }
            this.currentChartIndex = this.currentChartIndex < 0 ? 0 : this.currentChartIndex
            this.tipDisabled = true;
            let customsamples = false;
            let customSampleArr = [];
            if (this.csv && this.customSampleCount > 0) {
                try {
                    let csv = this.csv.split('\n').filter(x => x != '')
                    let length = !w.mode || w.mode == 'G25' ? 25 : w.mode && w.modecomponents[w.mode] ? w.modecomponents[w.mode].length : 25
                    csv.map(sample => {
                        customSampleArr.push({
                            sample: 'Custom:' + sample.split(',')[0].split(':').reverse()[0],
                            coords: sample.split(',').slice(-1 * length).join(',')
                        })
                    })
                } catch (err) {
                    console.log(err);
                }
            }
            setTimeout(() => {
                this.tipDisabled = false;
            }, 120000)
            if (!this.onLine) {
                this.spinner = false;
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: 'Application offline',
                        text: 'Please refresh the page and re-run when the application is connected to the internet'
                    }
                });
                return false;
            }
            var subId = this.$store.getters.get('user').username + ':' + this.queryTimeStamp;
            var w = this;
            if (w.chartJSON[w.currentChartIndex] && w.chartJSON[w.currentChartIndex].coords) {
                var coords = w.chartJSON[w.currentChartIndex].coords
            } else {
                console.log('Error chartIndex', w.currentChartIndex, w.chartJSON)
                w.spinner = false;
            }
            if (w.switches.calculator === true) {
                var nearGroups = [...w.chartJSON[w.currentChartIndex].nearest]
                var group = []
                nearGroups.map(x => {
                    if (x._row) group.push(x._row.split(':')[0])
                })
                var unique = new Set(group)
                var groups = [...unique].slice(0, 8);
                var nearest = false
                var calculator = this.groupArray[0].label;
                var quantity = this.groupArray[0].samples;
                var filtered = quantity > 800 ? true : this.aggregatedCalc && !this.switches.removeOutliers ? false : true
                var averaged = quantity > 800 ? undefined : this.aggregatedCalc && this.switches.groupAveraged ? true : undefined
                var median = quantity > 800 ? true : this.aggregatedCalc && this.switches.groupMedian ? true : undefined
                var eta = filtered ? (quantity / 60) * 1000 : (quantity / 300) * 1000
                var creator = this.groupArray[0].user;
                var query = getOraclesQuery
                var type = 'getOracle'
                var params = {
                    filtered: filtered,
                    averaged: averaged,
                    median: median,
                }
            } else {
                var nearGroups = [...w.chartJSON[w.currentChartIndex].nearest]
                var group = []
                nearGroups.map(x => {
                    if (x._row) group.push(x._row.split(':')[0])
                })
                var unique = new Set(group)
                var nearest = [...unique].slice(0, 8)
                nearest = nearest.map(x => {
                    let sample = x.replace(/ • /, ':')
                    sample = w.groupArray.find(y => y.index == sample)
                    if (sample && sample.alias) {
                        return {
                            alias: sample.alias,
                            sample: sample.index
                        };
                    } else {
                        return x;
                    }
                })
                console.log('nerest', nearest);
                var calculator = false
                var quantity = 0
                this.groupArray.map(x => quantity = quantity + (x.samples ? x.samples : 1))
                quantity = quantity < 5 ? 5 : quantity;
                var filtered = quantity > 500 ? false : !this.switches.removeOutliers ? false : true;
                var eta = filtered ? (quantity / 60) * 1000 : (quantity / 300) * 1000
                var creator = false
                var query = getFreeFormOraclesQuery
                var type = 'getFreeFormOracle'
                var params = {
                    filtered: filtered,
                    raw: this.mode !== 'G25' ? false : true
                }
                var groups = []
                this.groupArray.map(group => {
                    if (group.label) {
                        group.label = group.label.replace(' ► ', ':')
                        let vgroup = group.v ? (group.label.split(':').length > 1 ? group.label.split(':')[0] + '|' + group.v + ':' + group.label.split(':')[1] : group.label + '|' + group.v) : group.alias ? {
                            alias: group.alias,
                            sample: group.label
                        } : group.label;
                        vgroup = this.mode !== 'G25' ? (group.label.split(':').length > 1 ? group.label.split(':')[0] + '|' + this.mode + ':' + group.label.split(':')[1] : group.label + '|' + this.mode) : vgroup
                        groups.push(vgroup)
                    } else {
                        groups.push(group.group + ':' + group.sample)
                        quantity = quantity + 1;
                        if (this.g25customsamples && this.g25customsamples.length > 0 && this.g25customsamples.findIndex(sample => sample.split(':')[1] == group.sample && sample.split(':')[0] == group.group) >= 0) customsamples = this.g25Rerun
                    }
                })
            }
            let execArray = [{
                mode: 'mixed'
            }, {
                mode: 'multi'
            }]
            //let execArray = [{ mode: 'mixed'}]
            console.log(`ETA for query is ${Math.ceil(eta/1000)} seconds`);
            let credits = this.credits || 0
            let estimate = Math.ceil((0.8 * Math.round(eta / 1000)) / 3)
            estimate = estimate || 1
            if (estimate > credits) {
                w.spinner = false;
                let freesub = w.subs && w.subs.subType == 'free' ? true : false
                let buttons = [{
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.closable = false;
                        w.$modal.hide('dialog');
                    } // Button click handler
                }]
                if (freesub) {
                    buttons.unshift({
                        title: 'Subscribe',
                        handler: () => {
                            w.createNew = false;
                            w.$modal.hide('dialog');
                            w.recordEvent('subButtonAnalyze', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                } else {
                    buttons.unshift({
                        title: 'Add Credits',
                        handler: () => {
                            w.createNew = false;
                            w.$modal.hide('dialog');
                            w.recordEvent('subButtonAnalyze', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                params: 'addon',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                }
                w.$modal.show('dialog', {
                    title: 'Apologies',
                    text: `Unfortunately, you appear to have insufficient credits to execute this action<br><br><b>You need ${estimate} credits</b>` + (freesub ? `<br><b>Support us by subscribing to our services</b><br>` : '<br><b>Please add credits</b><br>'),
                    class: 'warning',
                    buttons: buttons
                })
                this.spinner = false;
                return
            }
            let resultArr = [];
            let index = w.currentIndex ? w.currentIndex : 0
            async function getOracles(groups, calculator, nearest, eta) {
                w.start = Date.now()
                const oraclesArr = execArray.map(async mode => {
                    let newParams = JSON.parse(JSON.stringify(params));
                    let fullsample = w.sampleArray.find(x => x.alias ? (x.alias + ':' + x.index.split(':')[1] == w.categories[index].replace(/ ► /g, ':')) : x.index === w.categories[index].replace(/ ► /g, ':')) || w.chartJSON[w.currentChartIndex]
                    fullsample.v = fullsample.v || fullsample.version
                    newParams.groups = groups;
                    newParams.sample = fullsample.index || fullsample.profile
                    if (w.g25customsamples && w.g25customsamples.length > 0 && w.g25customsamples.findIndex(x => x == newParams.sample) >= 0) customsamples = w.g25Rerun;
                    newParams.sample = newParams.sample.split(':')[0] == 'Custom' ? newParams.sample : w.mode !== 'G25' && fullsample.mode ? newParams.sample.split(':')[0] + '|' + w.mode + ':' + newParams.sample.split(':')[1] : fullsample.v ? newParams.sample.split(':')[0] + '|' + fullsample.v + ':' + newParams.sample.split(':')[1] : newParams.sample
                    newParams.calculator = calculator;
                    newParams.subtype = w.subs && w.subs.subType ? w.subs.subType : 'free'
                    newParams.coords = w.chartJSON[w.currentChartIndex].coords;
                    newParams.creator = creator;
                    newParams.excludegroups = w.calcGroupsArray && w.calcGroupsArray[0] ? w.calcGroupsArray.map(x => x.name) : undefined
                    newParams.raw = w.mode === 'G25' ? false : true
                    newParams.id = w.categories[index].replace(/ ► /g, ':') + ':oracle:' + mode.mode
                    newParams.sub = subId;
                    newParams.nearest = nearest;
                    newParams.customsamples = customsamples;
                    newParams.result = w.chartJSON[w.currentChartIndex] && w.chartJSON[w.currentChartIndex].groupResult ? w.chartJSON[w.currentChartIndex].groupResult : w.chartJSON[w.currentChartIndex] && w.chartJSON[w.currentChartIndex].result ? w.chartJSON[w.currentChartIndex].result : false;
                    newParams.multi = mode.mode && mode.mode === 'multi' ? true : false;
                    if (newParams.sample.split(':')[0] == 'Custom') newParams.coords = coords
                    const data = await w.$apollo.query({
                        query: query,
                        variables: {
                            params: JSON.stringify(newParams)
                        }
                    })
                    if (data.data && data.data[type]) {
                        let output = data.data[type];
                        let result = output.result ? JSON.parse(output.result) : false
                        let outdata = {
                            result: result,
                        };
                        try {
                            if (output.nearest) {
                                outdata.nearest = JSON.parse(output.nearest);
                            }
                        } catch (err) {
                            console.log(err);
                        }
                        resultArr.push(outdata);
                        return outdata
                    } else {
                        return false;
                    }
                });
                //w.$sentry.configureScope(scope => { scope.setTag("transactionId", subId); });
                try {
                    const oracles = await Promise.all(oraclesArr);
                    let oraclesMsg = []
                    let multi2 = []
                    let multi4 = []
                    let nearest = [...w.chartJSON[w.currentChartIndex].nearest].slice(0, checkfit)
                    let output = resultArr.map(result => {
                        if (result.result.oracles) {
                            result.result.oracles.map(oracle => {
                                let msg = ''
                                let result = oracle.result.map((x, i) => {
                                    let group = x.group.replace(/_/g, ' ')
                                    group = group.split(' [').length > 1 ? group.split(' [')[1].replace(/\]/, '') + '_' + group.split(' [')[0] : group
                                    if (oracle.result.length === 1) {
                                        msg = `50% ${group} + 50% ${group}`
                                    } else {
                                        msg = msg === '' ? `${x.pct}% ${group}` : `${msg} + ${x.pct}% ${group}`
                                    }
                                })
                                oraclesMsg.push({
                                    message: msg,
                                    distance: oracle.distance
                                })
                            })
                        }
                        if (result.result.multi2) {
                            result.result.multi2.map(oracle => {
                                let msg = ''
                                let result = oracle.groups.map((x, i) => {
                                    let group = x.split(':').length > 1 ? x.split(':')[0].replace(/_/g, ' ') : x.replace(/_/g, ' ')
                                    msg = msg === '' ? `50% ${group}` : `${msg} + 50% ${group}`
                                })
                                multi2.push({
                                    message: msg,
                                    distance: oracle.distance
                                })
                            })
                        }
                        if (result.result.multi4) {
                            result.result.multi4.map(oracle => {
                                let msg = ''
                                let fullmsg = ''
                                let result = oracle.groups.map((x, i) => {
                                    let group = x.split(':').length > 1 ? x.split(':')[0].replace(/_/g, ' ') : x.replace(/_/g, ' ')
                                    fullmsg = fullmsg === '' ? `25% ${group}` : `${fullmsg} + 25% ${group}`
                                    //group = group.length > 12 ? group.substr(0,10) + '...' : group;
                                    msg = msg === '' ? `${group}` : `${msg} + ${group}`
                                    //msg = msg === '' ? `${group}` : `${msg} + ${group}`
                                })
                                multi4.push({
                                    message: msg,
                                    distance: oracle.distance,
                                    fullmsg: fullmsg
                                })
                            })
                        }
                        if (result.nearest) {
                            nearest = result.nearest.slice(0, checkfit).map(x => {
                                x.distance = parseFloat((100 * x.distance).toFixed(2));
                                return x
                            })
                        }
                    })
                    var status = `${new Date().toLocaleString()}:` + ' Query completed in ' + Math.round((Date.now() - w.start) / 1000) + ' seconds'
                    console.log(status)
                    //w.$store.commit('change', { checkFitsData: resultArr[0] })
                    output.nearest
                    let checkfit = w.resources.checkfit[w.subType]
                    w.$modal.show('oraclesmodal', {
                        nearest: nearest,
                        oracles: oraclesMsg,
                        multi2: multi2,
                        multi4: multi4
                    });
                    w.progress = 0;
                    return oracles;
                } catch (err) {
                    console.log('caught runOracles ', err);
                    w.progress = 0;
                    var error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                    w.$eventBus.$emit('appEvents', {
                        exec: 'setError',
                        component: 'nav',
                        params: error
                    })
                    if (error.indexOf('insufficient credits') >= 0) {
                        let freesub = w.subs && w.subs.subType == 'free' ? true : false
                        let buttons = [{
                            title: 'Cancel',
                            default: true,
                            handler: () => {
                                w.closable = false;
                                w.$modal.hide('dialog');
                            } // Button click handler
                        }]
                        if (freesub) {
                            buttons.unshift({
                                title: 'Subscribe',
                                handler: () => {
                                    w.createNew = false;
                                    w.$modal.hide('dialog');
                                    w.recordEvent('subButtonAnalyze', {
                                        'event_category': 'function',
                                        'event_label': 'User initiated'
                                    })
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'checkSubStatus',
                                        component: 'nav',
                                    })
                                } // Button click handler
                            })
                        } else {
                            buttons.unshift({
                                title: 'Add Credits',
                                handler: () => {
                                    w.createNew = false;
                                    w.$modal.hide('dialog');
                                    w.recordEvent('subButtonAnalyze', {
                                        'event_category': 'function',
                                        'event_label': 'User initiated'
                                    })
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'checkSubStatus',
                                        params: 'addon',
                                        component: 'nav',
                                    })
                                } // Button click handler
                            })
                        }
                        w.$modal.show('dialog', {
                            title: 'Apologies',
                            text: "Unfortunately, you appear to have insufficient credits to execute this action" + (freesub ? `<br><b>Support us by subscribing to our services</b><br>` : '<br><b>Please add credits</b><br>'),
                            class: 'warning',
                            buttons: buttons
                        })
                    } else {
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Error',
                                text: error,
                                class: 'failure'
                            }
                        })
                    }
                }
            }
            w.progress = 10;
            getOracles(groups, calculator, nearest, eta);
        },
        runFit() {
            if (this.switches.calculator) {
                if (this.calcComponents.length > 0 && this.groupArray[0]) {
                    this.runOracles();
                    return;
                } else {
                    this.$eventBus.$emit('appEvents', {
                        exec: 'show',
                        component: 'nav',
                        params: {
                            class: 'warning',
                            title: 'Error',
                            text: 'No calculator selected'
                        }
                    });
                    return
                }
            } else {
                let w = this;
                if ((w.chartJSON && w.chartJSON[w.currentChartIndex]) || ((this.sampleArray.length > 0 || this.customSampleCount > 0) && this.groupArray[0])) {
                    this.runOracles();
                    return;
                } else {
                    this.$eventBus.$emit('appEvents', {
                        exec: 'show',
                        component: 'nav',
                        params: {
                            class: 'warning',
                            title: 'Error',
                            text: 'No Samples selected'
                        }
                    });
                    return
                }
            }
            this.tipDisabled = true;
            setTimeout(() => {
                this.tipDisabled = false;
            }, 70000)
            if (!this.onLine) {
                this.spinner = false;
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: 'Application offline',
                        text: 'Please refresh the page and re-run when the application is connected to the internet'
                    }
                });
                return false;
            }
            var subId = this.$store.getters.get('user').username + ':' + this.queryTimeStamp;
            var averaged = this.switches.groupAveraged ? true : false
            var median = this.switches.groupMedian ? true : false
            var filtered = this.switches.removeOutliers ? true : false
            var maxfits = this.slider.maxfits && this.slider.maxfits.value ? this.slider.maxfits.value : 20
            var params = {}
            if (averaged) params.averaged = averaged
            if (median) params.median = median
            if (filtered) params.filtered = filtered
            var filter = averaged ? 1 : median ? 2 : filtered ? 3 : 0;
            var w = this;
            var eta = params.median || params.averaged ? 3000 : params.filtered ? 5000 : 8000
            console.log(`ETA for query is ${Math.round(eta/1000)} seconds`);
            let credits = this.credits || 0
            //let estimate = Math.ceil((0.8 * Math.round(eta / 1000)) / 3)
            let estimate = Math.ceil((1.6 * Math.round(eta / 500)))
            if (estimate > credits) {
                let freesub = w.subs && w.subs.subType == 'free' ? true : false
                let buttons = [{
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.closable = false;
                        w.$modal.hide('dialog');
                    } // Button click handler
                }]
                if (freesub) {
                    buttons.unshift({
                        title: 'Subscribe',
                        handler: () => {
                            w.createNew = false;
                            w.$modal.hide('dialog');
                            w.recordEvent('subButtonAnalyze', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                } else {
                    buttons.unshift({
                        title: 'Add Credits',
                        handler: () => {
                            w.createNew = false;
                            w.$modal.hide('dialog');
                            w.recordEvent('subButtonAnalyze', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                params: 'addon',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                }
                w.$modal.show('dialog', {
                    title: 'Apologies',
                    text: `Unfortunately, you appear to have insufficient credits to execute this action<br><br><b>You need ${estimate} credits</b>` + (freesub ? `<br><b>Support us by subscribing to our services</b><br>` : '<br><b>Please add credits</b><br>'),
                    class: 'warning',
                    buttons: buttons
                })
                this.spinner = false;
                return
            }
            let resultArr = [];
            var index = w.currentIndex ? w.currentIndex : 0
            var samples = [w.categories[index].replace(/ ► /g, ':')]
            async function getResults(samples, eta) {
                w.start = Date.now()
                const profilesArr = samples.map(async sample => {
                    let newParams = JSON.parse(JSON.stringify(params));
                    let fullsample = w.sampleArray.find(x => x.index === sample)
                    newParams.sample = sample
                    newParams.sample = fullsample.v ? newParams.sample.split(':')[0] + '|' + fullsample.v + ':' + newParams.sample.split(':')[1] : w.mode !== 'G25' ? newParams.sample.split(':')[0] + '|' + w.mode + ':' + newParams.sample.split(':')[1] : newParams.sample
                    newParams.id = sample + ':fit:' + filter + ':' + maxfits + ':' + w.categories[index];
                    newParams.sub = subId;
                    newParams.subtype = w.subs && w.subs.subType ? w.subs.subType : 'free'
                    newParams.maxfits = maxfits;
                    const data = await w.$apollo.query({
                        query: getFitQuery,
                        variables: {
                            params: JSON.stringify(newParams)
                        }
                    })
                    if (data.data && data.data.getFit) {
                        let output = data.data.getFit;
                        let result = output.result ? JSON.parse(output.result) : false
                        w.filterResults = {
                            quantity: output.quantity,
                            filtered: output.filtered
                        }
                        let outdata = {
                            result: result,
                        };
                        resultArr.push(outdata);
                        return outdata
                    } else {
                        return false;
                    }
                });
                //w.$sentry.configureScope(scope => { scope.setTag("transactionId", subId); });
                try {
                    const profiles = await Promise.all(profilesArr);
                    var obj = resultArr[0].result
                    var filterMsg = w.filterResults && w.filterResults.filtered && w.filterResults.filtered > 0 ? ` >> filtered: ${w.filterResults.filtered} outliers/${w.filterResults.quantity} samples` : ''
                    var status = `${new Date().toLocaleString()}:` + ' Query completed in ' + Math.round((Date.now() - w.start) / 1000) + ' seconds' + filterMsg
                    console.log(status)
                    w.$store.commit('change', {
                        checkFitsData: resultArr[0]
                    })
                    w.progress = 0;
                    var nearest = w.chartJSON[w.currentChartIndex].nearest
                    w.$modal.show('checkfits', {
                        nearest: nearest.slice(0, maxfits)
                    });
                    return profiles
                } catch (err) {
                    console.log('caught runFit ', err);
                    w.progress = 0;
                    var error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                    w.$eventBus.$emit('appEvents', {
                        exec: 'setError',
                        component: 'nav',
                        params: error
                    })
                    if (error.indexOf('insufficient credits') >= 0) {
                        let freesub = w.subs && w.subs.subType == 'free' ? true : false
                        let buttons = [{
                            title: 'Cancel',
                            default: true,
                            handler: () => {
                                w.closable = false;
                                w.$modal.hide('dialog');
                            } // Button click handler
                        }]
                        if (freesub) {
                            buttons.unshift({
                                title: 'Subscribe',
                                handler: () => {
                                    w.createNew = false;
                                    w.$modal.hide('dialog');
                                    w.recordEvent('subButtonAnalyze', {
                                        'event_category': 'function',
                                        'event_label': 'User initiated'
                                    })
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'checkSubStatus',
                                        component: 'nav',
                                    })
                                } // Button click handler
                            })
                        } else {
                            buttons.unshift({
                                title: 'Add Credits',
                                handler: () => {
                                    w.createNew = false;
                                    w.$modal.hide('dialog');
                                    w.recordEvent('subButtonAnalyze', {
                                        'event_category': 'function',
                                        'event_label': 'User initiated'
                                    })
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'checkSubStatus',
                                        params: 'addon',
                                        component: 'nav',
                                    })
                                } // Button click handler
                            })
                        }
                        w.$modal.show('dialog', {
                            title: 'Apologies',
                            text: "Unfortunately, you appear to have insufficient credits to execute this action" + (freesub ? `<br><b>Support us by subscribing to our services</b><br>` : '<br><b>Please add credits</b><br>'),
                            class: 'warning',
                            buttons: buttons
                        })
                    } else {
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Error',
                                text: error,
                                class: 'failure'
                            }
                        })
                    }
                }
            }
            w.progress = 10;
            getResults(samples);
        },
        runCalc() {
            let w = this;
            w.switches.heatmap = false;
            w.switches.calculator = true;
            let calcQuery = this.switches.lite ? getCalcResultQuery : getCalcRResultQuery
            let queryProp = this.switches.lite ? 'getCalcResult' : 'getCalcRResult'
            //console.log(this.switches.lite, calcQuery, queryProp);

            let customsamples = false;
            let customSampleArr = [];
            if (this.csv && this.customSampleCount > 0) {
                try {
                    let csv = this.csv.split('\n').filter(x => x != '')
                    let length = !w.mode || w.mode == 'G25' ? 25 : w.mode && w.modecomponents[w.mode] ? w.modecomponents[w.mode].length : 25
                    csv.map(sample => {
                        customSampleArr.push({
                            sample: 'Custom:' + sample.split(',')[0].split(':').reverse()[0],
                            coords: sample.split(',').slice(-1 * length).join(',')
                        })
                    })
                } catch (err) {
                    console.log(err);
                }
            }
            this.mapOptions = false;
            this.recordEvent('runCalc', {
                'event_category': 'function',
                'event_label': 'User initiated'
            })
            if (this.map && this.map.geo) {
                this.map.geo.center = undefined
                this.map.geo.zoom = 1.25
            }
            this.chartReady = false;
            let eta = this.groupArray[0].samples ? 1000 * this.groupArray[0].samples / 400 : 2000
            eta = eta < 2000 ? 2000 : eta;
            eta = parseInt(this.slider.limit.value) && this.groupArray[0].samples ? (this.groupArray[0].samples / 1200) * eta * parseInt(this.slider.limit.value) : eta
            eta = this.switches.lite ? eta : eta * 2
            let credits = this.credits || 0
            let estimate = Math.ceil((1.2 * Math.round(eta / 1000))) * this.sampleArray.length;
            //estimate = parseInt(this.slider.limit.value) && this.groupArray[0].samples ? Math.ceil(eta * 2.2 / 500) : estimate
            //estimate = this.switches.lite ? estimate : estimate * 2
            console.log('estimate', estimate);
            estimate = estimate && estimate < 15 ? 15 : estimate
            console.log(`ETA for query is ${Math.ceil(eta/1000)} seconds`);
            if (estimate > credits) {
                let freesub = w.subs && w.subs.subType == 'free' ? true : false
                let buttons = [{
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.closable = false;
                        w.$modal.hide('dialog');
                    } // Button click handler
                }]
                if (freesub) {
                    buttons.unshift({
                        title: 'Subscribe',
                        handler: () => {
                            w.createNew = false;
                            w.$modal.hide('dialog');
                            w.recordEvent('subButtonAnalyze', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                } else {
                    buttons.unshift({
                        title: 'Add Credits',
                        handler: () => {
                            w.createNew = false;
                            w.$modal.hide('dialog');
                            w.recordEvent('subButtonAnalyze', {
                                'event_category': 'function',
                                'event_label': 'User initiated'
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'checkSubStatus',
                                params: 'addon',
                                component: 'nav',
                            })
                        } // Button click handler
                    })
                }
                w.$modal.show('dialog', {
                    title: 'Apologies',
                    text: `Unfortunately, you appear to have insufficient credits to execute this action<br><br><b>You need ${estimate} credits</b>` + (freesub ? `<br><b>Support us by subscribing to our services</b><br>` : '<br><b>Please add credits</b><br>'),
                    class: 'warning',
                    buttons: buttons
                })
                this.spinner = false;
                return
            }
            this.$store.commit('change', {
                statusMessage: ''
            })
            if (!this.onLine) {
                this.spinner = false;
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        title: 'Application offline',
                        text: 'Please refresh the page and re-run when the application is connected to the internet'
                    }
                });
                return false;
            }
            this.gridKey += 1;
            this.$store.commit('change', {
                g25firstRun: true
            })
            if (!this.gridApi) this.gridApi = this.gridOptions.api;
            this.$store.commit('change', {
                lastSort: false
            })
            var subId = this.$store.getters.get('user').username + ':' + this.queryTimeStamp;
            this.$store.commit('change', {
                subId: subId
            })
            var success = false;
            this.$store.commit('change', {
                spinner: true
            })
            //    this.chartReady = false;
            var evt = 'collapse-select';
            this.$root.$emit(evt, 'collapse');
            this.$store.commit('change', {
                g25chartSeries: []
            })
            var obj = {}
            this.components = []
            var filtered = this.aggregatedCalc && !this.switches.removeOutliers ? false : true
            var averaged = this.aggregatedCalc && this.switches.groupAveraged ? true : undefined
            var median = this.aggregatedCalc && this.switches.groupMedian ? true : undefined
            this.$store.commit('change', {
                g25chartComponents: this.components
            })
            var arr2 = this.sampleArray;
            var leftArr = []
            arr2.forEach(sample => {
                let vsample = w.mode !== 'G25' && sample.mode ? sample.group + '|' + w.mode : sample.v ? sample.group + '|' + sample.v : sample.group;
                leftArr.push(vsample + ':' + sample.sample)
                if (this.g25customsamples && this.g25customsamples.length > 0 && this.g25customsamples.findIndex(x => x.split(':')[1] == sample.sample && x.split(':')[0] == vsample) >= 0) customsamples = this.g25Rerun
            })
            if (customSampleArr && customSampleArr.length > 0) {
                customSampleArr.map(x => {
                    leftArr.push(x.sample)
                })
            }
            this.$store.commit('change', {
                g25chartCategories: leftArr
            })
            var chartOptions = this.chartOptions;
            this.chartOptions = chartOptions;
            var params = {
                sub: subId,
                calculator: this.groupArray[0].label,
                penalty: this.switches.penalty ? 0.001 : 0,
                filtered: filtered,
                batches: this.switches.lite ? undefined : this.slider.batches.value ? this.slider.batches.value : 200,
                cycles: this.switches.lite ? undefined : this.slider.cycles.value ? this.slider.cycles.value : 200,
                version: this.mode !== 'G25' ? undefined : this.publicGroups[0].v,
                averaged: averaged,
                median: median,
                customsamples: customsamples,
                raw: this.mode !== 'G25' ? true : false,
                scaled: this.mode !== 'G25' ? true : this.groupArray[0].scaled,
                creator: this.groupArray[0].user,
            }
            if (w.jsCalc && w.switches.lite && w.slider.limit && parseInt(w.slider.limit.value)) params.limit = parseInt(w.slider.limit.value)
            if (w.jsCalc && w.switches.lite && w.slider.min && parseInt(w.slider.min.value)) params.autofit = parseInt(w.slider.min.value)
            var samples = leftArr;
            w.$store.commit('change', {
                g25chartJSON: []
            })
            w.$store.commit('change', {
                g25chartCategories: samples
            })
            chartOptions = w.chartOptions
            w.chartOptions = chartOptions;
            w.subResults = [];
            let resultArr = [];
            let errorArr = []
            async function getResults(samples, eta) {
                w.reqnum = samples.length;
                w.start = Date.now()
                const profilesArr = samples.map(async sample => {
                    let newParams = JSON.parse(JSON.stringify(params));
                    newParams.sample = sample
                    newParams.excludegroups = w.calcGroupsArray && w.calcGroupsArray[0] ? w.calcGroupsArray.map(x => x.name) : undefined
                    newParams.id = sample;
                    newParams.subtype = w.subs && w.subs.subType ? w.subs.subType : 'free'
                    if (customSampleArr && customSampleArr.length > 0 && customSampleArr.find(x => x.sample == sample)) newParams.coords = customSampleArr.find(x => x.sample == sample).coords
                    const data = await w.$apollo.query({
                        query: calcQuery,
                        variables: {
                            params: JSON.stringify(newParams)
                        }
                    })
                    if (data.data && data.data[queryProp] && data.data[queryProp].result) {
                        let output = data.data[queryProp];
                        let result = output.result ? JSON.parse(output.result) : false
                        w.filterResults = {
                            quantity: output.quantity,
                            filtered: output.filtered
                        }
                        let nearest = output.nearest ? JSON.parse(output.nearest) : false
                        let geo = output.geo ? JSON.parse(output.geo) : false
                        let meta = output.meta ? JSON.parse(output.meta) : false
                        let version = output.version
                        let outdata = {
                            geo: geo,
                            result: result,
                            nearest: nearest,
                            coords: output.coords,
                            profile: output.profile,
                            distance: output.distance,
                            groupResult: output.groupResult,
                            sampleResult: output.sampleResult,
                            mapResult: output.mapResult,
                            meta: meta,
                            version: version
                        };
                        let index = w.sampleArray.find(x => x.index == sample)
                        if (index && index.alias) outdata.alias = index.alias
                        resultArr.push(outdata);
                        return outdata
                    } else {
                        errorArr.push(`sample ${sample.replace(/:/g, " ► ")} not found`)
                        return false;
                    }
                });
                //w.$sentry.configureScope(scope => { scope.setTag("transactionId", subId); });
                try {
                    const profiles = await Promise.all(profilesArr);
                    if (errorArr.length > 0) {
                        var errMessage = ''
                        errorArr.forEach(error => {
                            errMessage = errMessage + error + '<br>';
                        })
                        w.$store.commit('change', {
                            spinner: false
                        })
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Error',
                                text: errMessage,
                                class: 'failure'
                            }
                        })
                    }
                    if (resultArr.length <= 1) {
                        if (resultArr.length === 0) {
                            w.$store.commit('change', {
                                spinner: false
                            })
                            w.progress = 0;
                            return;
                        } else {
                            w.components = Object.keys(resultArr[0].result)
                            resultArr[0].groupResult = JSON.parse(resultArr[0].groupResult)
                            resultArr[0].sampleResult = JSON.parse(resultArr[0].sampleResult)
                            if (resultArr[0].mapResult) resultArr[0].mapResult = JSON.parse(resultArr[0].mapResult)
                            w.groupcomponents = Object.keys(resultArr[0].groupResult)
                            w.samplecomponents = Object.keys(resultArr[0].sampleResult)
                            //w.alias = w.sampleArray.find( x => x.alias && x.profile == 
                            var obj = resultArr[0].result
                            var keys = Object.keys(obj)
                        }
                    } else {
                        var sortKey = w.components[0]
                        var val = 0;
                        var index = 0;
                        var compindex = 0;
                        var profile = false;
                        let compObj = {}
                        let groupObj = {}
                        let sampleObj = {}
                        resultArr.map(x => {
                            x.groupResult = JSON.parse(x.groupResult);
                            x.sampleResult = JSON.parse(x.sampleResult);
                            if (x.mapResult) x.mapResult = JSON.parse(x.mapResult);
                            Object.keys(x.result).map(x => {
                                compObj[x] = true
                            })
                            Object.keys(x.groupResult).map(x => {
                                groupObj[x] = true
                            })
                            Object.keys(x.sampleResult).map(x => {
                                sampleObj[x] = true
                            })
                        })
                        w.components = Object.keys(compObj);
                        w.groupcomponents = Object.keys(groupObj);
                        w.samplecomponents = Object.keys(sampleObj);

                        resultArr.forEach((sample, i) => {
                            w.components.forEach((comp, n) => {
                                if (sample.result[comp] >= val) {
                                    sortKey = comp;
                                    val = sample.result[comp]
                                    profile = sample.profile
                                    index = i
                                    compindex = n
                                }
                            })
                        })
                        var obj = resultArr[index].result
                        var keys = JSON.parse(JSON.stringify(w.components))
                    }
                    w.$store.commit('change', {
                        g25chartComponents: w.components
                    })
                    w.$store.commit('change', {
                        g25calcComponents: w.groupcomponents
                    })
                    w.$store.commit('change', {
                        g25calcSampleComponents: w.samplecomponents
                    })

                    var chartColors = w.chartColors[w.slider.colors.value - 1]
                    var colors = [...chartColors].slice(0, w.components.length);
                    w.$store.commit('change', {
                        g25chartColors: colors
                    })
                    var calcColors = w.chartColors[w.slider.colors.value - 1]
                    calcColors = [...calcColors].slice(0, w.components.length);
                    w.$store.commit('change', {
                        g25calcColors: calcColors
                    })
                    var chartOptions = w.chartOptions;
                    chartOptions.colors = colors;
                    w.chartOptions = chartOptions;
                    keys.sort(function(a, b) {
                        var x = obj[a] ? obj[a] : 0;
                        var y = obj[b] ? obj[b] : 0;
                        return ((x < y) ? 1 : ((x > y) ? -1 : 0))
                    })
                    w.components = keys
                    w.$store.commit('change', {
                        geo: resultArr[0].geo
                    })
                    w.$store.commit('change', {
                        g25chartJSON: resultArr
                    })
                    setTimeout(() => {
                        w.$store.commit('change', {
                            spinner: false
                        })
                    }, 100)
                    w.processJSON(w.components[0]);
                    w.progress = 100;
                    var filterMsg = w.filterResults && w.filterResults.filtered && w.filterResults.filtered > 0 ? ` >> filtered: ${w.filterResults.filtered} outliers/${w.filterResults.quantity} samples` : ''
                    if (w.sampleArray.length > 1) {
                        if (profiles.length < w.sampleArray.length) {
                            var status = `${new Date().toLocaleString()}: Query did not complete ${w.sampleArray.length - profiles.length} subqueries/${w.sampleArray.length} in ${Math.round((Date.now() - w.start) / 1000)} seconds` + filterMsg
                            console.log(status)
                            w.$eventBus.$emit('appEvents', {
                                exec: 'setError',
                                component: 'nav',
                                params: status
                            })
                        } else {
                            var status = `${new Date().toLocaleString()}: Query completed in ${Math.round((Date.now() - w.start) / 1000)} seconds with no incomplete subqueries/${w.sampleArray.length}` + filterMsg
                            console.log(status)
                            w.$store.commit('change', {
                                lastQuery: status
                            })
                        }
                    } else {
                        var status = `${new Date().toLocaleString()}:` + ' Query completed in ' + Math.round((Date.now() - w.start) / 1000) + ' seconds' + filterMsg
                        console.log(status)
                        w.$store.commit('change', {
                            lastQuery: status
                        })
                    }
                    return profiles
                    w.progress = 0;
                } catch (err) {
                    console.log('caught getResults ', err);
                    var error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                    w.$eventBus.$emit('appEvents', {
                        exec: 'setError',
                        component: 'nav',
                        params: error
                    })
                    w.$store.commit('change', {
                        spinner: false
                    })
                    w.progress = 0;
                    if (error.indexOf('insufficient credits') >= 0) {
                        let freesub = w.subs && w.subs.subType == 'free' ? true : false
                        let buttons = [{
                            title: 'Cancel',
                            default: true,
                            handler: () => {
                                w.closable = false;
                                w.$modal.hide('dialog');
                            } // Button click handler
                        }]
                        if (freesub) {
                            buttons.unshift({
                                title: 'Subscribe',
                                handler: () => {
                                    w.createNew = false;
                                    w.$modal.hide('dialog');
                                    w.recordEvent('subButtonAnalyze', {
                                        'event_category': 'function',
                                        'event_label': 'User initiated'
                                    })
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'checkSubStatus',
                                        component: 'nav',
                                    })
                                } // Button click handler
                            })
                        } else {
                            buttons.unshift({
                                title: 'Add Credits',
                                handler: () => {
                                    w.createNew = false;
                                    w.$modal.hide('dialog');
                                    w.recordEvent('subButtonAnalyze', {
                                        'event_category': 'function',
                                        'event_label': 'User initiated'
                                    })
                                    w.$eventBus.$emit('appEvents', {
                                        exec: 'checkSubStatus',
                                        params: 'addon',
                                        component: 'nav',
                                    })
                                } // Button click handler
                            })
                        }
                        w.$modal.show('dialog', {
                            title: 'Apologies',
                            text: "Unfortunately, you appear to have insufficient credits to execute this action" + (freesub ? `<br><b>Support us by subscribing to our services</b><br>` : '<br><b>Please add credits</b><br>'),
                            class: 'warning',
                            buttons: buttons
                        })
                    } else {
                        w.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Error',
                                text: error,
                                class: 'failure'
                            }
                        })
                    }

                    //var json = w.$store.getters.get('g25chartJSON')
                    var json = resultArr;
                    if (Array.isArray(json) && json.length > 0) {
                        w.$store.commit('change', {
                            g25chartJSON: json
                        })
                        w.$store.commit('change', {
                            spinner: false
                        })
                        w.$store.commit('change', {
                            lastSort: false
                        })
                        if (json.length < w.sampleArray.length) {
                            var status = `${new Date().toLocaleString()}: Query did not complete ${w.sampleArray.length - json.length} subqueries/${w.sampleArray.length} in ${Math.round((Date.now() - w.start) / 1000)} seconds`
                            console.log(status)
                            w.$eventBus.$emit('appEvents', {
                                exec: 'setError',
                                component: 'nav',
                                params: status
                            })
                        } else {
                            var status = `${new Date().toLocaleString()}: Query completed in ${Math.round((Date.now() - w.start) / 1000)} seconds with no incomplete subqueries/${w.sampleArray.length}`
                            console.log(status)
                            w.$store.commit('change', {
                                lastQuery: status
                            })
                        }
                        w.processJSON(w.components[0]);
                        w.unchanged = true;
                    }
                }
            }
            w.showProgress(eta);
            getResults(samples);
        },
        loadPCA() {
            this.spinner = true
            let samples = {}
            let plotCustomGroups = this.groupArray.filter(x => !x.sample)
            let groupsamples = this.groupArray.filter(x => x.sample)
            let samplearray = [...this.sampleArray]
            let sampleobjects = []
            if (groupsamples.length) {
                groupsamples.map(x => {
                    let found = this.sampleOptions.find(y => y.originalGroup == x.group)
                    if (found) {
                        found = found.samples.find(z => z.index == x.label)
                    }
                    if (found) sampleobjects.push(found)
                })
            }
            samplearray = samplearray.concat(sampleobjects)
            samples['plotUserSamples'] = samplearray
            this.$store.commit('change', samples)
            let groups = {}
            groups['plotCustomGroups'] = plotCustomGroups
            this.$store.commit('change', groups)
            let interested = {
                plotInterestedSamples: []
            }
            this.$store.commit('change', interested)
            this.$store.commit('change', {
                autopca: this.switches.calculator ? `${decodeURI(this.groupArray[0].description).trim()}` : true
            })
            var name = this.user.username + ':plot:multiselect:customGroupModel'
            localStorage.setItem(name, JSON.stringify(plotCustomGroups));
            var name = this.user.username + ':plot:multiselect:sampleModel'
            localStorage.setItem(name, JSON.stringify(samplearray));
            this.$router.push('/pca')
        },
        runMonte: async function() {
            if (this.running) {
                this.$store.commit('change', {
                    spinner: false
                })
            }
            let w = this;
            var evt = 'collapse-select';
            setTimeout(() => {
                this.$root.$emit(evt, 'collapse');
            }, 10)
            w.destroyIntro();
            w.spinner = true;
            setTimeout(() => {
                let customsamples = false;
                let customSampleArr = [];
                if (this.csv && this.customSampleCount > 0) {
                    try {
                        let csv = this.csv.split('\n').filter(x => x != '')
                        let length = !w.mode || w.mode == 'G25' ? 25 : w.mode && w.modecomponents[w.mode] ? w.modecomponents[w.mode].length : 25
                        csv.map(sample => {
                            customSampleArr.push({
                                sample: 'Custom:' + sample.split(',')[0].split(':').reverse()[0],
                                coords: sample.split(',').slice(-1 * length).join(',')
                            })
                        })
                    } catch (err) {
                        console.log(err);
                    }
                }
                let heatmaps = []
                if (w.heatmapJSON.length > 0) this.$store.commit('change', {
                    g25heatmapJSON: false
                })
                this.mapOptions = false;
                if (this.switches.calculator) {
                    this.runCalc()
                    return;
                }
                if (w.previousQueryTimeStamp == w.queryTimeStamp) {
                    var json = w.$store.getters.get('g25chartJSON')
                    if (Array.isArray(json) && json.length > 0) {
                        w.spinner = true;
                        setTimeout(() => {
                            w.$store.commit('change', {
                                spinner: false
                            })
                        }, 0)
                        w.processJSON(w.components[0]);
                        return;
                    } else {
                        w.queryTimeStamp = Date.now()
                    }
                }
                if (this.map && this.map.geo) {
                    this.map.geo.center = undefined
                    this.map.geo.zoom = 1.25
                }
                this.recordEvent('runNMonte', {
                    'event_category': 'function',
                    'event_label': 'User initiated'
                })
                var penalty = this.switches.penalty ? 0.001 : 0;
                var unscaled = this.mode !== 'G25' ? false : this.switches.scaled ? false : true;
                var batches = this.switches.lite ? 200 : this.slider.batches.value ? this.slider.batches.value : 100;
                var cycles = this.switches.lite ? 200 : this.slider.cycles.value ? this.slider.cycles.value : 100;
                var batch = batches > 600 ? (batches * batches) / 600 : batches
                var eta = (100 * batch * cycles) / 1000
                eta = w.switches.lite && parseInt(w.slider.limit.value) ? eta * parseInt(w.slider.limit.value) * (w.groupArray.length / 10) : eta
                eta = this.switches.optimaFit ? 60000 : batches < 400 && cycles < 400 ? eta * 1.2 : eta
                let credits = this.credits || 0
                let totalSamples = this.sampleArray.length + this.customSampleCount
               // let estimate = Math.ceil((0.8 * Math.round(eta / 1000)) / 3) * totalSamples
                let estimate = Math.ceil((1 * Math.round(eta / 1000))) * totalSamples
                if (this.switches.optimaFit) {
                    estimate = 260;
                }
                if (w.switches.lite && parseInt(w.slider.limit.value)) {
                    estimate = parseInt((eta * 2.2) / 1000)
                }
                console.log(`ETA for query is ${Math.round(eta/1000)} seconds`);
                console.log('estimate', estimate, credits)
                if (estimate > credits) {
                    let freesub = w.subs && w.subs.subType == 'free' ? true : false
                    let buttons = [{
                        title: 'Cancel',
                        default: true,
                        handler: () => {
                            w.closable = false;
                            w.$modal.hide('dialog');
                        } // Button click handler
                    }]
                    if (freesub) {
                        buttons.unshift({
                            title: 'Subscribe',
                            handler: () => {
                                w.createNew = false;
                                w.$modal.hide('dialog');
                                w.recordEvent('subButtonAnalyze', {
                                    'event_category': 'function',
                                    'event_label': 'User initiated'
                                })
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'checkSubStatus',
                                    component: 'nav',
                                })
                            } // Button click handler
                        })

                    } else {
                        buttons.unshift({
                            title: 'Add Credits',
                            handler: () => {
                                w.createNew = false;
                                w.$modal.hide('dialog');
                                w.recordEvent('subButtonAnalyze', {
                                    'event_category': 'function',
                                    'event_label': 'User initiated'
                                })
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'checkSubStatus',
                                    params: 'addon',
                                    component: 'nav',
                                })
                            } // Button click handler
                        })
                    }
                    w.$modal.show('dialog', {
                        title: 'Apologies',
                        text: `Unfortunately, you appear to have insufficient credits to execute this action<br><br><b>You need ${estimate} credits</b>` + (freesub ? `<br><b>Support us by subscribing to our services</b><br>` : '<br><b>Please add credits</b><br>'),
                        class: 'warning',
                        buttons: buttons
                    })
                    this.spinner = false;
                    return
                }
                this.$store.commit('change', {
                    statusMessage: ''
                })
                if (!this.onLine) {
                    this.spinner = false;
                    this.$eventBus.$emit('appEvents', {
                        exec: 'show',
                        component: 'nav',
                        params: {
                            title: 'Application offline',
                            text: 'Please refresh the page and re-run when the application is connected to the internet'
                        }
                    });
                    return false;
                }
                if (this.switches.optimaFit) {
                    if (this.sampleArray.length + this.customSampleCount > 1 || (this.groupArray.length !== 0 && this.groupArray.length < 8)) {
                        this.$eventBus.$emit('appEvents', {
                            exec: 'show',
                            component: 'nav',
                            params: {
                                title: 'Unable to run optimaFit',
                                text: 'optimaFit is designed to run one sample at a time<br/>The ideal number of selected populations is 10, however any number between 8 to 20 should work well<br/>Alternatively, you may choose to run with no groups selected<br/>In this case, optimaFit will automatically find the groups that provide the best fit (moderns only)'
                            }
                        });
                        return false;
                    }
                }
                this.gridKey += 1;
                this.$store.commit('change', {
                    g25firstRun: true
                })
                if (!this.gridApi) this.gridApi = this.gridOptions.api;
                this.$store.commit('change', {
                    lastSort: false
                })
                var subId = this.$store.getters.get('user').username + ':' + this.queryTimeStamp;
                this.$store.commit('change', {
                    subId: subId
                })
                var success = false;
                this.$store.commit('change', {
                    spinner: true
                })
                this.chartReady = false;
                let arr = _.cloneDeep(this.groupArray)
                var submitArr = []
                var quantity = 0;
                arr.forEach(group => {
                    if (group.label) {
                        group.label = group.label.replace(' ► ', ':')
                        let vgroup = group.v ? (group.label.split(':').length > 1 ? group.label.split(':')[0] + '|' + group.v + ':' + group.label.split(':')[1] : group.label + '|' + group.v) : this.mode !== 'G25' ? (group.label.split(':').length > 1 ? group.label.split(':')[0] + '|' + this.mode + ':' + group.label.split(':')[1] : group.label.split(':')[0] + '|' + this.mode) : group.alias ? {
                            alias: group.alias,
                            sample: group.label
                        } : group.label;
                        submitArr.push(vgroup)
                        quantity = quantity + group.samples;
                    } else {
                        submitArr.push(group.group + ':' + group.sample)
                        quantity = quantity + 1;
                        if (this.g25customsamples && this.g25customsamples.length > 0 && this.g25customsamples.findIndex(sample => sample.split(':')[1] == group.sample && sample.split(':')[0] == group.group) >= 0) customsamples = this.g25Rerun
                    }
                })
                quantity = averaged ? submitArr.length : quantity
                this.$store.commit('change', {
                    g25chartSeries: []
                })
                var averaged = this.switches.groupAveraged ? true : false
                var median = this.switches.groupMedian ? true : false
                var obj = {}
                if (averaged || median) {
                    this.components = []
                    var suffix = averaged ? ' (AVG)' : ' (MED)';
                    submitArr.forEach(comp => {
                        comp = typeof(comp) == 'object' && comp.sample ? comp.sample : comp
                        let group = comp.split('|').length > 1 && (comp.split('|')[1].split(':')[0] > 2 || comp.split('|')[1].split(':')[0].length > 2) ? comp.split('|')[0] : comp
                        if (group.split(':').length > 1) {
                            //obj[group.split(':')[0]] = true
                            group = comp.split('|').length > 1 && comp.split('|')[1].split(':')[0] > 2 && !this.switches.custom ? comp.split('|')[0] : comp.split('|').length > 1 && comp.split('|')[1].split(':')[0] > 2 && this.switches.custom ? (comp.split(':').length > 1 ? comp.split('|')[0] + ' • ' + comp.split(':')[1] : comp.split('|')[0]) : comp.split(':').length > 1 && this.switches.custom ? comp.replace(/:/, ' • ') : comp
                            var suf = group + suffix;
                            obj[suf] = true
                        } else {
                            var suf = group + suffix;
                            obj[suf] = true
                        }
                    })
                } else {
                    this.components = []
                    submitArr.forEach(component => {
                        let comp = typeof(component) == 'object' && component.sample ? component.sample : component
                        let group = comp.split('|').length > 1 && comp.split('|')[1].split(':')[0] > 2 && !this.switches.custom ? comp.split('|')[0] : comp.split('|').length > 1 && comp.split('|')[1].split(':')[0] > 2 && this.switches.custom ? (comp.split(':').length > 1 ? comp.split('|')[0] + ' • ' + comp.split(':')[1] : comp.split('|')[0]) : comp.split(':').length > 1 && this.switches.custom ? comp.replace(/:/, ' • ') : comp
                        if (group.split(':').length > 1 && !this.switches.custom) {
                            obj[group.split(':')[0]] = true
                        } else {
                            if (component.alias) {
                                obj[component.alias + ' • ' + group.split(' • ')[1]] = true
                            } else {
                                obj[group] = true
                            }
                        }
                    })
                }
                console.log(submitArr);

                if (this.switches.optimaFit && submitArr[0]) {
                    console.log('optimaFit pool:', submitArr.map(x => x = x.split('|')[0].replace(/_/g, ' ')))
                }
                this.components = Object.keys(obj);
                var filtered = this.switches.removeOutliers ? true : false
                this.$store.commit('change', {
                    g25chartComponents: this.components
                })
                var chartColors = this.chartColors[this.slider.colors.value - 1]
                var colors = [...chartColors].slice(0, submitArr.length);
                [0]
                this.$store.commit('change', {
                    g25chartColors: colors
                })
                var chartOptions = this.chartOptions;
                chartOptions.colors = colors;
                this.chartOptions = chartOptions;
                var arr2 = this.sampleArray;
                var leftArr = []
                arr2.forEach(sample => {
                    let vsample = sample.v ? sample.group + '|' + sample.v : sample.type === 'raw' ? sample.group + '|' + this.mode : sample.group
                    leftArr.push(vsample + ':' + sample.sample)
                    if (this.g25customsamples && this.g25customsamples.length > 0 && this.g25customsamples.findIndex(x => x.split(':')[1] == sample.sample && x.split(':')[0] == vsample) >= 0) customsamples = this.g25Rerun
                })
                if (customSampleArr && customSampleArr.length > 0) {
                    customSampleArr.map(x => {
                        leftArr.push(x.sample)
                    })
                }
                this.$store.commit('change', {
                    g25chartCategories: leftArr
                })
                var chartOptions = this.chartOptions;
                this.chartOptions = chartOptions;
                var params = {
                    groups: submitArr,
                    penalty: penalty,
                    custom: this.switches.custom ? true : false,
                    mode: this.mode !== 'G25' ? this.mode : undefined,
                    auto: submitArr[0] ? false : true,
                    raw: this.mode !== 'G25' ? true : false,
                    version: this.mode !== 'G25' ? undefined : this.publicGroups[0].v,
                    batches: batches,
                    cycles: cycles,
                    unscaled: unscaled,
                    sub: subId,
                    customsamples: customsamples
                }
                if (w.jsCalc && w.slider.limit && parseInt(w.slider.limit.value)) params.limit = parseInt(w.slider.limit.value)
                if (w.jsCalc && w.slider.min && parseInt(w.slider.min.value)) params.autofit = parseInt(w.slider.min.value)
                if (averaged) params.averaged = averaged
                if (median) params.median = median
                if (filtered) params.filtered = filtered
                var samples = leftArr;
                w.$store.commit('change', {
                    g25chartJSON: []
                })
                w.$store.commit('change', {
                    g25chartCategories: samples
                })
                chartOptions = w.chartOptions
                w.chartOptions = chartOptions;
                w.subResults = [];
                if (this.switches.optimaFit) {
                    var query = invokeOptiFitQuery
                    samples = [samples[0]]
                    this.recordEvent('optimaFit', {
                        'event_category': 'feature',
                        'event_label': 'optimaFit'
                    })
                } else {
                    var query = w.switches.lite ? invokeApiJSQuery : invokeApiQuery
                }
                let response = w.switches.lite ? 'invokeJS' : 'invoke'
                async function invokeLambda(samples, eta) {
                    w.reqnum = samples.length;
                    w.start = Date.now()
                    const profilesArr = samples.map(async sample => {
                        let newParams = JSON.parse(JSON.stringify(params));
                        newParams.sample = sample;
                        newParams.subtype = w.subs && w.subs.subType ? w.subs.subType : 'free'
                        console.log('params', newParams, sample)
                        newParams.id = sample + ':' + newParams.groups.map(([x]) => (x)).join('');
                        if (customSampleArr && customSampleArr.length > 0 && customSampleArr.find(x => x.sample == sample)) newParams.coords = customSampleArr.find(x => x.sample == sample).coords
                        console.log('invoking', newParams);
                        const data = await w.$apollo.query({
                            query: query,
                            variables: {
                                event: JSON.stringify(newParams)
                            }
                        })
                        if (data.data && data.data[response] && data.data[response].status == "PENDIMG") {
                            return data.data[response].status
                        } else if (data.data && data.data.invokeOptiFit && data.data.invokeOptiFit.status == "PENDIMG") {
                            return data.data.invokeOptiFit.status

                        } else {
                            console.log('Invoke lambda failed for ' + sample);
                            console.log(data);
                            return data;
                        }
                    });
                    //w.$sentry.configureScope(scope => { scope.setTag("transactionId", subId); });
                    try {
                        const profiles = await Promise.all(profilesArr);
                        return profiles
                    } catch (err) {
                        console.log('caught invokeApi', err);
                        w.error = err.info && err.message ? err.info + err.message : err.message ? err.message : err.Message ? err.Message : err
                        w.$eventBus.$emit('appEvents', {
                            exec: 'setError',
                            component: 'nav',
                            params: w.error

                        })
                        w.$store.commit('change', {
                            spinner: false
                        })
                        w.progress = 0;
                        if (error.indexOf('insufficient credits') >= 0) {
                            let freesub = w.subs && w.subs.subType == 'free' ? true : false
                            let buttons = [{
                                title: 'Cancel',
                                default: true,
                                handler: () => {
                                    w.closable = false;
                                    w.$modal.hide('dialog');
                                } // Button click handler
                            }]
                            if (freesub) {
                                buttons.unshift({
                                    title: 'Subscribe',
                                    handler: () => {
                                        w.createNew = false;
                                        w.$modal.hide('dialog');
                                        w.recordEvent('subButtonAnalyze', {
                                            'event_category': 'function',
                                            'event_label': 'User initiated'
                                        })
                                        w.$eventBus.$emit('appEvents', {
                                            exec: 'checkSubStatus',
                                            component: 'nav',
                                        })
                                    } // Button click handler
                                })
                            } else {
                                buttons.unshift({
                                    title: 'Add Credits',
                                    handler: () => {
                                        w.createNew = false;
                                        w.$modal.hide('dialog');
                                        w.recordEvent('subButtonAnalyze', {
                                            'event_category': 'function',
                                            'event_label': 'User initiated'
                                        })
                                        w.$eventBus.$emit('appEvents', {
                                            exec: 'checkSubStatus',
                                            params: 'addon',
                                            component: 'nav',
                                        })
                                    } // Button click handler
                                })
                            }
                            w.$modal.show('dialog', {
                                title: 'Apologies',
                                text: "Unfortunately, you appear to have insufficient credits to execute this action" + (freesub ? `<br><b>Support us by subscribing to our services</b><br>` : '<br><b>Please add credits</b><br>'),
                                class: 'warning',
                                buttons: buttons
                            })
                        } else {
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: 'Error',
                                    text: w.error,
                                    class: 'failure'
                                }
                            })
                        }
                        var json = w.$store.getters.get('g25chartJSON')
                        if (Array.isArray(json) && json.length > 2) {
                            w.$store.commit('change', {
                                spinner: false
                            })
                            w.unchanged = true;
                            w.processJSON(w.components[0]);
                        }
                    }
                }
                let resultArr = [];
                let errorArr = []
                async function getResults(samples, eta) {
                    w.reqnum = samples.length;
                    w.start = Date.now()
                    let lite = w.switches.lite ? true : false
                    let response = w.switches.lite ? 'runJSResult' : 'getResult'
                    const profilesArr = samples.map(async sample => {
                        let newParams = JSON.parse(JSON.stringify(params));
                        newParams.sample = sample;
                        newParams.id = sample;
                        newParams.subtype = w.subs && w.subs.subType ? w.subs.subType : 'free'
                        if (customSampleArr && customSampleArr.length > 0 && customSampleArr.find(x => x.sample == sample)) newParams.coords = customSampleArr.find(x => x.sample == sample).coords
                        const data = await w.$apollo.query({
                            query: lite ? getResultJSQuery : getResultQuery,
                            variables: {
                                params: JSON.stringify(newParams)
                            }
                        })
                        if (data.data && data.data[response] && data.data[response].result) {
                            w.previousQueryTimeStamp = w.queryTimeStamp
                            let output = data.data[response]
                            let result = output.result ? JSON.parse(output.result) : false
                            w.filterResults = {
                                quantity: output.quantity,
                                filtered: output.filtered
                            }
                            if (w.switches.groupAveraged) {
                                var newresult = {}
                                Object.keys(result).forEach(comp => {
                                    newresult[comp + ' (AVG)'] = result[comp];
                                })
                                result = newresult;
                            }
                            if (w.switches.groupMedian) {
                                var newresult = {}
                                Object.keys(result).forEach(comp => {
                                    newresult[comp + ' (MED)'] = result[comp];
                                })
                                result = newresult;
                            }
                            //console.log('result', result);
                            let nearest = output.nearest ? JSON.parse(output.nearest) : false
                            let nearestGroups = {}
                            let heatmap = {
                                group: sample.split(':')[0],
                                name: sample.split(':').length > 1 ? sample.split(':')[1] : sample.split(':')[0],
                                data: []
                            }
                            let max = 0;
                            let profile = output.profile
                            nearest.map((x, i) => {
                                if (!nearestGroups[x._row.split(':')[0]]) {
                                    max = x.distance > max ? x.distance : max;
                                    nearestGroups[x._row.split(':')[0]] = true
                                    heatmap.data.push({
                                        x: x._row.split(' • ').length > 1 ? x._row.split(' • ')[0].replace(/_/g, " ") + '[' + x._row.split(' • ')[1] + ']' : x._row.split(':')[0].replace(/_/g, " "),
                                        y: x.distance,
                                        distance: x.distance,
                                        sample: x._row.split(' • ').length > 10 && (averaged || median) ? x._row + (averaged ? ' (AVG)' : ' (MED)') : x._row,
                                        profile: profile
                                    })
                                }
                            })

                            let length = heatmap.data.length
                            let similar = false;
                            let sum = 0;
                            heatmap.data = heatmap.data.map((x, i) => {
                                x.y = i === 0 ? 2 * length : i === length - 1 ? (length + 1) - i + 0.5 : (length + 1) - i;
                                sum = sum + x.y;
                                if (x.y === 2 * length) similar = {
                                    group: x.x,
                                    distance: x.distance,
                                    profile: x.profile
                                }
                                return x
                            })
                            heatmap.sum = sum;
                            if (heatmap.data.length > 0) {
                                heatmap.data.sort((a, b) => a.x > b.x ? 1 : a.x < b.x ? -1 : 0)
                                heatmaps.push(heatmap);
                            }
                            let geo = output.geo ? JSON.parse(output.geo) : false
                            let meta = output.meta ? JSON.parse(output.meta) : false
                            let coords = output.coords ? output.coords : false
                            let batches = output.batches
                            let version = output.version
                            let cycles = output.cycles
                            let outdata = {
                                batches: batches,
                                geo: geo,
                                meta: meta,
                                cycles: cycles,
                                similar: similar,
                                result: result,
                                coords: coords,
                                nearest: nearest,
                                profile: output.profile,
                                heatmap: heatmap.data.length > 0 ? heatmap : undefined,
                                distance: output.distance,
                                penalty: output.penalty,
                                version: version
                            };
                            let index = w.sampleArray.find(x => x.index == sample)

                            if (index && index.alias) outdata.alias = index.alias
                            resultArr.push(outdata);
                            return outdata
                        } else {
                            errorArr.push(`sample ${sample.replace(/:/g, " ► ")} not found`)
                            return false;
                        }
                    });
                    //w.$sentry.configureScope(scope => { scope.setTag("transactionId", subId); });
                    try {
                        const profiles = await Promise.all(profilesArr);
                        if (heatmaps.length > 0) {
                            w.$store.commit('change', {
                                g25heatmapJSON: heatmaps
                            })
                        }

                        //console.log(w.heatmapJSON);
                        if (errorArr.length > 0) {
                            var errMessage = ''
                            errorArr.forEach(error => {
                                errMessage = errMessage + error + '<br>';
                            })
                            w.$store.commit('change', {
                                spinner: false
                            })
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: 'Error',
                                    text: errMessage,
                                    class: 'failure'
                                }
                            })
                        }
                        if (resultArr.length <= 1) {
                            if (resultArr.length === 0) {
                                w.$store.commit('change', {
                                    spinner: false
                                })
                                w.progress = 0;
                                return;
                            } else {
                                var obj = resultArr[0].result
                                var keys = Object.keys(obj)
                            }
                        } else {
                            var sortKey = w.components[0]
                            var val = 0;
                            var index = 0;
                            var compindex = 0;
                            var profile = false;
                            let newComp = {}
                            let maxVals = {}
                            resultArr.forEach((sample, i) => {
                                w.components.forEach((comp, n) => {
                                    comp = comp.split(' • ').length > 1 ? comp.split(' • ')[0].split('|')[0] + ' • ' + comp.split(' • ')[1] : comp.split('|')[0]
                                    if (sample.result[comp]) {
                                        maxVals[comp] = maxVals[comp] == undefined ? sample.result[comp] : maxVals[comp] < sample.result[comp] ? sample.result[comp] : maxVals[comp]
                                    }
                                    //if (sample.result[comp]) newComp[comp] = true
                                    newComp[comp] = true
                                    if (sample.result[comp] >= val) {
                                        sortKey = comp;
                                        val = sample.result[comp]
                                        profile = sample.profile
                                        index = i
                                        compindex = n
                                    }
                                })
                            })
                            w.maxVals = maxVals;
                            var obj = resultArr[index].result
                            var keys = Object.keys(newComp);
                            //var keys = w.components
                        }
                        keys.sort(function(a, b) {
                            var x = obj[a] ? obj[a] : 0;
                            var y = obj[b] ? obj[b] : 0;
                            return ((x < y) ? 1 : ((x > y) ? -1 : 0))
                        })
                        w.components = keys;
                        w.$store.commit('change', {
                            geo: resultArr[0].geo
                        })
                        w.$store.commit('change', {
                            g25chartJSON: resultArr
                        })
                        w.$store.commit('change', {
                            spinner: false
                        })
                        w.processJSON(w.components[0]);
                        w.progress = 100;
                        var filterMsg = w.filterResults && w.filterResults.filtered && w.filterResults.filtered > 0 ? ` >> filtered: ${w.filterResults.filtered} outliers/${w.filterResults.quantity} samples` : ''
                        if (w.sampleArray.length > 1) {
                            if (profiles.length < w.sampleArray.length) {
                                var status = `${new Date().toLocaleString()}: Query did not complete ${w.sampleArray.length - profiles.length} subqueries/${w.sampleArray.length} in ${Math.round((Date.now() - w.start) / 1000)} seconds` + filterMsg
                                console.log(status)
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'setError',
                                    component: 'nav',
                                    params: status
                                })
                            } else {
                                var status = `${new Date().toLocaleString()}: Query completed in ${Math.round((Date.now() - w.start) / 1000)} seconds with no incomplete subqueries/${w.sampleArray.length}` + filterMsg
                                console.log(status)
                                w.$store.commit('change', {
                                    lastQuery: status
                                })
                            }
                        } else {
                            var status = `${new Date().toLocaleString()}:` + ' Query completed in ' + Math.round((Date.now() - w.start) / 1000) + ' seconds' + filterMsg
                            console.log(status)
                            w.$store.commit('change', {
                                lastQuery: status
                            })
                        }
                        return profiles
                        w.progress = 0;
                    } catch (err) {
                        console.log('caught getResults ', err);
                        var error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                        w.$eventBus.$emit('appEvents', {
                            exec: 'setError',
                            component: 'nav',
                            params: error
                        })
                        w.$store.commit('change', {
                            spinner: false
                        })
                        w.progress = 0;
                        if (error.indexOf('insufficient credits') >= 0) {
                            let freesub = w.subs && w.subs.subType == 'free' ? true : false
                            let buttons = [{
                                title: 'Cancel',
                                default: true,
                                handler: () => {
                                    w.closable = false;
                                    w.$modal.hide('dialog');
                                } // Button click handler
                            }]
                            if (freesub) {
                                buttons.unshift({
                                    title: 'Subscribe',
                                    handler: () => {
                                        w.createNew = false;
                                        w.$modal.hide('dialog');
                                        w.recordEvent('subButtonAnalyze', {
                                            'event_category': 'function',
                                            'event_label': 'User initiated'
                                        })
                                        w.$eventBus.$emit('appEvents', {
                                            exec: 'checkSubStatus',
                                            component: 'nav',
                                        })
                                    } // Button click handler
                                })
                            } else {
                                buttons.unshift({
                                    title: 'Add Credits',
                                    handler: () => {
                                        w.createNew = false;
                                        w.$modal.hide('dialog');
                                        w.recordEvent('subButtonAnalyze', {
                                            'event_category': 'function',
                                            'event_label': 'User initiated'
                                        })
                                        w.$eventBus.$emit('appEvents', {
                                            exec: 'checkSubStatus',
                                            params: 'addon',
                                            component: 'nav',
                                        })
                                    } // Button click handler
                                })
                            }
                            w.$modal.show('dialog', {
                                title: 'Apologies',
                                text: "Unfortunately, you appear to have insufficient credits to execute this action" + (freesub ? `<br><b>Support us by subscribing to our services</b><br>` : '<br><b>Please add credits</b><br>'),
                                class: 'warning',
                                buttons: buttons
                            })
                        } else {
                            w.$eventBus.$emit('appEvents', {
                                exec: 'show',
                                component: 'nav',
                                params: {
                                    title: 'Error',
                                    text: error,
                                    class: 'failure'
                                }
                            })
                        }

                        //var json = w.$store.getters.get('g25chartJSON')
                        var json = resultArr;
                        if (Array.isArray(json) && json.length > 0) {
                            w.$store.commit('change', {
                                g25chartJSON: json
                            })
                            w.$store.commit('change', {
                                spinner: false
                            })
                            w.$store.commit('change', {
                                lastSort: false
                            })
                            if (json.length < w.sampleArray.length) {
                                var status = `${new Date().toLocaleString()}: Query did not complete ${w.sampleArray.length - json.length} subqueries/${w.sampleArray.length} in ${Math.round((Date.now() - w.start) / 1000)} seconds`
                                console.log(status)
                                w.$eventBus.$emit('appEvents', {
                                    exec: 'setError',
                                    component: 'nav',
                                    params: status
                                })
                            } else {
                                var status = `${new Date().toLocaleString()}: Query completed in ${Math.round((Date.now() - w.start) / 1000)} seconds with no incomplete subqueries/${w.sampleArray.length}`
                                console.log(status)
                                w.$store.commit('change', {
                                    lastQuery: status
                                })
                            }
                            w.processJSON(w.components[0]);
                            w.unchanged = true;
                        }
                    }
                }
                if (eta < 10000) {
                    w.showProgress(eta);
                    getResults(samples);
                } else {
                    w.subMonte(params.sub, eta);
                    invokeLambda(samples);
                }
            }, 50)
        },
        showProgress(eta) {
            this.progress = 0;
            var i = 0;
            var eta = eta;
            var timer = Math.round(eta / 100)
            var incr = 1
            var w = this;
            var increment = function() {
                i++;
                if (i < 100) {
                    if (i > 93) timer = timer * 2
                    var incrementTimer = setTimeout(function() {

                        if (!w.chartReady) {
                            w.progress = i;
                            increment()
                        } else {
                            w.progress = 0;
                        }
                    }, timer);
                }
            }
            increment();
        },
        profileColor2: function() {
            return this.chartJSON[this.currentChartIndex] && this.chartJSON[this.currentChartIndex].distance >= 0 && this.chartJSON[this.currentChartIndex].distance <= 2 ? '#73af25cc' : this.chartJSON[this.currentChartIndex] && this.chartJSON[this.currentChartIndex].distance && this.chartJSON[this.currentChartIndex].distance <= 3 ? '#efa90be8' : this.chartJSON[this.currentChartIndex] && this.chartJSON[this.currentChartIndex].distance && this.chartJSON[this.currentChartIndex].distance <= 5 ? '#de3705cc' : '#3e3e3ecc'
        },
        profileColor: function() {
            let color = this.chartJSON[this.currentChartIndex] && this.chartJSON[this.currentChartIndex].distance >= 0 && this.chartJSON[this.currentChartIndex].distance <= 2 ? '#73af25cc' : this.chartJSON[this.currentChartIndex] && this.chartJSON[this.currentChartIndex].distance && this.chartJSON[this.currentChartIndex].distance <= 3 ? '#efa90be8' : this.chartJSON[this.currentChartIndex] && this.chartJSON[this.currentChartIndex].distance && this.chartJSON[this.currentChartIndex].distance <= 5 ? '#de3705cc' : '#3e3e3ecc'
            return color;
        },
        subMonte(subId, eta) {
            const w = this;
            w.subheatmaps = []
            let customsamples = false;
            this.progress = 0;
            //this.$Progress.set(0)
            var subscription;
            w.showProgress(eta);

            function endSubscription() {
                console.log('ending subscription...');
                w.progress = 100;
                //w.$Progress.finish()
                subscription.unsubscribe();
                subscription = false;
                if (w.errorArray.length > 0) {
                    var errMessage = ''
                    w.errorArray.forEach(error => {
                        errMessage = errMessage + error + '<br>';
                    })
                    w.$eventBus.$emit('appEvents', {
                        exec: 'show',
                        component: 'nav',
                        params: {
                            title: 'Error',
                            text: errMessage,
                            class: 'failure'
                        }
                    })
                }
                if (w.switches.optimaFit) {
                    var switches = {
                        ...w.switches
                    }
                    switches.optimaFit = false;
                    w.$store.commit('change', {
                        switches: switches
                    })
                    var name = w.user.username + ':switches'
                    localStorage.setItem(name, JSON.stringify(switches));
                }
                if (w.subResults.length === 1 || w.switches.optimaFit) {
                    var obj = w.subResults[0].result
                    var keys = w.subResults.length === 1 ? Object.keys(w.subResults[0].result) : w.components
                } else {
                    var sortKey = w.components[0]
                    var val = 0;
                    var index = 0;
                    var compindex = 0;
                    var profile = false;
                    let newComp = {}
                    w.subResults.forEach((sample, i) => {
                        w.components.forEach((comp, n) => {
                            comp = comp.split(' • ').length > 1 ? comp.split(' • ')[0].split('|')[0] + ' • ' + comp.split(' • ')[1] : comp.split('|')[0]
                            //if (sample.result[comp]) newComp[comp] = true
                            newComp[comp] = true
                            if (sample.result[comp] >= val) {
                                sortKey = comp;
                                val = sample.result[comp]
                                profile = sample.profile
                                index = i
                                compindex = n
                            }
                        })
                        let index = w.sampleArray.find(x => x.index == sample.profile)

                        if (index && index.alias) sample.alias = index.alias
                    })
                    try {
                        var obj = w.subResults[index].result
                    } catch (err) {
                        w.spinner = false;
                        throw err
                    }
                    //var keys = w.components
                    var keys = Object.keys(newComp);
                }
                keys.sort(function(a, b) {
                    var x = obj[a] ? obj[a] : 0;
                    var y = obj[b] ? obj[b] : 0;
                    return ((x < y) ? 1 : ((x > y) ? -1 : 0))
                })
                w.components = keys
                w.$store.commit('change', {
                    geo: w.subResults[0].geo
                })
                w.$store.commit('change', {
                    g25chartJSON: w.subResults
                })
                w.$store.commit('change', {
                    spinner: false
                })
                if (w.subheatmaps.length > 0) {
                    w.$store.commit('change', {
                        g25heatmapJSON: w.subheatmaps
                    })
                }
                w.processJSON(w.components[0]);
                w.progress = 0;
            }
            const observable = this.$apollo.subscribe({
                query: onPublishResultSub,
                variables: {
                    id: subId
                }
            });
            var checkSub = function() {
                if (subscription !== false) {
                    endSubscription()
                    var status = `${new Date().toLocaleString()}: Query ${subId} did not complete ${w.reqnum} subqueries/${w.sampleArray.length} within 15 seconds of first subquery`
                    console.log(status);
                    w.$eventBus.$emit('appEvents', {
                        exec: 'setError',
                        component: 'nav',
                        params: status
                    })
                    //w.$sentry.configureScope(scope => { scope.setTag("errorType", "incompleteResults"); });
                    //w.$sentry.captureException(new Error(`${new Date().toLocaleString()}: Query ${subId} did not complete ${w.reqnum} subqueries/${w.sampleArray.length} within 15 seconds of first subquery`))
                } else {
                    var filterMsg = w.filterResults && w.filterResults.filtered && w.filterResults.filtered > 0 ? ` >> filtered: ${w.filterResults.filtered} outliers/${w.filterResults.quantity} samples` : ''
                    var status = `${new Date().toLocaleString()}: Subscription for query ${subId} ended in ${Math.round((Date.now() - w.start) / 1000)} seconds with no incomplete subqueries/${w.sampleArray.length}` + filterMsg
                    console.log(status);
                    w.$store.commit('change', {
                        lastQuery: status
                    })
                }
            }
            var subTimer;
            w.errorArray = []
            var noresultTimer = setTimeout(function() {
                checkSub();
                clearTimeout(subTimer);
            }, eta + 15000)
            const realtimeResults = function realtimeResults(data) {
                w.reqnum = w.reqnum - 1
                try {
                    var result = JSON.parse(data.data.onPublishResult.result)
                    if (result && !result.error) {
                        w.previousQueryTimeStamp = w.queryTimeStamp
                        if (w.subResults.length === 0) {
                            subTimer = setTimeout(function() {
                                checkSub();
                            }, 15000)
                        }
                        if (w.switches.groupAveraged) {
                            var newresult = {}
                            Object.keys(result.result).forEach(comp => {
                                newresult[comp + ' (AVG)'] = result.result[comp];
                            })
                            result.result = newresult;
                        }
                        if (w.switches.groupMedian) {
                            var newresult = {}
                            Object.keys(result.result).forEach(comp => {
                                newresult[comp + ' (MED)'] = result.result[comp];
                            })
                            result.result = newresult;
                        }
                        let output = result
                        let nearest = output.nearest ? output.nearest : []
                        let sample = output.profile
                        let nearestGroups = {}
                        let heatmap = {
                            group: sample.split(':')[0],
                            name: sample.split(':').length > 1 ? sample.split(':')[1] : sample.split(':')[0],
                            data: []
                        }
                        let max = 0;
                        let profile = output.profile
                        nearest.map((x, i) => {
                            if (!nearestGroups[x._row.split(':')[0]]) {
                                max = x.distance > max ? x.distance : max;
                                nearestGroups[x._row.split(':')[0]] = true
                                heatmap.data.push({
                                    x: x._row.split(' • ').length > 1 ? x._row.split(' • ')[0].replace(/_/g, " ") + '[' + x._row.split(' • ')[1] + ']' : x._row.split(':')[0].replace(/_/g, " "),
                                    y: x.distance,
                                    distance: x.distance,
                                    sample: x._row.split(' • ').length > 10 && (averaged || median) ? x._row + (averaged ? ' (AVG)' : ' (MED)') : x._row,
                                    profile: profile
                                })
                            }
                        })
                        let length = heatmap.data.length
                        let similar = false;
                        let sum = 0;
                        heatmap.data = heatmap.data.map((x, i) => {
                            x.y = i === 0 ? 2 * length : i === length - 1 ? (length + 1) - i + 0.5 : (length + 1) - i;
                            sum = sum + x.y;
                            if (x.y === 2 * length) similar = {
                                group: x.x,
                                distance: x.distance,
                                profile: x.profile
                            }
                            return x
                        })
                        heatmap.sum = sum;
                        if (heatmap.data.length > 0) {
                            heatmap.data.sort((a, b) => a.x > b.x ? 1 : a.x < b.x ? -1 : 0)
                            w.subheatmaps.push(heatmap);
                        }
                        result.heatmap = heatmap;
                        result.similar = similar
                        w.subResults.push(result)
                    } else {
                        w.errorArray.push(result.error.error)
                    }
                    w.filterResults = {
                        quantity: result.quantity,
                        filtered: result.filtered
                    }
                } catch (e) {
                    w.errorArray.push(e)
                    console.log(e, 'No data received for ' + subId)
                }
                if (w.reqnum == 0) {
                    var filterMsg = w.filterResults && w.filterResults.filtered && w.filterResults.filtered > 0 ? ` filtered: ${w.filterResults.filtered}/${w.filterResults.quantity} outliers` : ''
                    console.log('Query completed in ' + Math.round((Date.now() - w.start) / 1000) + ' seconds' + filterMsg);
                    endSubscription();
                    checkSub();
                    clearTimeout(subTimer);
                    clearTimeout(noresultTimer);
                }
            }
            subscription = observable.subscribe({
                next: realtimeResults,
                complete: console.log,
                connect: function(evt) {
                    console.log('connected ', evt)
                },
                error: function(error) {
                    console.log('subscription error', error)
                }
            })

        },
        refreshCache(cache) {
            let currentDT = Math.floor(Date.now() / 1000)
            if (typeof(cache) !== 'undefined' && cache.tos) localStorage.setItem('cacheVer', JSON.stringify(cache));
            cache = typeof(cache) !== 'undefined' && cache.tos ? cache : localStorage.getItem('cacheVer') ? JSON.parse(localStorage.getItem('cacheVer')) : {
                groups: {
                    g25: currentDT
                },
                samples: currentDT,
                tos: 0,
                calcVersion: currentDT
            }
            var UTF8to16 = function(convertMe) {
                var out = "";
                for (var i = 0; i < convertMe.length; i += 2) {
                    var charCode = convertMe.charCodeAt(i) * 256;
                    charCode += convertMe.charCodeAt(i + 1);
                    out += String.fromCharCode(charCode);
                }
                return out;
            }
            var queryParam = '?v=0.'
            var stage = this.$store.getters.get('env') === 'production' ? '' : 'staging/';
            this.$dbCache.getCalculators(cache, 'g25', stage).then(str => {
                this.publicCalcs = str
            })

            this.$dbCache.getG25Groups(cache, 'g25', stage).then(str => {
                this.publicGroups = str
            })
            this.$dbCache.getSampleGroups(cache, 'g25', stage).then(str => {
                let customGroups = []
                str.forEach(x => {
                    let indexes = []
                    x.samples.map((sample, i) => {
                        x.originalGroup = sample.group
                        if (sample.alias) {
                            x.group = sample.alias
                            x.alias = sample.alias
                        }
                        if (sample.customgroup) {
                            indexes.push(i)
                            let customIndex = customGroups.findIndex(x => x.group == sample.customgroup + ' [' + sample.group + ']');
                            if (customIndex >= 0) {
                                customGroups[customIndex].samples.push(sample)
                            } else {
                                customGroups.push({
                                    group: sample.customgroup + ' [' + sample.group + ']',
                                    label: sample.customgroup + ' [' + sample.group + ']',
                                    type: sample.mode,
                                    samples: [sample]
                                })
                            }
                        }
                    })
                    if (indexes.length > 0) {
                        x.samples = x.samples.filter((value, index) => indexes.indexOf(index) == -1)
                    }
                })
                this.customGroups = customGroups
                this.publicSamples = str;
            })
            this.$dbCache.getRawGroupsCache(cache, 'g25', stage).then(str => {
                this.publicRawGroups = str;
            })
            this.$dbCache.getRawGroupedSamplesCache(cache, 'g25', stage).then(str => {
                this.publicRawSamples = str;
            })
            this.$dbCache.getAll(cache, 'from g25', stage, ['getRawGroupedSamplesCache', 'getRawGroupsCache', 'getSampleGroups', 'getG25Groups', 'getCalculators'])
        },
        startPGS() {
            this.$Progress.start()
        },
        setPGS(num) {
            this.$Progress.set(num)
        },
        increasePGS(num) {
            this.$Progress.increase(num)
        },
        decreasePGS(num) {
            this.$Progress.decrease(num)
        },
        finishPGS() {
            this.$Progress.finish()
        },
        failPGS() {
            this.$Progress.fail()
        },
        testPGS() {
            this.$Progress.start()

            this.$http.jsonp('http://api.rottentomatoes.com/api/public/v1.0/lists/movies/in_theaters.json?apikey=7waqfqbprs7pajbz28mqf6vz')
                .then((response) => {
                    this.$Progress.finish()
                }, (response) => {
                    this.$Progress.fail()
                })
        },
        copyNearestTableBB() {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.distance = 'Distance'
            var nearest = this.optimaEnabled ? this.chartJSON[this.currentChartIndex].nearest : this.chartJSON[this.currentChartIndex].nearest.splice(0, 5);
            var tabledata = []
            nearest.forEach(sample => {
                var obj = {};
                obj.sample = sample._row;
                obj.distance = sample.distance;
                tabledata.push(obj)
            })
            var copyhtml = new Table().setHeaders(headers).setData(tabledata).render()
            copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
            var replace = new RegExp(' class=.*?]', 'g')
            copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']').replace(/:/g, " ► ")
            copyhtml = `[size=1]${copyhtml}[/size]`
            copy(copyhtml, {
                asHtml: false,
            });
        },
        copyNearestTable(type) {
            var headers = {}
            var w = this;
            headers.sample = 'Sample'
            headers.distance = 'Distance'
            var nearest = this.optimaEnabled ? this.chartJSON[this.currentChartIndex].nearest : this.chartJSON[this.currentChartIndex].nearest.splice(0, 5);
            var tabledata = []
            nearest.forEach(sample => {
                var obj = {};
                obj.sample = sample._row;
                obj.distance = sample.distance;
                tabledata.push(obj)
            })
            var copyhtml = new Table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            copyhtml = juice.inlineContent(copyhtml, tablecss)
            let copytext = this.$yaml.stringify(tabledata, 2).replace(/-\n/g, '\n').replace(/'/g, '')
            if (type === 'text') {
                copy(copytext, {
                    asHtml: false,
                });
            } else {
                copy(copyhtml, {
                    asHtml: true,
                });
            }
        },
        clipNearest: function() {
            var nearest = this.optimaEnabled ? this.chartJSON[this.currentChartIndex].nearest : this.chartJSON[this.currentChartIndex].nearest.splice(0, 5);
            let data = []
            nearest.forEach(sample => {
                let obj = {};
                obj.sample = {
                    ...sample
                }.sample ? {
                    ...sample
                }.sample : {
                    ...sample
                }._row;
                obj.distance = {
                    ...sample
                }.distance
                data.push(obj);
            })
            let prettyJSON = JSON.stringify(data, null, 2);
            copy(prettyJSON, {
                asHtml: false,
            });
        },
        getInitialColorMode(value) {
            const persistedColorPreference = value == 'system' ? false : value
            const hasPersistedPreference = typeof persistedColorPreference === 'string';
            if (hasPersistedPreference) {
                this.setColors(persistedColorPreference)
                return persistedColorPreference;
            }
            const mql = window.matchMedia('(prefers-color-scheme: dark)');
            const hasMediaQueryPreference = typeof mql.matches === 'boolean';
            if (hasMediaQueryPreference) {
                this.setColors(mql.matches ? 'dark' : 'light')
                return mql.matches ? 'dark' : 'light';
            }
            this.setColors('light')
            return 'light';
        },
        setColors(value) {
            if (value == 'dark') {
                document.documentElement.style.setProperty('--bg-color', '#181818');
                document.documentElement.style.setProperty('--color', '#dfdfdf');
            } else {
                document.documentElement.style.setProperty('--bg-color', '#f2f2f2');
                document.documentElement.style.setProperty('--color', '#444444');
            }
        },
        toggleTheme() {
            this.currentShare = false;
            let value = this.slider.theme && this.slider.theme.value && typeof(this.slider.theme.value) == 'string' ? this.slider.theme.value.toLowerCase() : 'system'
            this.syncStore('slider.theme.' + value)
            let genoTheme = this.getInitialColorMode(value)
            console.log('setting theme', value, genoTheme);
            localStorage.setItem("genoTheme", genoTheme);
            let wn = document.getElementById('discussionframe');
            if (wn && wn.contentWindow) {
                wn = wn.contentWindow
                if (value == 'system') {
                    wn.postMessage({
                        action: 'removeStorage',
                        content: {
                            key: 'genoTheme'
                        },
                        source: 'genoplot.com'
                    }, '*')
                } else {
                    wn.postMessage({
                        action: 'setStorage',
                        content: {
                            key: 'genoTheme',
                            value: genoTheme
                        },
                        source: 'genoplot.com'
                    }, '*')
                }
            }
            const el = document.body;
            let sunOptions = this.sunOptions;
            let heatmapColors = this.heatmapColors;
            let levels = sunOptions.series.levels;
            if (el.classList.contains('dark') && genoTheme != 'dark') {
                el.classList.remove('dark')
                levels[2].label.color = '#444'
                levels[3].label.color = '#444'
                this.theme = false
                this.map.tooltip.backgroundColor = '#fff'
                this.map.tooltip.textStyle = {
                    color: 'gray'
                }
                this.map.visualMap.inRange.color = ['#1c425f88', '#1c425f88', '#1c425f88', '#1c425f88', '#1c425f88']
                this.map.geo.itemStyle = {
                    normal: {
                        areaColor: '#2c526f99',
                        borderColor: '#fff',
                    },
                    emphasis: {
                        areaColor: '#2c526f',
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        shadowBlur: 20,
                        borderWidth: 2,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            } else if (genoTheme == 'dark') {
                el.classList.add('dark')
                levels[2].label.color = '#f2f2f2'
                levels[3].label.color = 'white'
                this.theme = true
                this.map.visualMap.inRange.color = ["rgb(50, 60, 72)", "rgb(50, 60, 72)", "rgb(50, 60, 72)", "rgb(50, 60, 72)", "rgb(50, 60, 72)"]
                this.map.tooltip.backgroundColor = '#000000bb'
                this.map.tooltip.textStyle = {
                    color: 'white'
                }
                this.map.geo.itemStyle = {
                    normal: {
                        areaColor: '#323c48',
                        borderColor: 'silver'
                    },
                    emphasis: {
                        areaColor: 'gray',
                        areaColor: '#729bb5',
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        shadowBlur: 20,
                        borderWidth: 2,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
            this.sunOptions = sunOptions;
        },
        getXLS: () => {
            return new Promise((resolve, reject) => {
                if (!window.XLSX) {
                    let script = document.createElement('script')
                    script.onload = () => {
                        resolve(true)
                    }
                    script.async = true
                    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.15.2/xlsx.core.min.js'
                    document.head.appendChild(script)
                } else {
                    resolve(true)
                }
            })
        }
    },
}

function tokenize(inputStr) {
    const regex = /"([^"]+)"|'([^']+)'|(\S+)/g;
    const tokens = [];
    let match;
    while ((match = regex.exec(inputStr)) !== null) {
        if (match[1]) {
            tokens.push(match[1]);
        } else if (match[2]) {
            tokens.push(match[2]);
        } else if (match[3]) {
            tokens.push(match[3]);
        }
    }
    return tokens;
}

function parseConditions(tokens, defaultField) {
    const conditions = [];
    let currentOperator = 'OR'; // Default operator in uppercase
    tokens.forEach(token => {
        const lower = token.toLowerCase();
        if (lower === 'and' || lower === 'or') {
            currentOperator = lower.toUpperCase();
        } else {
            const parts = token.split(':');
            let field, value;
            if (parts.length === 3) {
                field = parts[0].toLowerCase();
                value = parts[1].toLowerCase();
            } else {
                field = defaultField.toLowerCase();
                value = token.toLowerCase();
            }
            conditions.push({
                field,
                value,
                operator: currentOperator
            });
            currentOperator = 'OR'; // Reset to default
        }
    });

    return conditions;
}

function getFieldValue(obj, field) {
    const fields = field.split('.');
    let value = obj;
    for (const f of fields) {
        if (value[f] === undefined || value[f] === null) {
            return '';
        }
        value = value[f];
    }
    return typeof value === 'string' ? value : String(value);
}

function buildFilterFunction(conditions) {
    return function(item) {
        let result = (conditions[0].operator === 'AND') ? true : false;

        conditions.forEach(cond => {
            const fieldValue = getFieldValue(item, cond.field).toLowerCase();
            const conditionMet1 = fieldValue == cond.value;
            const conditionMet2 = fieldValue.includes(cond.value);

            if (cond.operator === 'AND') {
                result = (result && conditionMet1 || result && conditionMet2)
            } else if (cond.operator === 'OR') {
                result = (result || conditionMet1 || conditionMet2);
            }
        });

        return result;
    };
}

function generateFilterString(conditions) {
    const filterConditions = conditions.map(cond => {
        return `item.${cond.field}.toLowerCase().includes('${cond.value}')`;
    });

    let filterString = 'const result = data.filter(item => ';

    filterConditions.forEach((cond, index) => {
        if (index === 0) {
            filterString += cond;
        } else {
            const operator = conditions[index].operator;
            filterString += ` ${operator} ${cond}`;
        }
    });

    filterString += ');';

    return filterString;
}

function filterNestedData(data, filterFunc, nestedArrayKey) {
    //console.log(data[0]);
    return data.reduce((acc, item) => {
        if (Array.isArray(item[nestedArrayKey])) {
            const filteredNested = item[nestedArrayKey].filter(filterFunc);
            if (filteredNested.length > 0) {
                acc.push({
                    ...item,
                    [nestedArrayKey]: filteredNested
                });
            }
        }
        // console.log(acc[0])
        return acc;
    }, []);
}

function filterData(inputStr, data, defaultField = 'refs', nestedArrayKey = 'samples') {
    //console.log('data', data);
    if (!Array.isArray(data) || data.length === 0 || !inputStr || inputStr < 4) return {
        filteredData: data,
        filterString: ''
    };
    const tokens = tokenize(inputStr);
    const conditions = parseConditions(tokens, defaultField);
    const filterString = generateFilterString(conditions);
    const filterFunc = buildFilterFunction(conditions);

    const firstItem = data[0];
    const isNested = nestedArrayKey && firstItem.hasOwnProperty(nestedArrayKey) && Array.isArray(firstItem[nestedArrayKey]);

    let filteredData;
    if (isNested) {
        filteredData = filterNestedData(data, filterFunc, nestedArrayKey);
    } else {
        filteredData = data.filter(filterFunc);
    }

    return {
        filteredData,
        filterString
    };
}
